
// Global maps to store metafields by variant ID and product handle
const firmnessMetafieldsMap = new Map(); // Map<variantId, {text1, text2, text3}>
const foundationMetafieldsMap = new Map(); // Map<variantId, {metafield1, metafield2, metafield3}>
const foundationMetafieldsByProduct = new Map(); // Map<productHandle, Map<variantId, metafields>>
const variantInfoMetafieldsMap = new Map(); // Map<variantId, {title, short, long, feature}>
const variantImageFeaturesMap = new Map(); // Map<variantId, {image, heading, description}>
const variantGalleryImagesMap = new Map(); // Map<variantId, string[] | { en: string[], es: string[] }>
const variantTechnicalSpecsMap = new Map(); // Map<variantId, {titles, features}>
const variantPerformanceDataMap = new Map(); // Map<variantId, [{performance_heading, performance_heading_value, performance_progress, performance_text}, ...]>
const collectionProductCache = new Map(); // Map<productHandle, productData>

function suaveT(key, fallback) {
  var i18n = (typeof window !== 'undefined' && window.__SUAVE_I18N__) || {};
  var value = i18n[key];
  return value != null && value !== '' ? value : (fallback != null ? fallback : key);
}

function suaveTWithFoundation(foundation) {
  var template = suaveT('withFoundation', 'with {{ foundation }}');
  return template.replace(/\{\{\s*foundation\s*\}\}/g, foundation);
}

function suavePdpT(key, fallback) {
  return suaveT(key, fallback);
}

function suavePdpRootUrl() {
  var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
  return String(store.rootUrl || '/').replace(/\/?$/, '/');
}

function suavePdpProductJsonUrl(handle) {
  return suavePdpRootUrl() + 'products/' + encodeURIComponent(handle) + '.js';
}

function suavePdpProductViewUrl(handle, view) {
  return suavePdpRootUrl() + 'products/' + encodeURIComponent(handle) + '?view=' + encodeURIComponent(view);
}

function suavePdpNoFoundationLabel() {
  const cfg = window.__PDP_UNDERBED_CONFIG__ || {};
  return (cfg.noFoundationLabel && String(cfg.noFoundationLabel).trim()) || suavePdpT('noFoundation', 'No Foundation');
}

// Helper function to parse rich text JSON and extract text content
function parseRichTextToText(richTextJson) {
  if (!richTextJson) return '';
  
  // If it's already a string, try to parse it
  let parsed;
  if (typeof richTextJson === 'string') {
    // Check if it's Ruby hash format (contains =>)
    if (richTextJson.includes('=>')) {
      // Convert Ruby hash syntax to JSON
      // Replace => with : and handle quotes
      let jsonString = richTextJson
        .replace(/=>/g, ':')
        .replace(/(\w+):/g, '"$1":')  // Add quotes to keys
        .replace(/:\s*"([^"]+)"/g, ': "$1"')  // Ensure values are quoted
        .replace(/:\s*(\d+)/g, ': $1')  // Keep numbers unquoted
        .replace(/:\s*(true|false|null)/g, ': $1');  // Keep booleans/null unquoted
      
      try {
        parsed = JSON.parse(jsonString);
      } catch (e) {
        // If conversion fails, try direct JSON parse
        try {
          parsed = JSON.parse(richTextJson);
        } catch (e2) {
          // If both fail, return as is
          return richTextJson;
        }
      }
    } else {
      // Regular JSON string
      try {
        parsed = JSON.parse(richTextJson);
      } catch (e) {
        // If parsing fails, return as is (might be plain text)
        return richTextJson;
      }
    }
  } else {
    parsed = richTextJson;
  }
  
  // If it's not an object, return as string
  if (typeof parsed !== 'object' || parsed === null) {
    return String(richTextJson);
  }
  
  // Extract text from rich text structure
  function extractText(node) {
    if (!node) return '';
    
    if (node.type === 'text' && node.value) {
      return node.value;
    }
    
    if (node.type === 'list-item' && node.children) {
      const items = node.children.map(extractText).filter(Boolean);
      return items.join(' ');
    }
    
    if (node.children && Array.isArray(node.children)) {
      const texts = node.children.map(extractText).filter(Boolean);
      return texts.join(' ');
    }
    
    return '';
  }
  
  // Extract all list items
  const listItems = [];
  
  function extractListItems(node) {
    if (!node) return;
    
    if (node.type === 'list-item' && node.children) {
      const text = node.children.map(extractText).filter(Boolean).join(' ');
      if (text) {
        listItems.push(text);
      }
    }
    
    if (node.children && Array.isArray(node.children)) {
      node.children.forEach(extractListItems);
    }
  }
  
  // Start extraction from root
  if (parsed.type === 'root' && parsed.children) {
    parsed.children.forEach(extractListItems);
  } else {
    extractListItems(parsed);
  }
  
  // Return formatted list (use newlines so firmness-feature-text / meta description can show as bullets and preserve structure)
  if (listItems.length > 0) {
    return listItems.join('\n');
  }
  
  // Fallback: try to extract any text; preserve block breaks by joining block-level children with newline
  function extractTextWithBreaks(node) {
    if (!node) return '';
    if (node.type === 'text' && node.value) return node.value;
    if (node.children && Array.isArray(node.children)) {
      var sep = (node.type === 'paragraph' || node.type === 'list-item' || node.type === 'block') ? '\n' : ' ';
      return node.children.map(extractTextWithBreaks).filter(Boolean).join(sep);
    }
    return '';
  }
  const fallbackText = extractTextWithBreaks(parsed);
  return fallbackText || String(richTextJson);
}

  // Helper function to load variant info data for a specific product handle
  function loadVariantInfoForProduct(productHandle) {
    if (!productHandle) return;
    
    // Find script tag by class and data-product-handle attribute
    const variantInfoScripts = document.querySelectorAll('.variant-info-json');
    
    if (variantInfoScripts && variantInfoScripts.length > 0) {
      // Find script tag matching product handle
      for (let script of variantInfoScripts) {
        if (script.getAttribute('data-product-handle') === productHandle) {
          try {
            const variantInfoData = JSON.parse(script.textContent);
            
            // Parse variant info metafields from JSON (metaobject: title, short, long, feature)
            if (variantInfoData && variantInfoData.variants && Array.isArray(variantInfoData.variants)) {
              variantInfoData.variants.forEach((variantInfo, idx) => {
                if (variantInfo && variantInfo.variantId) {
                  const variantId = variantInfo.variantId.toString();
                  
                  // Helper function to process field values
                  const processField = (fieldValue) => {
                    if (fieldValue === null || fieldValue === undefined || fieldValue === 'null' || fieldValue === 'undefined') {
                      return null;
                    }
                    
                    const str = String(fieldValue).trim();
                    if (str === '' || str === 'null' || str === 'undefined') {
                      return null;
                    }
                    
                    return str;
                  };
                  
                  // For feature, keep as object if it's already an object (rich text JSON)
                  let featureValue = variantInfo.feature;
                  if (featureValue !== null && featureValue !== undefined && featureValue !== 'null' && featureValue !== 'undefined') {
                    // If it's already an object, keep it as is
                    if (typeof featureValue === 'object') {
                      // Already an object, use as is
                    } else if (typeof featureValue === 'string' && featureValue.trim() !== '') {
                      // Try to parse if it's a JSON string
                      try {
                        featureValue = JSON.parse(featureValue);
                      } catch (e) {
                        // If parsing fails, keep as string
                      }
                    } else {
                      featureValue = null;
                    }
                  } else {
                    featureValue = null;
                  }
                  
                  // firmness_feature_text: variant-specific metafield for firmness card
                  let firmnessFeatureValue = variantInfo.firmness_feature_text;
                  if (firmnessFeatureValue !== null && firmnessFeatureValue !== undefined && firmnessFeatureValue !== 'null' && firmnessFeatureValue !== 'undefined') {
                    if (typeof firmnessFeatureValue === 'object') {
                      // keep as is
                    } else if (typeof firmnessFeatureValue === 'string' && firmnessFeatureValue.trim() !== '') {
                      try {
                        firmnessFeatureValue = JSON.parse(firmnessFeatureValue);
                      } catch (e) {
                        // keep as string
                      }
                    } else {
                      firmnessFeatureValue = null;
                    }
                  } else {
                    firmnessFeatureValue = null;
                  }
                  
                  const variantInfoObj = {
                    title: processField(variantInfo.title),
                    short: processField(variantInfo.short),
                    long: processField(variantInfo.long),
                    feature: featureValue,
                    firmness_feature_text: firmnessFeatureValue
                  };
                  
                  // Always store, even if some fields are empty
                  variantInfoMetafieldsMap.set(variantId, variantInfoObj);
                }
              });
            }
            return; // Found and processed, exit
          } catch (e) {
            console.log('error loading variant info: ', e);
          }
        }
      }
    }
  }

  // Function to initialize metafields from data attributes
function initializeMetafieldsFromDataAttributes() {
  // Get all mattress product tabs
  const tabs = document.querySelectorAll('#custom-product-container .tab[data-variant-metafields]');
  // Also check for tabs without the attribute
  const allTabs = document.querySelectorAll('#custom-product-container .tab');
  
  tabs.forEach((tab, tabIndex) => {
    const productHandle = tab.getAttribute('data-product-handle');
    const variantMetafieldsData = tab.getAttribute('data-variant-metafields');
    const foundationMetafieldsData = tab.getAttribute('data-foundation-variant-metafields');
    const variantImageFeaturesData = tab.getAttribute('data-variant-image-features');
    const variantGalleryImagesData = tab.getAttribute('data-variant-gallery-images');
    
    // Debug the structure by showing what's between each ||
    if (foundationMetafieldsData && foundationMetafieldsData.trim() !== '') {
      const entries = foundationMetafieldsData.split('||');
      entries.forEach((entry, i) => {
        const parts = entry.split(':');
      });
    }
    // Parse firmness metafields
    if (variantMetafieldsData && variantMetafieldsData.trim() !== '') {
      const variantMetafields = variantMetafieldsData.split('||').filter(v => v && v.trim() !== '');
      
      variantMetafields.forEach((variantData, idx) => {
        if (variantData && variantData.trim() !== '') {
          // Firmness format: variantId:field1|field2|field3 (3 fields separated by |)
          const parts = variantData.split(':');
          
          if (parts.length >= 2) {
            const variantId = parts[0].trim();
            const metafields = parts.slice(1).join(':'); // Join in case any field contains ':'
            const fields = metafields.split('|');
            
            // Helper function to decode HTML entities (for rich text metafields)
            // Data attributes automatically escape HTML, so we need to decode them
            const decodeHtml = (html) => {
              if (!html) return null;
              const htmlStr = html.trim();
              if (htmlStr === '' || htmlStr === 'null' || htmlStr === 'undefined') return null;
              
              // Create a temporary element to decode HTML entities
              const txt = document.createElement('textarea');
              txt.innerHTML = htmlStr;
              const decoded = txt.value;
              
              // If decoded value is different, it means there were HTML entities
              // Otherwise, return original (might already be plain text)
              return decoded !== htmlStr ? decoded : htmlStr;
            };
            
            // Store metafields even if some are empty - we'll check individual fields when displaying
            const metafieldObj = {
              firmness_variant_option_text: decodeHtml(fields[0]),
              firmness_variant_option_text_2: decodeHtml(fields[1]),
              firmness_variant_option_text_3: decodeHtml(fields[2])
            };
            
            // Store with variant ID as string (to match lookup) - store even if all are empty for debugging
            firmnessMetafieldsMap.set(variantId, metafieldObj);
            
            // Check if at least one metafield has data
            const hasAnyValue = metafieldObj.firmness_variant_option_text || 
                               metafieldObj.firmness_variant_option_text_2 || 
                               metafieldObj.firmness_variant_option_text_3;
          }
        }
      });
    }
    
    // Parse foundation metafields
    if (foundationMetafieldsData && foundationMetafieldsData.trim() !== '' && productHandle) {
      const variantMetafields = foundationMetafieldsData.split('||').filter(v => v && v.trim() !== '');
      const foundationMap = new Map();
      
      variantMetafields.forEach((variantData, dataIndex) => {
        if (variantData && variantData.trim() !== '') {
          // Foundation format: variantId:field1 (single field, no pipes)
          const parts = variantData.split(':');
          
          if (parts.length >= 2) {
            const variantId = parts[0].trim();
            const metafieldValue = parts.slice(1).join(':').trim(); // Join in case value contains ':'
            
            if (variantId) {
              // Store even if value is empty - we'll use it for mapping
              // The value might be empty, but we still need to map the variant to its position
              const metafieldObj = {
                value: (metafieldValue && metafieldValue !== '' && metafieldValue !== 'null' && metafieldValue !== 'undefined') ? metafieldValue : null,
                position: dataIndex,   // Position in the data (0, 1, 2, ...)
                foundation_product_variant_metafield: (dataIndex === 0) ? ((metafieldValue && metafieldValue !== '' && metafieldValue !== 'null') ? metafieldValue : null) : null,
                foundation_product_variant_metafield_2: (dataIndex === 1) ? ((metafieldValue && metafieldValue !== '' && metafieldValue !== 'null') ? metafieldValue : null) : null,
                foundation_product_variant_metafield_3: (dataIndex === 2) ? ((metafieldValue && metafieldValue !== '' && metafieldValue !== 'null') ? metafieldValue : null) : null
              };
              
              // Store with variant ID as string (to match lookup) - store even if value is empty for mapping
              foundationMap.set(variantId, metafieldObj);
              
              if (metafieldObj.value) {
                const metafieldName = dataIndex === 0 ? 'metafield1' : (dataIndex === 1 ? 'metafield2' : 'metafield3');
              }
            } 
          }
        }
      });
      
      foundationMetafieldsByProduct.set(productHandle, foundationMap);
    }
    
    // Parse variant image and features metafields
    if (variantImageFeaturesData && variantImageFeaturesData.trim() !== '') {
      const variantImageFeatures = variantImageFeaturesData.split('||').filter(v => v && v.trim() !== '');
      
      variantImageFeatures.forEach((variantData) => {
        if (variantData && variantData.trim() !== '') {
          const parts = variantData.split(':');
          
          if (parts.length >= 2) {
            const variantId = parts[0].trim();
            const metafieldJson = parts.slice(1).join(':').trim(); // Join in case JSON contains ':'
            
            if (variantId && metafieldJson && metafieldJson !== '' && metafieldJson !== 'null' && metafieldJson !== 'undefined') {
              try {
                // Decode HTML entities before parsing
                const decodedJson = metafieldJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
                const parsedData = JSON.parse(decodedJson);
                // Store with both string and number variant ID for flexibility
                variantImageFeaturesMap.set(variantId, parsedData);
                const variantIdNum = parseInt(variantId);
                if (!isNaN(variantIdNum)) {
                  variantImageFeaturesMap.set(variantIdNum.toString(), parsedData);
                  variantImageFeaturesMap.set(String(variantIdNum), parsedData);
                }
              } catch (e) {
                // Silent error - invalid JSON
              }
            }
          }
        }
      });
    }
    
    // Parse variant technical specifications metafields
    if (variantGalleryImagesData && variantGalleryImagesData.trim() !== '') {
      const variantGalleryEntries = variantGalleryImagesData.split('||').filter(v => v && v.trim() !== '');
      variantGalleryEntries.forEach((variantData) => {
        const sep = variantData.indexOf(':');
        if (sep < 1) return;
        const variantId = variantData.slice(0, sep).trim();
        const galleryJson = variantData.slice(sep + 1).trim();
        if (!variantId || !galleryJson) return;
        try {
          const decodedJson = galleryJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
          const parsed = JSON.parse(decodedJson);
          let galleryEntry = { en: [], es: [] };
          if (Array.isArray(parsed)) {
            galleryEntry = { en: parsed, es: parsed };
          } else if (parsed && typeof parsed === 'object') {
            galleryEntry = {
              en: Array.isArray(parsed.en) ? parsed.en : [],
              es: Array.isArray(parsed.es)
                ? parsed.es
                : (Array.isArray(parsed.en) ? parsed.en : [])
            };
          }
          const urls = galleryEntry.en;
          variantGalleryImagesMap.set(variantId, galleryEntry);
          const variantIdNum = parseInt(variantId, 10);
          if (!isNaN(variantIdNum)) {
            variantGalleryImagesMap.set(String(variantIdNum), galleryEntry);
          }
        } catch (e) {
          // Ignore malformed variant gallery payload
        }
      });
    }

    // Parse variant technical specifications metafields
    const variantTechnicalSpecsData = tab.getAttribute('data-variant-technical-specs');
    if (variantTechnicalSpecsData && variantTechnicalSpecsData.trim() !== '') {
      const variantTechnicalSpecs = variantTechnicalSpecsData.split('||').filter(v => v && v.trim() !== '');
      
      variantTechnicalSpecs.forEach((variantData) => {
        if (variantData && variantData.trim() !== '') {
          const parts = variantData.split(':');
          
          if (parts.length >= 2) {
            const variantId = parts[0].trim();
            const metafieldJson = parts.slice(1).join(':').trim(); // Join in case JSON contains ':'
            
            if (variantId && metafieldJson && metafieldJson !== '' && metafieldJson !== 'null' && metafieldJson !== 'undefined') {
              try {
                // Decode HTML entities before parsing
                const decodedJson = metafieldJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
                const parsedData = JSON.parse(decodedJson);
                // Metafield is list of metaobject: normalize to { titles: [], features: [] }
                let normalized = parsedData;
                if (Array.isArray(parsedData)) {
                  const titlesArr = parsedData.map(item => {
                    let t = item && (item.titles !== undefined ? item.titles : item.title);
                    if (t && typeof t === 'object' && t.value != null) t = t.value;
                    return t != null && t !== 'null' ? String(t).trim() : '';
                  });
                  const featuresArr = parsedData.map(item => {
                    let f = item && (item.features !== undefined ? item.features : item.feature);
                    if (f && typeof f === 'object' && f.value != null) f = f.value;
                    return f != null && f !== 'null' ? String(f).trim() : '';
                  });
                  normalized = { titles: titlesArr, features: featuresArr };
                }
                variantTechnicalSpecsMap.set(variantId, normalized);
                const variantIdNum = parseInt(variantId);
                if (!isNaN(variantIdNum)) {
                  variantTechnicalSpecsMap.set(variantIdNum.toString(), normalized);
                  variantTechnicalSpecsMap.set(String(variantIdNum), normalized);
                }
              } catch (e) {
                // Silent error - invalid JSON
              }
            }
          }
        }
      });
    }
    
    // Parse variant performance data metafields (list of metaobject: performance_heading, performance_heading_value, performance_progress, performance_text)
    const variantPerformanceDataAttr = tab.getAttribute('data-variant-performance-data');
    if (variantPerformanceDataAttr && variantPerformanceDataAttr.trim() !== '') {
      function safePerfStr(v) {
        if (v == null || v === undefined) return '';
        if (typeof v === 'object' && v !== null && 'value' in v) return safePerfStr(v.value);
        return String(v);
      }
      function safePerfNum(v) {
        if (v == null || v === undefined) return 0;
        if (typeof v === 'object' && v !== null && 'value' in v) return safePerfNum(v.value);
        const n = Number(v);
        return isNaN(n) ? 0 : Math.min(100, Math.max(0, n));
      }
      const variantPerformanceEntries = variantPerformanceDataAttr.split('||').filter(v => v && v.trim() !== '');
      variantPerformanceEntries.forEach((variantData) => {
        if (variantData && variantData.trim() !== '') {
          const parts = variantData.split(':');
          if (parts.length >= 2) {
            const variantId = parts[0].trim();
            const metafieldJson = parts.slice(1).join(':').trim();
            if (variantId && metafieldJson && metafieldJson !== '' && metafieldJson !== 'null' && metafieldJson !== 'undefined') {
              try {
                const decodedJson = metafieldJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
                const parsedData = JSON.parse(decodedJson);
                let normalized = [];
                if (Array.isArray(parsedData)) {
                  normalized = parsedData.map(item => {
                    return {
                      performance_heading: safePerfStr(item && item.performance_heading),
                      performance_heading_value: safePerfStr(item && item.performance_heading_value),
                      performance_progress: safePerfNum(item && item.performance_progress),
                      performance_text: safePerfStr(item && item.performance_text)
                    };
                  });
                } else if (parsedData && typeof parsedData === 'object') {
                  var prog = parsedData.performance_progress !== undefined && parsedData.performance_progress !== null ? parsedData.performance_progress : (parsedData.progress !== undefined && parsedData.progress !== null ? parsedData.progress : parsedData.progress_value);
                  normalized = [{
                    performance_heading: safePerfStr(parsedData.performance_heading),
                    performance_heading_value: safePerfStr(parsedData.performance_heading_value),
                    performance_progress: prog,
                    performance_text: safePerfStr(parsedData.performance_text)
                  }];
                }
                if (normalized.length > 0) {
                  // If data has comma-separated values in any field, split into one block per value (block 1 = first value, block 2 = second, etc.)
                  const hasCommaInAny = normalized.some(it => {
                    const h = (it.performance_heading || '').toString();
                    const hv = (it.performance_heading_value || '').toString();
                    const t = (it.performance_text || '').toString();
                    const pStr = (it.performance_progress != null ? it.performance_progress : '').toString();
                    return h.indexOf(',') !== -1 || hv.indexOf(',') !== -1 || t.indexOf(',') !== -1 || pStr.indexOf(',') !== -1;
                  });
                  if (hasCommaInAny) {
                    const expanded = [];
                    for (const item of normalized) {
                      const h = (item.performance_heading || '').toString();
                      const hv = (item.performance_heading_value || '').toString();
                      const t = (item.performance_text || '').toString();
                      const headings = h.split(',').map(s => s.trim());
                      const values = hv.split(',').map(s => s.trim());
                      const texts = t.split(',').map(s => s.trim());
                      let progressArr = [];
                      const pStr = (item.performance_progress != null ? item.performance_progress : '').toString();
                      if (pStr.indexOf(',') !== -1) {
                        progressArr = pStr.split(',').map(s => safePerfNum(s.trim()));
                      } else {
                        const singleProgress = safePerfNum(item.performance_progress);
                        const n = Math.max(headings.length, values.length, texts.length, 1);
                        progressArr = Array(n).fill(singleProgress);
                      }
                      const n = Math.max(headings.length, values.length, progressArr.length, texts.length, 1);
                      for (let i = 0; i < n; i++) {
                        expanded.push({
                          performance_heading: headings[i] || '',
                          performance_heading_value: values[i] || '',
                          performance_progress: progressArr[i] !== undefined ? progressArr[i] : 0,
                          performance_text: texts[i] || ''
                        });
                      }
                    }
                    normalized = expanded;
                  }
                }
                if (normalized.length > 0) {
                  variantPerformanceDataMap.set(variantId, normalized);
                  const variantIdNum = parseInt(variantId);
                  if (!isNaN(variantIdNum)) {
                    variantPerformanceDataMap.set(variantIdNum.toString(), normalized);
                    variantPerformanceDataMap.set(String(variantIdNum), normalized);
                  }
                }
              } catch (e) {
                // Silent - invalid JSON
              }
            }
          }
        }
      });
    }
  });

  document.querySelectorAll('.variant-info-json').forEach((script) => {
    const h = script.getAttribute('data-product-handle');
    if (h) loadVariantInfoForProduct(h);
  });

  // Parse variant performance data from ALL tabs (so default + variant change always have data)
  (function parsePerformanceDataFromAllTabs() {
    function safePerfStr(v) {
      if (v == null || v === undefined) return '';
      if (typeof v === 'object' && v !== null && 'value' in v) return safePerfStr(v.value);
      return String(v);
    }
    function safePerfNum(v) {
      if (v == null || v === undefined) return 0;
      if (typeof v === 'object' && v !== null && 'value' in v) return safePerfNum(v.value);
      const n = Number(v);
      return isNaN(n) ? 0 : Math.min(100, Math.max(0, n));
    }
    allTabs.forEach(function(tab) {
      const attr = tab.getAttribute('data-variant-performance-data');
      if (!attr || attr.trim() === '') return;
      const entries = attr.split('||').filter(function(v) { return v && v.trim() !== ''; });
      entries.forEach(function(variantData) {
        if (!variantData || variantData.trim() === '') return;
        const parts = variantData.split(':');
        if (parts.length < 2) return;
        const variantId = parts[0].trim();
        const metafieldJson = parts.slice(1).join(':').trim();
        if (!variantId || !metafieldJson || metafieldJson === '' || metafieldJson === 'null' || metafieldJson === 'undefined') return;
        try {
          const decodedJson = metafieldJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
          const parsedData = JSON.parse(decodedJson);
          let normalized = [];
          if (Array.isArray(parsedData)) {
            normalized = parsedData.map(function(item) {
              return {
                performance_heading: safePerfStr(item && item.performance_heading),
                performance_heading_value: safePerfStr(item && item.performance_heading_value),
                performance_progress: safePerfNum(item && item.performance_progress),
                performance_text: safePerfStr(item && item.performance_text)
              };
            });
          } else if (parsedData && typeof parsedData === 'object') {
            var prog = parsedData.performance_progress !== undefined && parsedData.performance_progress !== null ? parsedData.performance_progress : (parsedData.progress !== undefined && parsedData.progress !== null ? parsedData.progress : parsedData.progress_value);
            normalized = [{
              performance_heading: safePerfStr(parsedData.performance_heading),
              performance_heading_value: safePerfStr(parsedData.performance_heading_value),
              performance_progress: prog,
              performance_text: safePerfStr(parsedData.performance_text)
            }];
          }
          if (normalized.length > 0) {
            const hasCommaInAny = normalized.some(function(it) {
              const h = (it.performance_heading || '').toString();
              const hv = (it.performance_heading_value || '').toString();
              const t = (it.performance_text || '').toString();
              const pStr = (it.performance_progress != null ? it.performance_progress : '').toString();
              return h.indexOf(',') !== -1 || hv.indexOf(',') !== -1 || t.indexOf(',') !== -1 || pStr.indexOf(',') !== -1;
            });
            if (hasCommaInAny) {
              const expanded = [];
              for (var idx = 0; idx < normalized.length; idx++) {
                const item = normalized[idx];
                const h = (item.performance_heading || '').toString();
                const hv = (item.performance_heading_value || '').toString();
                const t = (item.performance_text || '').toString();
                const headings = h.split(',').map(function(s) { return s.trim(); });
                const values = hv.split(',').map(function(s) { return s.trim(); });
                const texts = t.split(',').map(function(s) { return s.trim(); });
                var progressArr = [];
                const pStr = (item.performance_progress != null ? item.performance_progress : '').toString();
                if (pStr.indexOf(',') !== -1) {
                  progressArr = pStr.split(',').map(function(s) { return safePerfNum(s.trim()); });
                } else {
                  const singleProgress = safePerfNum(item.performance_progress);
                  const n = Math.max(headings.length, values.length, texts.length, 1);
                  progressArr = Array(n).fill(singleProgress);
                }
                const n = Math.max(headings.length, values.length, progressArr.length, texts.length, 1);
                for (var j = 0; j < n; j++) {
                  expanded.push({
                    performance_heading: headings[j] || '',
                    performance_heading_value: values[j] || '',
                    performance_progress: progressArr[j] !== undefined ? progressArr[j] : 0,
                    performance_text: texts[j] || ''
                  });
                }
              }
              normalized = expanded;
            }
            variantPerformanceDataMap.set(variantId, normalized);
            const variantIdNum = parseInt(variantId, 10);
            if (!isNaN(variantIdNum)) {
              variantPerformanceDataMap.set(variantIdNum.toString(), normalized);
              variantPerformanceDataMap.set(String(variantIdNum), normalized);
            }
          }
        } catch (e) { /* silent */ }
      });
    });
  })();

  // Debug: Show sample of stored metafields
  if (firmnessMetafieldsMap.size > 0) {
    let count = 0;
    for (let [variantId, metafields] of firmnessMetafieldsMap.entries()) {
      if (count < 3) {
        count++;
      } else {
        break;
      }
    }
  }
  
  // Debug: Show foundation metafields
  if (foundationMetafieldsByProduct.size > 0) {
    for (let [productHandle, foundationMap] of foundationMetafieldsByProduct.entries()) {
      let count = 0;
      for (let [variantId, metafields] of foundationMap.entries()) {
        if (count < 2) {
          count++;
        } else {
          break;
        }
      }
    }
  }
  
  // Debug: Show variant info metafields
  if (variantInfoMetafieldsMap.size > 0) {
    let count = 0;
    for (let [variantId, variantInfo] of variantInfoMetafieldsMap.entries()) {
      if (count < 3) {
        count++;
      } else {
        break;
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Initialize metafields first
  initializeMetafieldsFromDataAttributes();
  let pdpInitialProductDescriptionHtml = '';
  function captureInitialProductDescriptionHtml() {
    const el = document.querySelector('#custom-product-container .product-description');
    if (el && el.innerHTML.trim()) {
      pdpInitialProductDescriptionHtml = el.innerHTML.trim();
    }
  }
  captureInitialProductDescriptionHtml();
  initPdpMainImageSwipe();
  // Store current state
  let currentMattressProduct = null;
  let currentFirmnessVariant = null;
  let currentSizeVariant = null;
  let currentFoundationVariant = null;
  let currentFoundationProduct = null;
  let currentFoundationImages = null;
  let currentMattressImages = null;
  let currentFirmnessTitle = '';
  let isFoundationSelected = false;
  let selectedModelValue = '';
  let selectedUnderbedProduct = null;
  /** When foundation has 2 options (Size + Foundation Type), store the selected type so we sync variant by mattress size */
  let selectedFoundationType = null;
  /** When upsell popup is shown, remember buyNow for "continue" action */
  let pendingUpsellBuyNow = false;
  /** Which upsell overlay is open (adjustable or breeze) — used for confirm/continue dataset */
  let activeUpsellOverlay = null;
  /** After foundation upsell, chain state for add-to-cart (foundation upgrade ids + buyNow). */
  let pendingAccessoryChain = null;

  function upsellPopupGetEl(namespace, suffix) {
    return document.getElementById(namespace + '-' + suffix);
  }

  /** Console: ?pdp_upsell_debug=1 or window.SUAVE_PDP_UPSELL_DEBUG = true. Alerts: ?pdp_upsell_debug=alert or window.SUAVE_PDP_UPSELL_DEBUG_ALERTS = true */
  function suavePdpUpsellDebugEnabled() {
    if (typeof window === 'undefined') return false;
    if (window.SUAVE_PDP_UPSELL_DEBUG === true) return true;
    try {
      var s = window.location && window.location.search;
      if (s && /[?&]pdp_upsell_debug=(?:1|true)(?:&|$)/i.test(s)) return true;
    } catch (e) {}
    return false;
  }
  function suavePdpUpsellDebugAlerts() {
    if (typeof window === 'undefined') return false;
    if (window.SUAVE_PDP_UPSELL_DEBUG_ALERTS === true) return true;
    try {
      var s = window.location && window.location.search;
      if (s && /[?&]pdp_upsell_debug=alert(?:&|$)/i.test(s)) return true;
    } catch (e) {}
    return false;
  }
  function suavePdpUpsellDbg(msg, detail) {
    if (!suavePdpUpsellDebugEnabled()) return;
    if (detail !== undefined) console.log('[SUAVE PDP upsell]', msg, detail);
    else console.log('[SUAVE PDP upsell]', msg);
  }
  function suavePdpUpsellDbgAlert(msg) {
    if (!suavePdpUpsellDebugAlerts()) return;
    try {
      alert('[SUAVE PDP upsell]\n' + msg);
    } catch (e) {}
  }

  /**
   * Same resolution as add-to-cart: :checked radio, else .foundation-option.selected, else first available.
   * Upsell previously used only :checked — if UI got out of sync, popup never ran.
   */
  function getFoundationInputForUpsell() {
    var el = document.querySelector('input[name="foundation"]:checked');
    if (el) return el;
    var foundationContainer = document.getElementById('foundation-options-container');
    if (foundationContainer) {
      el =
        foundationContainer.querySelector('input[name="foundation"]:checked') ||
        foundationContainer.querySelector('.foundation-option.selected input[name="foundation"]') ||
        foundationContainer.querySelector('.foundation-option:not(.out-of-stock) input[name="foundation"]:not([disabled])') ||
        foundationContainer.querySelector('input[name="foundation"]');
      if (el) return el;
      // No separate foundation product / metafield: mattress "model" options (Base, etc.) render as name="model" in the same section
      el =
        foundationContainer.querySelector('input[name="model"]:checked') ||
        foundationContainer.querySelector('.model-option.selected input[name="model"]') ||
        foundationContainer.querySelector('.model-option:not(.out-of-stock) input[name="model"]:not([disabled])') ||
        foundationContainer.querySelector('input[name="model"]');
      if (el) return el;
      el = foundationContainer.querySelector('input[name="underbed"]:checked');
      if (el && !el.disabled) return el;
    }
    return null;
  }

  /** Label used for upsell trigger matching: data-foundation-type, or model radio value / parent data-foundation-type */
  function getEffectiveFoundationTypeForUpsell(input) {
    if (!input) return '';
    var ft = input.getAttribute('data-foundation-type');
    if (ft != null && String(ft).trim() !== '') return String(ft).trim();
    if (input.name === 'model' && input.value) return String(input.value).trim();
    var wrap = input.closest && input.closest('[data-foundation-type]');
    if (wrap && wrap.getAttribute('data-foundation-type')) {
      return String(wrap.getAttribute('data-foundation-type')).trim();
    }
    return '';
  }

  function isUnderbedNoFoundationInput(input) {
    if (!input || input.name !== 'underbed') return false;
    if (input.getAttribute('data-foundation-choice') === 'none') return true;
    if (input.closest && input.closest('.foundation-option--no-foundation')) return true;
    return String(input.value || '').trim() === '';
  }

  function getSelectedUnderbedInput() {
    var el = document.querySelector('input[name="underbed"]:checked');
    if (el && !el.disabled) return el;
    return null;
  }

  function clearUnderbedSelection(container) {
    if (!container) container = document.getElementById('foundation-options-container');
    if (!container) return;
    container.querySelectorAll('input[name="underbed"]').forEach(function (i) {
      i.checked = false;
    });
    clearFoundationOptionSelection(container);
    selectedUnderbedProduct = null;
    currentFoundationVariant = null;
    selectedFoundationType = suavePdpNoFoundationLabel();
    selectedModelValue = '';
    isFoundationSelected = false;
  }

  function syncCurrentFoundationFromUnderbedInput(input) {
    if (!input || isUnderbedNoFoundationInput(input)) {
      currentFoundationVariant = null;
      return;
    }
    var variantId = input.getAttribute('data-underbed-variant-id');
    if (!variantId) {
      currentFoundationVariant = null;
      return;
    }
    currentFoundationVariant = {
      id: parseInt(variantId, 10),
      title: input.getAttribute('data-foundation-type') || (selectedUnderbedProduct && selectedUnderbedProduct.title) || '',
      price: parseInt(input.getAttribute('data-price') || '0', 10) || 0
    };
  }

  function getUnderbedAddonPriceCents() {
    var input = getSelectedUnderbedInput();
    if (!input || isUnderbedNoFoundationInput(input) || input.disabled) return 0;
    if (!input.getAttribute('data-underbed-variant-id')) return 0;
    return parseInt(input.getAttribute('data-price') || '0', 10) || 0;
  }

  function isSelectedUnderbedSellable() {
    var input = getSelectedUnderbedInput();
    if (!input || isUnderbedNoFoundationInput(input)) return true;
    var selectedSize = getCurrentMattressSizeValue();
    if (!selectedSize) return true;
    return !!input.getAttribute('data-underbed-variant-id');
  }

  function foundationTriggerMatches(config, foundationType) {
    if (!config || !foundationType) {
      suavePdpUpsellDbg('foundationTriggerMatches: no match (missing config or type)', {
        hasConfig: !!config,
        foundationType: foundationType
      });
      return false;
    }
    const trigger = config.foundationTrigger ? String(config.foundationTrigger).trim().toLowerCase() : '';
    if (!trigger) {
      suavePdpUpsellDbg('foundationTriggerMatches: no match (empty trigger in config)', { foundationType: foundationType });
      return false;
    }
    const normalized = String(foundationType).trim().toLowerCase();
    const eq = normalized === trigger;
    const inc1 = normalized.includes(trigger);
    const inc2 = trigger.includes(normalized);
    const ok = eq || inc1 || inc2;
    suavePdpUpsellDbg('foundationTriggerMatches', {
      trigger: trigger,
      foundationTypeNorm: normalized,
      eq: eq,
      typeIncludesTrigger: inc1,
      triggerIncludesType: inc2,
      result: ok
    });
    return ok;
  }
  
  // Store original product data
  
  // Store current active color for title styling
  let currentActiveTab = null;

  function broadcastFirmnessLabel(label) {
    if (!label || typeof label !== 'string') return;
    document.dispatchEvent(
      new CustomEvent('suave:firmness-change', {
        detail: { label: label.trim() }
      })
    );
  }

  function syncPdpLayersActiveProduct(productHandle, productTitle) {
    var layersSection = document.querySelector('[data-pdp-collection-layers-section]');
    if (!layersSection) return;
    if (productHandle) {
      activatePdpLayersTab(layersSection, productHandle);
    }
    if (productTitle) {
      broadcastFirmnessLabel(productTitle);
    }
  }

  function isPdpColorDark(color) {
    if (!color) return false;
    let r;
    let g;
    let b;
    const normalized = String(color).trim();
    if (normalized.startsWith('#')) {
      const hex = normalized.replace('#', '');
      if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
      } else {
        r = parseInt(hex.substr(0, 2), 16);
        g = parseInt(hex.substr(2, 2), 16);
        b = parseInt(hex.substr(4, 2), 16);
      }
    } else if (normalized.startsWith('rgb')) {
      const matches = normalized.match(/\d+/g);
      if (!matches || matches.length < 3) return false;
      r = parseInt(matches[0], 10);
      g = parseInt(matches[1], 10);
      b = parseInt(matches[2], 10);
    } else {
      return false;
    }
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.5;
  }

  function applyTabColorToPdpElements(tabColor) {
    if (!tabColor || tabColor.trim() === '' || tabColor === 'null' || tabColor === '#') return;
    const color = tabColor.trim();
    const contrastText = isPdpColorDark(color) ? '#ffffff' : '#000000';

    document.querySelectorAll('#custom-product-container .pdp-color-enabled').forEach(function (el) {
      el.style.backgroundColor = color;
      el.style.borderColor = color;
      el.style.color = contrastText;
      el.style.setProperty('--pdp-bg-color', color);
      el.style.setProperty('--pdp-text-color', contrastText);
    });

    document.querySelectorAll('#custom-product-container .pdp-text-color').forEach(function (el) {
      if (el.closest('.foundation-option')) return;
      el.style.color = color;
      el.style.setProperty('--pdp-text-color', color);
    });

    document.querySelectorAll('#custom-product-container .pdp-border-color').forEach(function (el) {
      el.style.borderColor = color;
      el.style.setProperty('--pdp-border-color', color);
    });
  }

  function applyMattressTabActiveVisuals(activeTab) {
    if (!activeTab) return;

    document.querySelectorAll('#custom-product-container .tab').forEach(function (t) {
      t.classList.remove('active');
      const tabColor = (t.getAttribute('data-tab-color') || '').trim();
      t.style.borderWidth = '1px';
      t.style.borderStyle = 'solid';
      t.style.backgroundColor = '#ffffff';
      if (tabColor && tabColor !== 'null' && tabColor !== '#') {
        t.style.borderColor = tabColor;
        t.style.color = tabColor;
      } else {
        t.style.borderColor = '';
        t.style.color = '';
      }
    });

    activeTab.classList.add('active');
    const activeColor = (activeTab.getAttribute('data-tab-color') || '').trim();
    if (activeColor && activeColor !== 'null' && activeColor !== '#') {
      activeTab.style.borderWidth = '2px';
      activeTab.style.borderStyle = 'solid';
      activeTab.style.borderColor = activeColor;
      activeTab.style.backgroundColor = activeColor;
      activeTab.style.color = '#ffffff';
    }
  }

  function applyFirmnessCardTabColor(tabColor) {
    const color = (tabColor || '').trim();
    const textSelector =
      '.firmness-label, .firmness-card-title, .firmness-title, .firmness-variant-name, .firmness-title-text, .firmness-description, .firmness-features li';

    document.querySelectorAll('#custom-product-container .firmness-card').forEach(function (card) {
      card.style.backgroundColor = '';
      card.style.borderColor = '';
      card.style.color = '';
      card.querySelectorAll(textSelector).forEach(function (el) {
        el.style.color = '';
      });
    });

    if (!color || color === 'null' || color === '#') return;

    const selectedCard = document.querySelector('#custom-product-container .firmness-card.selected');
    if (!selectedCard) return;

    selectedCard.style.backgroundColor = color;
    selectedCard.style.borderColor = color;
    selectedCard.style.color = '#ffffff';
    selectedCard.querySelectorAll(textSelector).forEach(function (el) {
      el.style.color = '#ffffff';
    });
  }

  function clearFoundationOptionVisualStyles(optionEl) {
    if (!optionEl) return;

    optionEl.style.removeProperty('background-color');
    optionEl.style.removeProperty('background');
    optionEl.style.removeProperty('border-color');
    optionEl.style.removeProperty('color');
    optionEl.style.removeProperty('border-width');
    optionEl.style.removeProperty('border-style');

    optionEl.querySelectorAll('.foundation-title, .foundation-price, .foundation-subtitle, .out-of-stock-badge').forEach(function (el) {
      el.classList.remove('pdp-text-color');
      el.style.removeProperty('color');
      el.style.removeProperty('--pdp-text-color');
    });

    const subtitleEl = optionEl.querySelector('.foundation-subtitle');
    if (subtitleEl) {
      const isUnavailable = optionEl.classList.contains('out-of-stock') || optionEl.classList.contains('size-unavailable');
      subtitleEl.style.color = isUnavailable ? '#ff4444' : '#666';
    }
  }

  function applyFoundationOptionTabColor(tabColor) {
    const color = (tabColor || '').trim();
    const textSelector =
      '.foundation-title, .foundation-price, .foundation-subtitle, .out-of-stock-badge';

    document.querySelectorAll('#custom-product-container .foundation-option').forEach(function (opt) {
      clearFoundationOptionVisualStyles(opt);
    });

    if (!color || color === 'null' || color === '#') return;

    const selectedOption = document.querySelector('#custom-product-container .foundation-option.selected');
    if (!selectedOption) return;

    selectedOption.style.backgroundColor = color;
    selectedOption.style.borderColor = color;
    selectedOption.style.color = '#ffffff';
    selectedOption.querySelectorAll(textSelector).forEach(function (el) {
      el.style.color = '#ffffff';
    });
  }

  function applyPdpSelectionTabColors(tabColor) {
    applyFirmnessCardTabColor(tabColor);
    applyFoundationOptionTabColor(tabColor);
  }

  // Function to update title last word(s) color based on active tab
  function updateTitleLastWordColor() {
    const activeTab = document.querySelector('#custom-product-container .tab.active');
    if (!activeTab) return;

    const tabColor = activeTab.getAttribute('data-tab-color');
    if (!tabColor) return;

    currentActiveTab = activeTab;
    applyMattressTabActiveVisuals(activeTab);
    applyTabColorToPdpElements(tabColor);
    applyPdpSelectionTabColors(tabColor);

    document.querySelectorAll('.title-last-word').forEach(function (el) {
      el.style.color = tabColor.trim();
    });
  }
  
  function isSpanishPdpLocale() {
    const container = document.getElementById('custom-product-container');
    const dataLocale = container ? (container.getAttribute('data-pdp-locale') || '').toLowerCase() : '';
    const path = window.location.pathname || '';

    if (path === '/en' || path.indexOf('/en/') === 0) return false;
    if (path === '/es' || path.indexOf('/es/') === 0) return true;

    var prefMatch = document.cookie.match(/(?:^|; )suave_locale_pref=([^;]*)/);
    var localePref = prefMatch ? decodeURIComponent(prefMatch[1]) : '';
    if (localePref === 'en') return false;
    if (localePref === 'es') return true;

    if (dataLocale.indexOf('es') === 0) return true;
    if (dataLocale.indexOf('en') === 0) return false;

    const htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (htmlLang.indexOf('es') === 0) return true;
    if (htmlLang.indexOf('en') === 0) return false;

    if (typeof Shopify !== 'undefined' && Shopify.locale) {
      const shopifyLocale = String(Shopify.locale).toLowerCase();
      if (shopifyLocale.indexOf('es') === 0) return true;
      if (shopifyLocale.indexOf('en') === 0) return false;
    }

    return false;
  }

  function normalizePdpImageUrl(url) {
    if (!url || typeof url !== 'string') return '';
    return url.replace(/_small\.|_medium\.|_large\.|_compact\.|_grande\./g, '_master.');
  }

  function pdpImageUrlsMatch(a, b) {
    if (!a || !b) return false;
    return String(a).split('?')[0] === String(b).split('?')[0];
  }

  function getVariantMetafieldGalleryUrls(variantId) {
    const variantIdStr = String(variantId || '');
    if (!variantIdStr) return [];
    let entry = variantGalleryImagesMap.get(variantIdStr);
    if (!entry) {
      const variantIdNum = parseInt(variantIdStr, 10);
      if (!isNaN(variantIdNum)) {
        entry = variantGalleryImagesMap.get(String(variantIdNum));
      }
    }
    if (!entry) return [];
    if (Array.isArray(entry)) {
      return entry.filter(function (u) {
        return typeof u === 'string' && u.trim() !== '' && u !== 'null';
      });
    }
    const localeKey = isSpanishPdpLocale() ? 'es' : 'en';
    const urls = entry[localeKey] || entry.en || [];
    return Array.isArray(urls)
      ? urls.filter(function (u) {
          return typeof u === 'string' && u.trim() !== '' && u !== 'null';
        })
      : [];
  }

  function getVariantFeaturedImageData(variantId) {
    const variantIdStr = String(variantId || '');
    if (!variantIdStr || !currentMattressProduct || !currentMattressProduct.variants) return null;
    const currentVariant = currentMattressProduct.variants.find(function (v) {
      return String(v.id) === variantIdStr || String(v.id) === String(parseInt(variantIdStr, 10));
    });
    if (!currentVariant || !currentVariant.featured_image) return null;
    const featuredSrc =
      typeof currentVariant.featured_image === 'string'
        ? currentVariant.featured_image
        : currentVariant.featured_image.src;
    if (!featuredSrc || String(featuredSrc).trim() === '') return null;
    return {
      src: normalizePdpImageUrl(featuredSrc),
      alt: currentVariant.title || 'Variant image'
    };
  }

  // Function to load and display product images
  function loadProductImages(productImages, options) {
    options = options || {};
    const thumbnailContainer = document.getElementById('thumbnail-images-container');
    const mainImage = document.getElementById('main-image');
    const imageLoading = document.getElementById('image-loading');
    
    if (!thumbnailContainer || !mainImage) {
      return;
    }
    
    // Hide loading and show thumbnail container
    if (imageLoading) {
      imageLoading.style.display = 'none';
    }
    
    // Clear existing content
    thumbnailContainer.innerHTML = '';
    
    const thumbs = productImages && productImages.length > 0 ? productImages : [];
    const mainOverride = options.mainImage || null;

    if (thumbs.length > 0) {
      thumbs.forEach(function (image, index) {
        const thumbnail = createThumbnail(image, index);
        thumbnailContainer.appendChild(thumbnail);
      });
    }

    let mainImageData = mainOverride;
    if (!mainImageData && thumbs.length > 0) {
      mainImageData = {
        src: thumbs[0].src || thumbs[0],
        alt: thumbs[0].alt || 'Product image'
      };
    }

    if (mainImageData) {
      let mainImageUrl = mainImageData.src || mainImageData;
      if (typeof mainImageUrl === 'string') {
        mainImageUrl = normalizePdpImageUrl(mainImageUrl);
      }
      mainImage.src = mainImageUrl;
      mainImage.alt = mainImageData.alt || 'Product image';
      mainImage.onerror = function () {
        console.error('Failed to load main image:', mainImageUrl);
        this.src = mainImageUrl;
      };

      const allThumbnails = thumbnailContainer.querySelectorAll('.thumbnail');
      let matchedThumb = null;
      allThumbnails.forEach(function (thumb) {
        thumb.classList.remove('active');
        const thumbUrl = thumb.getAttribute('data-image');
        if (!matchedThumb && pdpImageUrlsMatch(thumbUrl, mainImageUrl)) {
          matchedThumb = thumb;
        }
      });
      if (matchedThumb) {
        matchedThumb.classList.add('active');
      }

      initPdpThumbnailCarousel();
    } else if (thumbs.length === 0) {
      if (imageLoading) {
        imageLoading.textContent = suavePdpT('noImages', 'No images available');
        imageLoading.style.display = '';
      }
    }
  }

  function loadVariantImageGallery(variantId) {
    const featured = getVariantFeaturedImageData(variantId);
    const galleryUrls = getVariantMetafieldGalleryUrls(variantId);
    const thumbs = galleryUrls.map(function (src) {
      return {
        src: normalizePdpImageUrl(src),
        alt: (featured && featured.alt) || 'Product image'
      };
    });
    loadProductImages(thumbs, { mainImage: featured });
  }
  
  // Function to create thumbnail element
  function createThumbnail(image, index) {
    const thumbnail = document.createElement('div');
    thumbnail.className = 'thumbnail';
    thumbnail.dataset.index = index;
    
    // Get the proper image URL
    let imageUrl = image.src || image;
    if (typeof imageUrl === 'string') {
      // Convert to master size for main image
      imageUrl = imageUrl.replace(/_small\.|_medium\.|_large\.|_compact\.|_grande\./g, '_master.');
    }
    
    thumbnail.dataset.image = imageUrl;
    
    const img = document.createElement('img');
    // Use medium size for thumbnails
    const thumbUrl = imageUrl.replace('_master.', '_medium.');
    img.src = thumbUrl;
    img.alt = image.alt || 'Product image';
    img.loading = 'lazy';
    img.onerror = function() {
      console.error('Failed to load thumbnail image:', thumbUrl);
      this.src = imageUrl; // Fallback to master
    };
    
    thumbnail.appendChild(img);
    
    // Add click event
    thumbnail.addEventListener('click', function() {
      activatePdpThumbnail(this, 'smooth');
    });
    
    return thumbnail;
  }

  const PDP_THUMB_CAROUSEL_MQ = typeof window.matchMedia === 'function'
    ? window.matchMedia('(max-width: 749px)')
    : null;

  function isPdpThumbCarouselMobile() {
    return PDP_THUMB_CAROUSEL_MQ && PDP_THUMB_CAROUSEL_MQ.matches;
  }

  function getPdpThumbnailTrack() {
    return document.getElementById('thumbnail-images-container');
  }

  function getPdpThumbnailElements() {
    const track = getPdpThumbnailTrack();
    return track ? Array.from(track.querySelectorAll('.thumbnail')) : [];
  }

  function scrollPdpThumbToElement(thumbEl, behavior) {
    const track = getPdpThumbnailTrack();
    if (!track || !thumbEl) return;
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    if (maxScroll <= 0) return;
    const target = thumbEl.offsetLeft - (track.clientWidth - thumbEl.offsetWidth) / 2;
    track.scrollTo({
      left: Math.max(0, Math.min(target, maxScroll)),
      behavior: behavior || 'auto'
    });
  }

  function scrollPdpActiveThumbnailIntoView(thumbEl) {
    const track = getPdpThumbnailTrack();
    if (!track) return;
    const el = thumbEl || track.querySelector('.thumbnail.active');
    scrollPdpThumbToElement(el, 'smooth');
  }

  function activatePdpThumbnail(thumbEl, scrollBehavior) {
    if (!thumbEl) return;
    const allThumbnails = document.querySelectorAll('#custom-product-container .thumbnail');
    allThumbnails.forEach(function (t) {
      t.classList.remove('active');
    });
    thumbEl.classList.add('active');

    const imageUrl = thumbEl.getAttribute('data-image');
    const mainImage = document.getElementById('main-image');
    if (imageUrl && mainImage) {
      mainImage.src = imageUrl;
      const thumbImg = thumbEl.querySelector('img');
      if (thumbImg) mainImage.alt = thumbImg.alt;
    }

    scrollPdpThumbToElement(thumbEl, scrollBehavior || 'smooth');
    updatePdpThumbnailCarouselNavState();
  }

  function scrollPdpThumbAdjacent(direction) {
    const track = getPdpThumbnailTrack();
    const thumbs = getPdpThumbnailElements();
    if (!track || !thumbs.length) return;
    const active = track.querySelector('.thumbnail.active') || thumbs[0];
    const idx = Math.max(0, thumbs.indexOf(active));
    const nextIdx = Math.max(0, Math.min(thumbs.length - 1, idx + direction));
    if (nextIdx === idx) return;
    activatePdpThumbnail(thumbs[nextIdx], 'smooth');
  }

  function refreshPdpThumbnailCarousel() {
    updatePdpThumbnailCarouselNavState();
  }

  function updatePdpThumbnailCarouselNavState() {
    const carousel = document.getElementById('pdp-thumbnail-carousel');
    const track = getPdpThumbnailTrack();
    const prevBtn = document.getElementById('pdp-thumb-carousel-prev');
    const nextBtn = document.getElementById('pdp-thumb-carousel-next');
    if (!carousel || !track || !prevBtn || !nextBtn) return;

    const thumbCount = getPdpThumbnailElements().length;
    const enabled = thumbCount > 1;

    carousel.classList.toggle('pdp-thumb-carousel--enabled', enabled);

    if (!enabled) {
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      return;
    }

    const thumbs = getPdpThumbnailElements();
    const active = track.querySelector('.thumbnail.active') || thumbs[0];
    const idx = active ? Math.max(0, thumbs.indexOf(active)) : 0;
    prevBtn.disabled = idx <= 0;
    nextBtn.disabled = idx >= thumbs.length - 1;
  }

  function bindPdpThumbnailCarouselImageLoads(track) {
    if (!track) return;
    track.querySelectorAll('.thumbnail img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', refreshPdpThumbnailCarousel, { once: true });
      img.addEventListener('error', refreshPdpThumbnailCarousel, { once: true });
    });
  }

  function initPdpMainImageSwipe() {
    var root = document.getElementById('custom-product-container');
    if (!root || root.getAttribute('data-enable-main-image-swipe') === 'false') return;
    if (typeof window.suaveBindMainImageSwipe !== 'function') return;
    var wrap = document.querySelector('#custom-product-container .main-image');
    if (!wrap) return;
    window.suaveBindMainImageSwipe(
      wrap,
      function () {
        scrollPdpThumbAdjacent(1);
      },
      function () {
        scrollPdpThumbAdjacent(-1);
      },
      { swipeClass: 'pdp-main-image--swipe' }
    );
  }

  function initPdpThumbnailCarousel() {
    const carousel = document.getElementById('pdp-thumbnail-carousel');
    const track = getPdpThumbnailTrack();
    const prevBtn = document.getElementById('pdp-thumb-carousel-prev');
    const nextBtn = document.getElementById('pdp-thumb-carousel-next');
    if (!carousel || !track) return;

    bindPdpThumbnailCarouselImageLoads(track);

    if (!carousel._pdpThumbCarouselBound) {
      carousel._pdpThumbCarouselBound = true;

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollPdpThumbAdjacent(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollPdpThumbAdjacent(1);
        });
      }

      track.addEventListener('scroll', function () {
        updatePdpThumbnailCarouselNavState();
      }, { passive: true });

      if (PDP_THUMB_CAROUSEL_MQ) {
        const onMqChange = function () {
          refreshPdpThumbnailCarousel();
        };
        if (typeof PDP_THUMB_CAROUSEL_MQ.addEventListener === 'function') {
          PDP_THUMB_CAROUSEL_MQ.addEventListener('change', onMqChange);
        } else if (typeof PDP_THUMB_CAROUSEL_MQ.addListener === 'function') {
          PDP_THUMB_CAROUSEL_MQ.addListener(onMqChange);
        }
      }

      window.addEventListener('resize', refreshPdpThumbnailCarousel, { passive: true });

      if (typeof ResizeObserver !== 'undefined' && !track._pdpThumbResizeObs) {
        track._pdpThumbResizeObs = true;
        const ro = new ResizeObserver(refreshPdpThumbnailCarousel);
        ro.observe(track);
      }
    }

    refreshPdpThumbnailCarousel();
    requestAnimationFrame(refreshPdpThumbnailCarousel);
    setTimeout(refreshPdpThumbnailCarousel, 120);
    setTimeout(refreshPdpThumbnailCarousel, 400);
  }
  
  function getActiveMattressVariantId() {
    if (currentSizeVariant && currentSizeVariant.id) {
      return String(currentSizeVariant.id);
    }
    if (currentFirmnessVariant && currentFirmnessVariant.id) {
      return String(currentFirmnessVariant.id);
    }
    return '';
  }
  
  // Foundation selection should not use old alt-text image matching.
  // Always keep mattress gallery driven by selected mattress variant.
  function handleFoundationVariantImageChange(variantElement, foundationProductData) {
    try {
      const activeVariantId = getActiveMattressVariantId();
      if (activeVariantId) {
        loadVariantImageGallery(activeVariantId);
        return;
      }
      if (currentMattressImages && currentMattressImages.length > 0) {
        loadProductImages(currentMattressImages);
      }
    } catch (error) {
      if (currentMattressImages && currentMattressImages.length > 0) {
        loadProductImages(currentMattressImages);
      }
    }
  }
  
  // Function to fetch variant metafields for a product
  // NOTE: This function now only uses data attributes - API calls removed due to 403 errors
  async function fetchVariantMetafields(productData) {
    // Metafields are already merged from data attributes via mergeVariantMetafields()
    // This function is kept for compatibility but does nothing
    return productData;
  }
  
  // Function to fetch foundation variant metafields
  // NOTE: This function now only uses data attributes - API calls removed due to 403 errors
  async function fetchFoundationVariantMetafields(foundationProduct) {
    // Metafields are already merged from data attributes via mergeFoundationMetafields()
    // This function is kept for compatibility but does nothing
    return foundationProduct;
  }

  // Function to get foundation product from metafield
  async function getFoundationProductFromMetafield(productHandle) {
    try {
      // Try to get product with metafields using Shopify's AJAX API
      const response = await fetch(suavePdpProductViewUrl(productHandle, 'json-metafields'));
      
      if (response.ok) {
        const html = await response.text();
        
        // Try to parse as JSON first
        try {
          const productData = JSON.parse(html);
          
          // Check for foundation_product in metafields
          if (productData.metafields && productData.metafields.custom && productData.metafields.custom.foundation_product) {
            const foundationHandle = productData.metafields.custom.foundation_product;
            return foundationHandle;
          }
          
          // Check in global namespace
          if (productData.metafields && productData.metafields.global && productData.metafields.global.foundation_product) {
            const foundationHandle = productData.metafields.global.foundation_product;
            return foundationHandle;
          }
          
          // Check direct property
          if (productData.metafields && productData.metafields.foundation_product) {
            const foundationHandle = productData.metafields.foundation_product;
            return foundationHandle;
          }
          
        } catch (e) {
          console.log('Response is not JSON, trying to parse as HTML');
        }
        
        // Look for metafield in data attributes or script tags
        const dataAttrRegex = /data-foundation-product=["']([^"']+)["']/i;
        const dataMatch = html.match(dataAttrRegex);
        if (dataMatch && dataMatch[1]) {
          return dataMatch[1];
        }
        
      }
      
      // Try to get product JSON directly
      const jsonResponse = await fetch(suavePdpProductJsonUrl(productHandle));
      if (jsonResponse.ok) {
        const productData = await jsonResponse.json();
        
        // Check if product has metafields property
        if (productData.metafields) {
          
          // Check custom namespace
          if (productData.metafields.custom && productData.metafields.custom.foundation_product) {
            return productData.metafields.custom.foundation_product;
          }
          
          // Check global namespace
          if (productData.metafields.global && productData.metafields.global.foundation_product) {
            return productData.metafields.global.foundation_product;
          }
          
          // Check direct property
          if (productData.metafields.foundation_product) {
            return productData.metafields.foundation_product;
          }
        }
        
      }
      
      return null;
      
    } catch (error) {
      console.error('Error fetching foundation metafield:', error);
      return null;
    }
  }
  
  function resolveMattressProductForFoundation(mattressProductHandle) {
    if (currentMattressProduct && currentMattressProduct.variants && currentMattressProduct.variants.length) {
      return currentMattressProduct;
    }
    if (mattressProductHandle && currentMattressProduct && currentMattressProduct.handle === mattressProductHandle) {
      return currentMattressProduct;
    }
    return null;
  }

  function findBaseModelContext(productData) {
    if (!productData || !productData.variants || !productData.variants.length) return null;
    const { modelIndex, sizeIndex } = detectOptionTypes(productData);
    if (modelIndex === -1 || modelIndex === sizeIndex) return null;
    let baseModelValue = '';
    const baseVariants = [];
    productData.variants.forEach((variant) => {
      const modelValue = getModelLabelFromVariant(variant, modelIndex);
      if (!isUnderbedReplacementModelLabel(modelValue)) return;
      if (!baseModelValue) baseModelValue = modelValue;
      baseVariants.push(variant);
    });
    if (!baseVariants.length) return null;
    return { modelIndex, sizeIndex, baseModelValue, baseVariants };
  }

  function getCurrentMattressSizeVariantPriceCents() {
    if (currentSizeVariant && currentSizeVariant.price != null) {
      return parseInt(currentSizeVariant.price, 10) || 0;
    }
    const sizeSelect = document.getElementById('size-select');
    if (sizeSelect && sizeSelect.selectedIndex >= 0) {
      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      if (selectedOption && selectedOption.value && currentMattressProduct && currentMattressProduct.variants) {
        const variant = currentMattressProduct.variants.find(
          (v) => v.id.toString() === selectedOption.value
        );
        if (variant && variant.price != null) {
          return parseInt(variant.price, 10) || 0;
        }
      }
      const priceAttr = selectedOption ? selectedOption.getAttribute('data-price') : null;
      if (priceAttr) {
        const priceStr = priceAttr.replace(/[$,]/g, '');
        const priceFloat = parseFloat(priceStr);
        if (!isNaN(priceFloat)) {
          return Math.round(priceFloat * 100);
        }
      }
    }
    if (currentFirmnessVariant && currentFirmnessVariant.price != null) {
      return parseInt(currentFirmnessVariant.price, 10) || 0;
    }
    return 0;
  }

  function updateNoFoundationCardPrice() {
    const priceEl = document.querySelector('#foundation-options-container [data-no-foundation-price]');
    if (!priceEl) return;
    priceEl.textContent = formatMoney(0);
  }

  var BED_SIZE_ALIAS_GROUPS = [
    ['twin', 'individual', 'sencillo', 'single', 'twin bed'],
    ['twin xl', 'twinxl', 'individual xl', 'xl twin'],
    ['full', 'doble', 'double'],
    ['queen', 'matrimonial', 'queen size'],
    ['king', 'king size', 'kingsize'],
    ['cal king', 'california king', 'king california', 'calking', 'cal king size'],
    ['split king', 'splitking']
  ];

  function bedSizeCanonicalKey(value) {
    var n = normalizeMattressSizeLabel(value);
    if (!n) return '';
    var gi;
    for (gi = 0; gi < BED_SIZE_ALIAS_GROUPS.length; gi++) {
      var group = BED_SIZE_ALIAS_GROUPS[gi];
      var ai;
      for (ai = 0; ai < group.length; ai++) {
        if (normalizeMattressSizeLabel(group[ai]) === n || compactBedSizeKey(group[ai]) === compactBedSizeKey(value)) {
          return group[0];
        }
      }
    }
    return compactBedSizeKey(value);
  }

  function isVariantSellable(variant) {
    return isVariantSellableForUpsell(variant);
  }

  function detectUnderbedSizeIndex(product) {
    if (!product) return -1;
    const optionNames = Array.isArray(product.option_names) ? product.option_names : [];
    const sizeKeywords = ['size', 'dimension', 'tamaño', 'tamano', 'medida', 'twin', 'full', 'queen', 'king', 'california', 'xl'];
    for (let i = 0; i < optionNames.length; i += 1) {
      const name = String(optionNames[i] || '').toLowerCase();
      if (sizeKeywords.some((k) => name.includes(k))) return i;
    }
    return optionNames.length > 1 ? 1 : (optionNames.length === 1 ? 0 : -1);
  }

  function getVariantOptionByIndex(variant, index) {
    if (!variant || index < 0) return '';
    if (index === 0) return String(variant.option1 || '').trim();
    if (index === 1) return String(variant.option2 || '').trim();
    if (index === 2) return String(variant.option3 || '').trim();
    return '';
  }

  function findUnderbedVariantForSize(product, selectedSize) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length || !selectedSize) return null;
    const sizeIndex = detectUnderbedSizeIndex(product);
    var match = null;
    if (sizeIndex >= 0) {
      match = product.variants.find(function (v) {
        return mattressSizesMatch(getVariantOptionByIndex(v, sizeIndex), selectedSize);
      });
    }
    if (!match) {
      match = product.variants.find(function (v) {
        return variantOptionValuesAll(v).some(function (val) {
          return mattressSizesMatch(val, selectedSize);
        });
      });
    }
    return match || null;
  }

  function resolveUnderbedVariantForCurrentSize(product, requireExactSizeMatch) {
    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) return null;
    const selectedSize = getCurrentMattressSizeValue();
    if (selectedSize) {
      const exactVariant = findUnderbedVariantForSize(product, selectedSize);
      if (exactVariant) return exactVariant;
      if (requireExactSizeMatch) return null;
    }
    const firstAvailable = product.variants.find(function (v) { return isVariantSellable(v); });
    return firstAvailable || product.variants[0] || null;
  }

  function buildNoFoundationOptionHtml(checked) {
    const cfg = getUnderbedConfig();
    const title = (cfg && cfg.noFoundationLabel) ? String(cfg.noFoundationLabel).trim() : suaveT('noFoundation', 'No Foundation');
    const subtitle = (cfg && cfg.noFoundationSubtitle)
      ? String(cfg.noFoundationSubtitle).trim()
      : `Select ${title} model for your bed setup.`;
    const noFoundationType = escapeHtmlText(title);
    return `
      <label class="foundation-option foundation-option--no-foundation${checked ? ' selected' : ''}"
             data-foundation-choice="none"
             data-foundation-type="${noFoundationType}">
        <input type="radio" name="underbed" value=""
               data-foundation-choice="none"
               data-foundation-type="${noFoundationType}"
               data-price="0"
               ${checked ? 'checked' : ''}
               class="foundation-input">
        <span class="foundation-indicator"></span>
        <div class="foundation-content">
          <p class="foundation-title ${checked ? 'pdp-text-color' : ''}">${escapeHtmlText(title)}</p>
          <p class="foundation-subtitle" style="color: #666;">${escapeHtmlText(subtitle)}</p>
        </div>
        <p class="foundation-price foundation-price--no-foundation ${checked ? 'pdp-text-color' : ''}" data-no-foundation-price>${formatMoney(0)}</p>
      </label>
    `;
  }

  function buildUnderbedCollectionOptionHtml(product, checked) {
    const selectedSize = getCurrentMattressSizeValue();
    const sizeMatchedVariant = resolveUnderbedVariantForCurrentSize(product, !!selectedSize);
    const hasSizeMatch = !!sizeMatchedVariant;
    const isAvailable = selectedSize
      ? hasSizeMatch && isVariantSellable(sizeMatchedVariant)
      : !!(product.variants && product.variants.some(isVariantSellable));
    const price = sizeMatchedVariant && typeof sizeMatchedVariant.price === 'number'
      ? sizeMatchedVariant.price
      : (typeof product.price === 'number' ? product.price : 0);
    const subtitle = selectedSize && !hasSizeMatch
      ? suavePdpT('notAvailableInSize', 'Not available in selected size')
      : `Select ${product.title} model for your bed setup.`;
    const foundationType = product.title || '';
    return `
      <label class="foundation-option underbed-option${checked ? ' selected' : ''}${selectedSize && !isAvailable ? ' out-of-stock' : ''}"
             data-underbed-handle="${escapeAttr(product.handle)}"
             data-foundation-type="${escapeAttr(foundationType)}">
        ${selectedSize && !isAvailable ? '<span class="out-of-stock-badge">' + suavePdpT('notAvailable', 'Not Available') + '</span>' : ''}
        <input type="radio" name="underbed" value="${escapeAttr(product.handle)}"
               data-underbed-product-id="${escapeAttr(product.id)}"
               data-foundation-type="${escapeAttr(foundationType)}"
               data-underbed-variant-id="${sizeMatchedVariant ? escapeAttr(sizeMatchedVariant.id) : ''}"
               data-price="${price}"
               ${checked ? 'checked' : ''} class="foundation-input">
        <span class="foundation-indicator"></span>
        <div class="foundation-content">
          <p class="foundation-title ${checked ? 'pdp-text-color' : ''}">${escapeHtmlText(product.title)}</p>
          <p class="foundation-subtitle" style="color: ${selectedSize && !isAvailable ? '#ff4444' : '#666'};">
            ${escapeHtmlText(subtitle)}
          </p>
        </div>
        <p class="foundation-price ${checked ? 'pdp-text-color' : ''}">${selectedSize && !isAvailable ? suavePdpT('notAvailable', 'Not Available') : (price > 0 ? '+' + formatMoney(price) : formatMoney(price))}</p>
      </label>
    `;
  }

  function refreshUnderbedCollectionCardPrices() {
    const cfg = getUnderbedConfig();
    const container = document.getElementById('foundation-options-container');
    if (!cfg || !cfg.products || !container) return;

    container.querySelectorAll('.underbed-option').forEach((cardEl) => {
      const handle = cardEl.getAttribute('data-underbed-handle') || '';
      if (!handle) return;
      const product = cfg.products.find((p) => p && p.handle === handle);
      if (!product) return;

      const selectedSize = getCurrentMattressSizeValue();
      const variant = resolveUnderbedVariantForCurrentSize(product, !!selectedSize);
      const price = variant && typeof variant.price === 'number'
        ? variant.price
        : (typeof product.price === 'number' ? product.price : 0);
      const isAvailable = selectedSize
        ? !!(variant && isVariantSellable(variant))
        : !!(product.variants && product.variants.some(isVariantSellable));

      const input = cardEl.querySelector('input[name="underbed"]');
      if (input) {
        input.setAttribute('data-price', String(price));
        input.setAttribute('data-underbed-variant-id', variant ? String(variant.id) : '');
        input.removeAttribute('disabled');
      }

      const subtitleEl = cardEl.querySelector('.foundation-subtitle');
      if (subtitleEl) {
        subtitleEl.textContent = selectedSize && !isAvailable
          ? suavePdpT('notAvailableInSize', 'Not available in selected size')
          : `Select ${product.title} model for your bed setup.`;
        subtitleEl.style.color = selectedSize && !isAvailable ? '#ff4444' : '#666';
      }

      const priceEl = cardEl.querySelector('.foundation-price');
      if (priceEl) {
        priceEl.textContent = selectedSize && !isAvailable
          ? suavePdpT('notAvailable', 'Not Available')
          : (price > 0 ? '+' + formatMoney(price) : formatMoney(price));
      }

      cardEl.classList.toggle('out-of-stock', selectedSize && !isAvailable);

      const badge = cardEl.querySelector('.out-of-stock-badge');
      if (selectedSize && !isAvailable) {
        if (!badge) {
          const span = document.createElement('span');
          span.className = 'out-of-stock-badge';
          span.textContent = suavePdpT('notAvailable', 'Not Available');
          cardEl.insertBefore(span, cardEl.firstChild);
        }
      } else if (badge) {
        badge.remove();
      }
    });

    const selectedUnderbedInput = getSelectedUnderbedInput();
    if (selectedUnderbedInput) {
      syncCurrentFoundationFromUnderbedInput(selectedUnderbedInput);
    }
  }

  function attachUnderbedFoundationListeners(foundationContainer) {
    foundationContainer.querySelectorAll('.underbed-option').forEach((optionEl) => {
      optionEl.addEventListener('click', function (event) {
        const handle = this.getAttribute('data-underbed-handle') || '';
        if (!handle) return;

        const input = this.querySelector('input[name="underbed"]');
        if (!input) return;

        const selectedSize = getCurrentMattressSizeValue();
        if (selectedSize && !input.getAttribute('data-underbed-variant-id')) {
          return;
        }

        const wasSelected = this.classList.contains('selected');
        if (wasSelected) {
          event.preventDefault();
          event.stopPropagation();
          clearUnderbedSelection(foundationContainer);
          syncMattressModelFromUnderbedSelection();
          updateVariantNameDisplay();
          updateButtonStates();
          updateTotalPrice();
          return;
        }

        event.preventDefault();
        const cfg = getUnderbedConfig();
        const product = cfg && cfg.products ? cfg.products.find((p) => p.handle === handle) : null;
        selectedUnderbedProduct = product || { handle: handle };
        selectedFoundationType = product && product.title ? String(product.title).trim() : handle;
        selectedModelValue = '';
        foundationContainer.querySelectorAll('input[name="underbed"]').forEach((i) => { i.checked = false; });
        selectFoundationOptionElement(this, foundationContainer);
        input.checked = true;
        syncCurrentFoundationFromUnderbedInput(input);
        syncMattressModelFromUnderbedSelection();
        updateVariantNameDisplay();
        updateButtonStates();
        updateTotalPrice();
      });
    });
  }

  /** Collection bases only — optional add-ons; default cart model is No Foundation. */
  function renderUnderbedFoundationSection() {
    const cfg = getUnderbedConfig();
    const foundationContainer = document.getElementById('foundation-options-container');
    if (!cfg || !cfg.products.length || !foundationContainer) return false;

    let html = '';
    cfg.products.forEach((product) => {
      html += buildUnderbedCollectionOptionHtml(product, false);
    });

    foundationContainer.innerHTML = html;
    clearUnderbedSelection(foundationContainer);

    attachUnderbedFoundationListeners(foundationContainer);
    refreshUnderbedCollectionCardPrices();
    syncMattressModelFromUnderbedSelection();
    return true;
  }

  // Function to load foundation options for a mattress product
  async function loadFoundationOptions(mattressProductHandle) {
    const foundationContainer = document.getElementById('foundation-options-container');
    
    if (!foundationContainer) {
      return;
    }
    
    // Show loading state
    foundationContainer.innerHTML = '<p class="no-foundation-options">' + suavePdpT('loadingFoundation', 'Loading foundation options...') + '</p>';
    
    try {
      let productForFoundation = resolveMattressProductForFoundation(mattressProductHandle);
      if (!productForFoundation && mattressProductHandle) {
        try {
          const response = await fetch(suavePdpProductJsonUrl(mattressProductHandle));
          if (response.ok) {
            productForFoundation = await response.json();
          }
        } catch (fetchErr) {
          console.warn('Could not fetch mattress for foundation options:', fetchErr);
        }
      }

      // Underbed collection: optional base add-ons from collection (no "No Foundation" card)
      if (renderUnderbedFoundationSection()) {
        return;
      }

      // Mattress variant "model" dimension when no underbed collection is configured
      if (productForFoundation) {
        const renderedModels = renderModelOptionsForCurrentProduct(productForFoundation);
        if (renderedModels) {
          return;
        }
      }

      // METHOD 1: Try to get foundation product from active tab data attribute FIRST
      const activeTab = document.querySelector('#custom-product-container .tab.active');
      let foundationProductHandle = null;
      
      if (activeTab) {
        const tabFoundationProduct = activeTab.getAttribute('data-foundation-product');
        if (tabFoundationProduct && tabFoundationProduct !== '' && tabFoundationProduct !== 'null') {
          foundationProductHandle = tabFoundationProduct;
        }
      }
      
      // METHOD 2: If not in tab data, try metafield
      if (!foundationProductHandle) {
        foundationProductHandle = await getFoundationProductFromMetafield(mattressProductHandle);
      }
      
      // METHOD 3: Fallback to section settings
      if (!foundationProductHandle || foundationProductHandle === '' || foundationProductHandle === 'null') {
        // eslint-disable-next-line no-unused-vars -- Liquid replaced at build/render
        const defaultFoundationProduct = typeof window.__SECTION_FOUNDATION_PRODUCT__ !== 'undefined' ? window.__SECTION_FOUNDATION_PRODUCT__ : null;
        if (defaultFoundationProduct && defaultFoundationProduct !== '') {
          foundationProductHandle = defaultFoundationProduct;
        }
      }
      
      // If we found a foundation product, load it
      if (foundationProductHandle && foundationProductHandle !== '' && foundationProductHandle !== 'null') {
        await loadFoundationProduct(foundationProductHandle);
      } else {
        foundationContainer.innerHTML = '<p class="no-foundation-options">' + suavePdpT('noFoundationOptions', 'No foundation options available for this mattress.') + '</p>';
      }
      
    } catch (error) {
      console.error('💥 Error loading foundation options:', error);
      foundationContainer.innerHTML = '<p class="no-foundation-options">' + suavePdpT('unableLoadFoundation', 'Unable to load foundation options.') + '</p>';
    }
  }
  
  // Function to merge foundation metafields from data attributes
  function mergeFoundationMetafields(foundationProduct) {
    // Get active tab to find foundation metafields
    const activeTab = document.querySelector('#custom-product-container .tab.active');
    if (!activeTab || !foundationProduct || !foundationProduct.variants) return foundationProduct;
    
    // Get foundation metafields from data attribute
    const foundationMetafieldsData = activeTab.getAttribute('data-foundation-variant-metafields');
    
    if (foundationMetafieldsData) {
      // Parse metafields data: format is "variantId:field1|field2|field3||variantId2:..."
      const variantMetafields = foundationMetafieldsData.split('||');
      
      // Create a map of variant ID to its index in the foundation product
      const variantIndexMap = {};
      foundationProduct.variants.forEach((v, index) => {
        variantIndexMap[v.id.toString()] = index;
      });
      
      variantMetafields.forEach((variantData) => {
        if (variantData) {
          const [variantId, metafields] = variantData.split(':');
          if (variantId && metafields) {
            const fields = metafields.split('|');
            const variant = foundationProduct.variants.find(v => v.id.toString() === variantId);
            const variantIndex = variantIndexMap[variantId];
            
            if (variant && variantIndex !== undefined) {
              if (!variant.metafields) variant.metafields = {};
              if (!variant.metafields.custom) variant.metafields.custom = {};
              
              // Set only the metafield that corresponds to this variant's index (0, 1, 2)
              // Variant at index 0 gets foundation_product_variant_metafield
              // Variant at index 1 gets foundation_product_variant_metafield_2
              // Variant at index 2 gets foundation_product_variant_metafield_3
              if (variantIndex === 0 && fields[0] && fields[0].trim() !== '') {
                variant.metafields.custom.foundation_product_variant_metafield = fields[0];
              } else if (variantIndex === 1 && fields[1] && fields[1].trim() !== '') {
                variant.metafields.custom.foundation_product_variant_metafield_2 = fields[1];
              } else if (variantIndex === 2 && fields[2] && fields[2].trim() !== '') {
                variant.metafields.custom.foundation_product_variant_metafield_3 = fields[2];
              } else {
                // Fallback: try to find any non-empty metafield for this variant
                const availableField = fields.find(f => f && f.trim() !== '');
                if (availableField) {
                  if (variantIndex === 0) {
                    variant.metafields.custom.foundation_product_variant_metafield = availableField;
                  } else if (variantIndex === 1) {
                    variant.metafields.custom.foundation_product_variant_metafield_2 = availableField;
                  } else if (variantIndex === 2) {
                    variant.metafields.custom.foundation_product_variant_metafield_3 = availableField;
                  }
                }
              }
            }
          }
        }
      });
    }
    
    return foundationProduct;
  }

  function escapeAttr(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  }

  function escapeHtmlText(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

// Function to load foundation product - UPDATED with flexible image matching
async function loadFoundationProduct(foundationProductHandle) {
  const foundationContainer = document.getElementById('foundation-options-container');
  
  if (!foundationContainer) return;
  
  selectedFoundationType = null;
  
  try {
    // Fetch foundation product data
    const response = await fetch(suavePdpProductJsonUrl(foundationProductHandle));
    if (!response.ok) {
      throw new Error(`Failed to fetch foundation product: ${response.status}`);
    }
    
    let foundationProduct = await response.json();
    
    // First try to merge from data attributes (faster, more reliable)
    foundationProduct = mergeFoundationMetafields(foundationProduct);
    
    // Then try to fetch from API as fallback
    foundationProduct = await fetchFoundationVariantMetafields(foundationProduct);
    
    // Ensure handle is set
    if (!foundationProduct.handle) {
      foundationProduct.handle = foundationProductHandle;
    }
    currentFoundationProduct = foundationProduct;
    
    if (!foundationProduct.variants || foundationProduct.variants.length === 0) {
      foundationContainer.innerHTML = '<p class="no-foundation-options">' + suavePdpT('noFoundationVariants', 'No foundation variants available.') + '</p>';
      if (typeof window.rebuildCustomDropdown === 'function') {
        window.rebuildCustomDropdown();
      }
      return;
    }
    
    // Ensure firmness header title is set correctly
    const firmnessTitleElement = document.querySelector('#firmness-section .section-title');
    if (firmnessTitleElement) {
      firmnessTitleElement.textContent = suavePdpT('chooseComfort', 'Choose your comfort preference.');
      currentFirmnessTitle = suavePdpT('chooseComfort', 'Choose your comfort preference.');
    }
    
    let foundationHTML = '';
    let hasAvailableVariant = false;
    let firstAvailableVariantIndex = -1;
    
    // Get the active tab to find which mattress product's foundation metafields to use
    const activeTab = document.querySelector('#custom-product-container .tab.active');
    const mattressProductHandle = activeTab ? activeTab.getAttribute('data-product-handle') : null;
    
    // Foundation product with 2 options: Size (hidden) + Foundation Type. Show one option per Foundation Type; size syncs with mattress size.
    const hasTwoOptions = foundationProduct.options && foundationProduct.options.length >= 2;
    // Foundation product with only size variants: hide size, show 3 "foundation type" options (Breeze etc.); variant = mattress size.
    const hasOneOption = foundationProduct.options && foundationProduct.options.length === 1;
    const currentSizeValue = getCurrentMattressSizeValue();
    
    if (hasOneOption) {
      // Size-only foundation: show 3 foundation type options (labels from tab metafields); actual variant = by mattress size
      const metafieldsRaw = activeTab ? activeTab.getAttribute('data-foundation-variant-metafields') : '';
      const typeLabels = [];
      const subtitleMetafieldsOne = [];
      if (metafieldsRaw) {
        const entries = metafieldsRaw.split('||').filter(Boolean);
        for (let i = 0; i < 3 && i < entries.length; i++) {
          const part = entries[i].split(':');
          const label = (part[1] != null ? part[1] : '').trim();
          if (label) typeLabels.push(label);
          subtitleMetafieldsOne.push((part[1] != null ? part[1] : '').toString().trim());
        }
      }
      if (typeLabels.length === 0) {
        typeLabels.push('Foundation 1', 'Foundation 2', 'Foundation 3');
      }
      const resolvedVariant = getFoundationVariantBySize(foundationProduct, currentSizeValue);
      const displayVariant = resolvedVariant || null;
      typeLabels.forEach(function (label, typeIndex) {
        const variant = resolvedVariant;
        const sizeMismatch = !variant;
        if (sizeMismatch) {
          let mismatchSubtitle = (subtitleMetafieldsOne[typeIndex] != null ? subtitleMetafieldsOne[typeIndex] : '').toString().trim();
          if (!mismatchSubtitle && metafieldsRaw && mattressProductHandle && foundationMetafieldsByProduct) {
            const entries = metafieldsRaw.split('||').filter(Boolean);
            if (entries[typeIndex]) {
              const variantId = entries[typeIndex].split(':')[0];
              if (variantId) {
                const foundationMap = foundationMetafieldsByProduct.get(mattressProductHandle);
                const mf = foundationMap ? foundationMap.get(variantId.trim()) : null;
                if (mf) {
                  mismatchSubtitle = (mf.value && mf.value.trim() !== '') ? mf.value.trim() : (mf.foundation_product_variant_metafield || mf.foundation_product_variant_metafield_2 || mf.foundation_product_variant_metafield_3 || '');
                }
              }
            }
          }
          if (!mismatchSubtitle) {
            const fallbackV = foundationProduct.variants[typeIndex] || foundationProduct.variants[0];
            mismatchSubtitle = fallbackV ? (fallbackV.title || '') : '';
          }
          const badgeHtml = '<span class="out-of-stock-badge foundation-size-na-badge">' + suavePdpT('notAvailable', 'Not Available') + '</span>';
          foundationHTML += `
          <label class="foundation-option foundation-option-size-synced size-unavailable out-of-stock" 
                 data-foundation-type="${(label || '').replace(/"/g, '&quot;')}"
                 data-foundation-subtitle-default="${escapeAttr(mismatchSubtitle)}"
                 data-variant-id=""
                 data-variant-title="${(label || 'Foundation').replace(/"/g, '&quot;')}"
                 data-variant-price="0"
                 data-variant-compare-price=""
                 data-variant-available="false"
                 data-size-mismatch="true"
                 data-variant-inventory="0"
                 data-variant-inventory-policy="deny"
                 data-variant-inventory-management="shopify"
                 data-variant-image=""
                 data-variant-alt="${(label || '') + ' - ' + (foundationProduct.title || '')}"
                 data-product-handle="${foundationProduct.handle}"
                 data-product-title="${foundationProduct.title}">
            ${badgeHtml}
            <input type="radio" name="foundation" value=""
                   data-foundation-type="${(label || '').replace(/"/g, '&quot;')}"
                   data-variant-id="" data-product-id="${foundationProduct.id}" data-product-handle="${foundationProduct.handle}" data-product-title="${(foundationProduct.title || '').replace(/"/g, '&quot;')}"
                   data-price="0" data-variant-title="${(label || 'Foundation').replace(/"/g, '&quot;')}"
                   data-variant-available="false" data-variant-inventory="0"
                   data-variant-inventory-policy="deny" data-variant-inventory-management="shopify"
                   disabled class="foundation-input">
            <span class="foundation-indicator"></span>
            <div class="foundation-content">
              <p class="foundation-title">${(label || 'Foundation').replace(/</g, '&lt;')}</p>
              <p class="foundation-subtitle" style="color: #666;">
                ${escapeHtmlText(mismatchSubtitle)}
              </p>
            </div>
            <p class="foundation-price">—</p>
          </label>
        `;
          return;
        }
        const variantId = variant.id.toString();
        // Option 1 → foundation_product_variant_metafield, option 2 → _2, option 3 → _3
        let foundationMetafieldText = (subtitleMetafieldsOne[typeIndex] != null ? subtitleMetafieldsOne[typeIndex] : '').toString().trim();
        if (!foundationMetafieldText && mattressProductHandle && foundationMetafieldsByProduct) {
          const foundationMap = foundationMetafieldsByProduct.get(mattressProductHandle);
          if (foundationMap) {
            const metafields = foundationMap.get(variantId);
            if (metafields) {
              const v = (metafields.value && metafields.value.trim() !== '') ? metafields.value.trim() : (metafields.foundation_product_variant_metafield || metafields.foundation_product_variant_metafield_2 || metafields.foundation_product_variant_metafield_3 || '');
              if (v) foundationMetafieldText = v;
            }
          }
        }
        let isAvailable = false;
        if (variant.available === true) isAvailable = true;
        else if (variant.inventory_policy === 'continue') isAvailable = true;
        else if (variant.inventory_quantity != null && variant.inventory_quantity > 0) isAvailable = true;
        else if (variant.inventory_management == null && variant.available !== false) isAvailable = true;
        if (isAvailable && firstAvailableVariantIndex === -1) { firstAvailableVariantIndex = typeIndex; hasAvailableVariant = true; }
        const hasFeaturedImage = (displayVariant && displayVariant.featured_image && displayVariant.featured_image.src) || (variant.featured_image && variant.featured_image.src);
        const isFirstAvailable = typeIndex === firstAvailableVariantIndex && isAvailable;
        foundationHTML += `
          <label class="foundation-option foundation-option-size-synced${isFirstAvailable ? ' selected' : ''}${!isAvailable ? ' out-of-stock' : ''}" 
                 data-foundation-type="${(label || '').replace(/"/g, '&quot;')}"
                 data-foundation-subtitle-default="${escapeAttr(foundationMetafieldText)}"
                 data-variant-id="${variant.id}" 
                 data-variant-title="${(label || variant.title || 'Default Title').replace(/"/g, '&quot;')}"
                 data-variant-price="${variant.price || 0}"
                 data-variant-compare-price="${variant.compare_at_price || ''}"
                 data-variant-available="${isAvailable}"
                 data-variant-inventory="${variant.inventory_quantity || 0}"
                 data-variant-inventory-policy="${variant.inventory_policy || 'deny'}"
                 data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                 data-variant-image="${hasFeaturedImage ? (variant.featured_image && variant.featured_image.src ? variant.featured_image.src : (displayVariant && displayVariant.featured_image && displayVariant.featured_image.src) || '') : ''}"
                 data-variant-alt="${(label || '') + ' - ' + (foundationProduct.title || '')}"
                 data-product-handle="${foundationProduct.handle}"
                 data-product-title="${foundationProduct.title}">
            ${!isAvailable ? '<span class="out-of-stock-badge">Out of Stock</span>' : ''}
            <input type="radio" name="foundation" value="${variant.id}" 
                   data-foundation-type="${(label || '').replace(/"/g, '&quot;')}"
                   data-variant-id="${variant.id}" data-product-id="${foundationProduct.id}" data-product-handle="${foundationProduct.handle}" data-product-title="${(foundationProduct.title || '').replace(/"/g, '&quot;')}"
                   data-price="${variant.price || 0}" data-variant-title="${(label || variant.title || 'Default Title').replace(/"/g, '&quot;')}"
                   data-variant-available="${isAvailable}" data-variant-inventory="${variant.inventory_quantity || 0}"
                   data-variant-inventory-policy="${variant.inventory_policy || 'deny'}" data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                   ${isFirstAvailable ? 'checked' : ''} class="foundation-input" ${!isAvailable ? 'disabled' : ''}>
            <span class="foundation-indicator"></span>
            <div class="foundation-content">
              <p class="foundation-title ${isFirstAvailable ? 'pdp-text-color' : ''}">${(label || 'Foundation').replace(/</g, '&lt;')}</p>
              <p class="foundation-subtitle" style="color: ${isAvailable ? '#666' : '#ff4444'};">
                ${(isAvailable ? foundationMetafieldText : suavePdpT('outOfStock', 'Out of Stock')).replace(/</g, '&lt;')}
              </p>
            </div>
            <p class="foundation-price ${isFirstAvailable ? 'pdp-text-color' : ''}">${(variant.price && variant.price > 0) ? '+' + formatMoney(variant.price) : formatMoney(variant.price || 0)}</p>
          </label>
        `;
      });
    } else if (hasTwoOptions) {
      // Option1 = Foundation Type (No foundation, Base, Adjustable, etc.), Option2 = Size. Show only Foundation Type; size syncs with mattress.
      // Subtitle: option 1 → foundation_product_variant_metafield, option 2 → _2, option 3 → _3 (from tab data-foundation-variant-metafields: first 3 variant values)
      const foundationVariantMetafieldsRaw = activeTab ? activeTab.getAttribute('data-foundation-variant-metafields') : '';
      const subtitleMetafields = [];
      if (foundationVariantMetafieldsRaw) {
        const entries = foundationVariantMetafieldsRaw.split('||').filter(Boolean);
        for (let i = 0; i < 3 && i < entries.length; i++) {
          const part = entries[i].split(':');
          const val = (part[1] != null ? part[1] : '').toString().trim();
          subtitleMetafields.push(val);
        }
      }
      const foundationTypes = [...new Set(foundationProduct.variants.map(function (v) {
        return (v.option1 || (v.options && v.options[0]) || '').toString().trim();
      }).filter(Boolean))];
      foundationTypes.forEach(function (foundationType, typeIndex) {
        const variant = getFoundationVariantBySizeAndType(foundationProduct, currentSizeValue, foundationType);
        const sizeMismatch = !variant;
        if (sizeMismatch) {
          let mismatchSubtitle = (subtitleMetafields[typeIndex] != null ? subtitleMetafields[typeIndex] : '').toString().trim();
          const anyForType = getFirstVariantForFoundationType(foundationProduct, foundationType);
          if (!mismatchSubtitle && anyForType && mattressProductHandle && foundationMetafieldsByProduct) {
            const foundationMap = foundationMetafieldsByProduct.get(mattressProductHandle);
            const mf = foundationMap ? foundationMap.get(anyForType.id.toString()) : null;
            if (mf) {
              mismatchSubtitle = (mf.value && mf.value.trim() !== '') ? mf.value.trim() : (mf.foundation_product_variant_metafield || mf.foundation_product_variant_metafield_2 || mf.foundation_product_variant_metafield_3 || '');
            }
          }
          if (!mismatchSubtitle && anyForType) {
            mismatchSubtitle = anyForType.title || '';
          }
          const badgeHtml = '<span class="out-of-stock-badge foundation-size-na-badge">' + suavePdpT('notAvailable', 'Not Available') + '</span>';
          foundationHTML += `
          <label class="foundation-option size-unavailable out-of-stock" 
                 data-foundation-type="${(foundationType || '').replace(/"/g, '&quot;')}"
                 data-foundation-subtitle-default="${escapeAttr(mismatchSubtitle)}"
                 data-variant-id=""
                 data-variant-title="${(foundationType || 'Default Title').replace(/"/g, '&quot;')}"
                 data-variant-price="0"
                 data-variant-compare-price=""
                 data-variant-available="false"
                 data-size-mismatch="true"
                 data-variant-inventory="0"
                 data-variant-inventory-policy="deny"
                 data-variant-inventory-management="shopify"
                 data-variant-image=""
                 data-variant-alt="${(foundationType || '') + ' - ' + (foundationProduct.title || '')}"
                 data-product-handle="${foundationProduct.handle}"
                 data-product-title="${foundationProduct.title}">
            ${badgeHtml}
            <input type="radio" name="foundation" value=""
                   data-foundation-type="${(foundationType || '').replace(/"/g, '&quot;')}"
                   data-variant-id="" data-product-id="${foundationProduct.id}" data-product-handle="${foundationProduct.handle}" data-product-title="${(foundationProduct.title || '').replace(/"/g, '&quot;')}"
                   data-price="0" data-variant-title="${(foundationType || 'Default Title').replace(/"/g, '&quot;')}"
                   data-variant-available="false" data-variant-inventory="0"
                   data-variant-inventory-policy="deny" data-variant-inventory-management="shopify"
                   disabled class="foundation-input">
            <span class="foundation-indicator"></span>
            <div class="foundation-content">
              <p class="foundation-title">${(foundationType || 'Default Title').replace(/</g, '&lt;')}</p>
              <p class="foundation-subtitle" style="color: #666;">
                ${escapeHtmlText(mismatchSubtitle)}
              </p>
            </div>
            <p class="foundation-price">—</p>
          </label>
        `;
          return;
        }
        const variantId = variant.id.toString();
        // Option 1 (typeIndex 0) → foundation_product_variant_metafield, option 2 → _2, option 3 → _3
        let foundationMetafieldText = (subtitleMetafields[typeIndex] != null ? subtitleMetafields[typeIndex] : '').toString().trim();
        if (!foundationMetafieldText && foundationMetafieldsByProduct) {
          const foundationMap = mattressProductHandle ? foundationMetafieldsByProduct.get(mattressProductHandle) : null;
          if (foundationMap) {
            const metafields = foundationMap.get(variantId);
            if (metafields) {
              foundationMetafieldText = (metafields.value && metafields.value.trim() !== '') ? metafields.value.trim() : (metafields.foundation_product_variant_metafield || metafields.foundation_product_variant_metafield_2 || metafields.foundation_product_variant_metafield_3 || '');
            }
          }
        }
        if (!foundationMetafieldText || foundationMetafieldText.trim() === '') foundationMetafieldText = variant.title || '';
        let isAvailable = false;
        if (variant.available === true) isAvailable = true;
        else if (variant.inventory_policy === 'continue') isAvailable = true;
        else if (variant.inventory_quantity != null && variant.inventory_quantity > 0) isAvailable = true;
        else if (variant.inventory_management == null && variant.available !== false) isAvailable = true;
        if (isAvailable && firstAvailableVariantIndex === -1) { firstAvailableVariantIndex = typeIndex; hasAvailableVariant = true; }
        const hasFeaturedImage = variant.featured_image && variant.featured_image.src;
        const isFirstAvailable = typeIndex === firstAvailableVariantIndex && isAvailable;
        foundationHTML += `
          <label class="foundation-option${isFirstAvailable ? ' selected' : ''}${!isAvailable ? ' out-of-stock' : ''}" 
                 data-foundation-type="${(foundationType || '').replace(/"/g, '&quot;')}"
                 data-foundation-subtitle-default="${escapeAttr(foundationMetafieldText)}"
                 data-variant-id="${variant.id}" 
                 data-variant-title="${(variant.title || 'Default Title').replace(/"/g, '&quot;')}"
                 data-variant-price="${variant.price || 0}"
                 data-variant-compare-price="${variant.compare_at_price || ''}"
                 data-variant-available="${isAvailable}"
                 data-variant-inventory="${variant.inventory_quantity || 0}"
                 data-variant-inventory-policy="${variant.inventory_policy || 'deny'}"
                 data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                 data-variant-image="${hasFeaturedImage ? variant.featured_image.src : ''}"
                 data-variant-alt="${(variant.title || '') + ' - ' + (foundationProduct.title || '')}"
                 data-product-handle="${foundationProduct.handle}"
                 data-product-title="${foundationProduct.title}">
            ${!isAvailable ? '<span class="out-of-stock-badge">Out of Stock</span>' : ''}
            <input type="radio" name="foundation" value="${variant.id}" 
                   data-foundation-type="${(foundationType || '').replace(/"/g, '&quot;')}"
                   data-variant-id="${variant.id}" data-product-id="${foundationProduct.id}" data-product-handle="${foundationProduct.handle}" data-product-title="${(foundationProduct.title || '').replace(/"/g, '&quot;')}"
                   data-price="${variant.price || 0}" data-variant-title="${(variant.title || 'Default Title').replace(/"/g, '&quot;')}"
                   data-variant-available="${isAvailable}" data-variant-inventory="${variant.inventory_quantity || 0}"
                   data-variant-inventory-policy="${variant.inventory_policy || 'deny'}" data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                   ${isFirstAvailable ? 'checked' : ''} class="foundation-input" ${!isAvailable ? 'disabled' : ''}>
            <span class="foundation-indicator"></span>
            <div class="foundation-content">
              <p class="foundation-title ${isFirstAvailable ? 'pdp-text-color' : ''}">${(foundationType || variant.title || 'Default Title').replace(/</g, '&lt;')}</p>
              <p class="foundation-subtitle" style="color: ${isAvailable ? '#666' : '#ff4444'};">
                ${(isAvailable ? foundationMetafieldText : suavePdpT('outOfStock', 'Out of Stock')).replace(/</g, '&lt;')}
              </p>
            </div>
            <p class="foundation-price ${isFirstAvailable ? 'pdp-text-color' : ''}">${(variant.price && variant.price > 0) ? '+' + formatMoney(variant.price) : formatMoney(variant.price || 0)}</p>
          </label>
        `;
      });
    } else {
      foundationProduct.variants.forEach((variant, index) => {
        // Get foundation variant metafields from global map
        let foundationMetafieldText = '';
        const variantId = variant.id.toString();
        
        // Get the foundation metafields map for the mattress product (not foundation product)
        // The foundation metafields are stored under the mattress product handle
        const foundationMap = mattressProductHandle ? foundationMetafieldsByProduct.get(mattressProductHandle) : null;
        
        if (foundationMap) {
          const metafields = foundationMap.get(variantId);
          if (metafields) {
            // Use the 'value' property first - it contains the actual metafield text for this variant
            // This is more reliable than checking position-specific properties
            foundationMetafieldText = (metafields.value && metafields.value.trim() !== '') ? metafields.value.trim() : '';
            
            // If value is empty, try position-specific properties as fallback
            if (!foundationMetafieldText) {
              if (index === 0) {
                foundationMetafieldText = metafields.foundation_product_variant_metafield || '';
              } else if (index === 1) {
                foundationMetafieldText = metafields.foundation_product_variant_metafield_2 || '';
              } else if (index === 2) {
                foundationMetafieldText = metafields.foundation_product_variant_metafield_3 || '';
              }
            }
          }
        }
        
        // If no metafield found, use variant title as fallback
        if (!foundationMetafieldText || foundationMetafieldText.trim() === '') {
          foundationMetafieldText = variant.title || '';
        }
        
        // Check availability
        let isAvailable = false;
        let availabilityText = suavePdpT('inStock', 'In Stock');
        
        if (variant.available === true) {
          isAvailable = true;
        } else if (variant.inventory_policy === 'continue') {
          isAvailable = true;
          availabilityText = suavePdpT('availableBackorder', 'Available for Backorder');
        } else if (variant.inventory_quantity !== null && variant.inventory_quantity > 0) {
          isAvailable = true;
          if (variant.inventory_quantity < 10) {
            availabilityText = `Only ${variant.inventory_quantity} left`;
          }
        } else if (variant.inventory_management === null && variant.available !== false) {
          isAvailable = true;
        }
        
        if (isAvailable && firstAvailableVariantIndex === -1) {
          firstAvailableVariantIndex = index;
          hasAvailableVariant = true;
        }
        
        // Get ALL matching images for this variant using flexible matching
        // Check if variant has a featured image
        const hasFeaturedImage = variant.featured_image && variant.featured_image.src;
        
        foundationHTML += `
          <label class="foundation-option${index === firstAvailableVariantIndex && isAvailable ? ' selected' : ''}${!isAvailable ? ' out-of-stock' : ''}" 
                 data-variant-id="${variant.id}" 
                 data-variant-title="${variant.title || 'Default Title'}"
                 data-variant-price="${variant.price || 0}"
                 data-variant-compare-price="${variant.compare_at_price || ''}"
                 data-variant-available="${isAvailable}"
                 data-variant-inventory="${variant.inventory_quantity || 0}"
                 data-variant-inventory-policy="${variant.inventory_policy || 'deny'}"
                 data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                 data-variant-image="${hasFeaturedImage ? variant.featured_image.src : ''}"
                 data-variant-alt="${variant.title || ''} - ${foundationProduct.title}"
                 data-product-handle="${foundationProduct.handle}"
                 data-product-title="${foundationProduct.title}">
            ${!isAvailable ? '<span class="out-of-stock-badge">Out of Stock</span>' : ''}
            
            <input type="radio" 
                   name="foundation" 
                   value="${variant.id}" 
                   data-variant-id="${variant.id}" 
                   data-product-id="${foundationProduct.id}" 
                   data-product-handle="${foundationProduct.handle}" 
                   data-product-title="${foundationProduct.title}" 
                   data-product-description="${foundationProduct.description ? foundationProduct.description.replace(/"/g, '&quot;') : ''}" 
                   data-price="${variant.price || 0}" 
                   data-variant-title="${variant.title || 'Default Title'}"
                   data-variant-available="${isAvailable}"
                   data-variant-inventory="${variant.inventory_quantity || 0}"
                   data-variant-inventory-policy="${variant.inventory_policy || 'deny'}"
                   data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                   ${index === firstAvailableVariantIndex && isAvailable ? 'checked' : ''}
                   class="foundation-input"
                   ${!isAvailable ? 'disabled' : ''}>
            
            <span class="foundation-indicator"></span>
            <div class="foundation-content">
              <p class="foundation-title ${index === firstAvailableVariantIndex && isAvailable ? 'pdp-text-color' : ''}">
                ${variant.title || 'Default Title'}
              </p>
              <p class="foundation-subtitle" style="color: ${isAvailable ? '#666' : '#ff4444'};">
                ${isAvailable ? foundationMetafieldText : suavePdpT('outOfStock', 'Out of Stock')}
              </p>
            </div>
            <p class="foundation-price ${index === firstAvailableVariantIndex && isAvailable ? 'pdp-text-color' : ''}">${(variant.price && variant.price > 0) ? '+' + formatMoney(variant.price) : formatMoney(variant.price || 0)}</p>
          </label>
        `;
      });
    }
    
    // Save current scroll position to prevent auto-scroll
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    foundationContainer.innerHTML = foundationHTML;
    
    // Restore scroll position immediately and in next frame to prevent auto-scroll
    window.scrollTo(0, scrollPosition);
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollPosition);
    });
    
    // Add event listeners to foundation options
    const foundationOptions = foundationContainer.querySelectorAll('.foundation-option');
    foundationOptions.forEach(option => {
      option.addEventListener('click', function(e) {
        // Prevent default scroll behavior when clicking foundation options
        e.preventDefault();
        e.stopPropagation();
        const input = this.querySelector('input[type="radio"]');
        const liveAvailable = this.getAttribute('data-variant-available') === 'true';
        if (!liveAvailable || !input || input.disabled || !input.value) {
          return;
        }
        
        if (this.classList.contains('selected')) return;
        
        foundationOptions.forEach(opt => {
          opt.classList.remove('selected');
          const optInput = opt.querySelector('input[type="radio"]');
          if (optInput) optInput.checked = false;
          // Remove pdp-text-color class
          const optTitle = opt.querySelector('.foundation-title');
          const optPrice = opt.querySelector('.foundation-price');
          if (optTitle) optTitle.classList.remove('pdp-text-color');
          if (optPrice) optPrice.classList.remove('pdp-text-color');
        });
        
        this.classList.add('selected');
        if (input) input.checked = true;
        
        // Add pdp-text-color class to selected foundation
        const selectedTitle = this.querySelector('.foundation-title');
        const selectedPrice = this.querySelector('.foundation-price');
        if (selectedTitle) selectedTitle.classList.add('pdp-text-color');
        if (selectedPrice) selectedPrice.classList.add('pdp-text-color');

        var activeTabForFoundation = document.querySelector('#custom-product-container .tab.active');
        applyFoundationOptionTabColor(
          activeTabForFoundation ? activeTabForFoundation.getAttribute('data-tab-color') : ''
        );
        
        // Set current foundation variant
        const variantId = input.value;
        const variantPrice = this.getAttribute('data-variant-price');
        const parsedPrice = variantPrice ? parseInt(variantPrice) : 0;
        const foundationTypeVal = this.getAttribute('data-foundation-type');
        if (foundationTypeVal) selectedFoundationType = foundationTypeVal;
        
        currentFoundationVariant = {
          id: variantId,
          title: this.getAttribute('data-variant-title'),
          price: parsedPrice,
          available: liveAvailable,
          inventoryPolicy: this.getAttribute('data-variant-inventory-policy'),
          inventoryQuantity: this.getAttribute('data-variant-inventory'),
          inventoryManagement: this.getAttribute('data-variant-inventory-management')
        };
        
        // Immediately update price when foundation is selected
        updateTotalPrice();
        
        // Update variant name display (to show foundation name)
        updateVariantNameDisplay();
        
        // Store that foundation is now selected
        isFoundationSelected = true;
        
        // Handle foundation variant image changes
        // Ensure foundation product has handle before calling
        if (foundationProduct && !foundationProduct.handle) {
          const productHandle = this.getAttribute('data-product-handle');
          if (productHandle) {
            foundationProduct.handle = productHandle;
          } else if (currentFoundationProduct && currentFoundationProduct.handle) {
            foundationProduct.handle = currentFoundationProduct.handle;
          }
        }
        handleFoundationVariantImageChange(this, foundationProduct);
        
        // Update button states
        updateButtonStates();
      });
    });
    
    // Auto-select first available foundation option AND trigger image change
if (firstAvailableVariantIndex !== -1) {
  const firstAvailableFoundation = foundationContainer.querySelector(`.foundation-option:nth-child(${firstAvailableVariantIndex + 1})`);
  if (firstAvailableFoundation) {
    // Get the radio input and foundation option element
    const radioInput = firstAvailableFoundation.querySelector('input[type="radio"]');
    
    if (radioInput && firstAvailableFoundation) {
      // Programmatically check the radio button without triggering scroll
      // Prevent focus to avoid automatic scroll
      const originalTabIndex = radioInput.getAttribute('tabindex');
      radioInput.setAttribute('tabindex', '-1');
      radioInput.checked = true;
      radioInput.blur(); // Remove focus if it was gained
      if (originalTabIndex !== null) {
        radioInput.setAttribute('tabindex', originalTabIndex);
      } else {
        radioInput.removeAttribute('tabindex');
      }
      
      // Manually update the UI state without click event
      foundationOptions.forEach(opt => {
        opt.classList.remove('selected');
        const optInput = opt.querySelector('input[type="radio"]');
        if (optInput) {
          const optTabIndex = optInput.getAttribute('tabindex');
          optInput.setAttribute('tabindex', '-1');
          optInput.checked = false;
          optInput.blur();
          if (optTabIndex !== null) {
            optInput.setAttribute('tabindex', optTabIndex);
          } else {
            optInput.removeAttribute('tabindex');
          }
        }
        const optTitle = opt.querySelector('.foundation-title');
        const optPrice = opt.querySelector('.foundation-price');
        if (optTitle) optTitle.classList.remove('pdp-text-color');
        if (optPrice) optPrice.classList.remove('pdp-text-color');
      });
      
      // Set selected state
      firstAvailableFoundation.classList.add('selected');
      const selectedTitle = firstAvailableFoundation.querySelector('.foundation-title');
      const selectedPrice = firstAvailableFoundation.querySelector('.foundation-price');
      if (selectedTitle) selectedTitle.classList.add('pdp-text-color');
      if (selectedPrice) selectedPrice.classList.add('pdp-text-color');
      
      // Set current foundation variant
      const variantId = radioInput.value;
      const variantPrice = firstAvailableFoundation.getAttribute('data-variant-price');
      const parsedPrice = variantPrice ? parseInt(variantPrice) : 0;
      const isAvailable = firstAvailableFoundation.getAttribute('data-variant-available') === 'true';
      
      currentFoundationVariant = {
        id: variantId,
        title: firstAvailableFoundation.getAttribute('data-variant-title'),
        price: parsedPrice,
        available: isAvailable,
        inventoryPolicy: firstAvailableFoundation.getAttribute('data-variant-inventory-policy'),
        inventoryQuantity: firstAvailableFoundation.getAttribute('data-variant-inventory'),
        inventoryManagement: firstAvailableFoundation.getAttribute('data-variant-inventory-management')
      };
      const ft = firstAvailableFoundation.getAttribute('data-foundation-type');
      if (ft) selectedFoundationType = ft;
      
      // Update price and button states
      updateTotalPrice();
      updateVariantNameDisplay();
      isFoundationSelected = true;
      updateButtonStates();
      
      // IMPORTANT FIX: Call handleFoundationVariantImageChange for the first foundation option
      // This ensures the images load on page load, not just when user clicks
      // Ensure foundation product has handle before calling
      if (foundationProduct && !foundationProduct.handle) {
        const productHandle = firstAvailableFoundation.getAttribute('data-product-handle');
        if (productHandle) {
          foundationProduct.handle = productHandle;
        } else if (currentFoundationProduct && currentFoundationProduct.handle) {
          foundationProduct.handle = currentFoundationProduct.handle;
        }
      }
      handleFoundationVariantImageChange(firstAvailableFoundation, foundationProduct);
    }
  }
} else if (foundationOptions.length > 0) {
  // If no variants are available, select first one but don't enable it (without scroll)
  const firstOption = foundationOptions[0];
  const radioInput = firstOption.querySelector('input[type="radio"]');
  
  if (radioInput) {
    // Prevent focus to avoid automatic scroll
    const originalTabIndex = radioInput.getAttribute('tabindex');
    radioInput.setAttribute('tabindex', '-1');
    radioInput.checked = true;
    radioInput.blur(); // Remove focus if it was gained
    if (originalTabIndex !== null) {
      radioInput.setAttribute('tabindex', originalTabIndex);
    } else {
      radioInput.removeAttribute('tabindex');
    }
    firstOption.classList.add('selected');
  }
}

    if (typeof window.rebuildCustomDropdown === 'function') {
      window.rebuildCustomDropdown();
    }

    var activeTabAfterFoundation = document.querySelector('#custom-product-container .tab.active');
    applyFoundationOptionTabColor(
      activeTabAfterFoundation ? activeTabAfterFoundation.getAttribute('data-tab-color') : ''
    );

  } catch (error) {
    console.error('Error loading foundation product:', error);
    foundationContainer.innerHTML = '<p class="no-foundation-options">' + suavePdpT('unableLoadFoundation', 'Unable to load foundation options.') + '</p>';
  }
}
  
  /** When mattress size changes, update each foundation option to the variant matching mattress size (and foundation type if 2 options). Keeps same foundation type selected. */
  function syncFoundationOptionsWithMattressSize() {
    const foundationContainer = document.getElementById('foundation-options-container');
    if (!currentFoundationProduct || !currentFoundationProduct.variants || !foundationContainer) return;
    const hasTwoOptions = currentFoundationProduct.options && currentFoundationProduct.options.length >= 2;
    const hasOneOption = currentFoundationProduct.options && currentFoundationProduct.options.length === 1;
    if (!hasTwoOptions && !hasOneOption) return;
    const currentSizeValue = getCurrentMattressSizeValue();
    const options = foundationContainer.querySelectorAll('.foundation-option[data-foundation-type]');
    let previouslySelectedType = selectedFoundationType;
    let newSelectedVariant = null;
    options.forEach(function (opt) {
      const typeVal = opt.getAttribute('data-foundation-type');
      if (!typeVal) return;
      opt.querySelectorAll('.foundation-size-na-badge').forEach(function (b) {
        b.remove();
      });
      const variant = hasOneOption
        ? getFoundationVariantBySize(currentFoundationProduct, currentSizeValue)
        : getFoundationVariantBySizeAndType(currentFoundationProduct, currentSizeValue, typeVal);
      if (!variant) {
        opt.setAttribute('data-variant-id', '');
        opt.setAttribute('data-variant-title', typeVal);
        opt.setAttribute('data-variant-price', '0');
        opt.setAttribute('data-variant-available', 'false');
        opt.setAttribute('data-size-mismatch', 'true');
        opt.removeAttribute('data-variant-image');
        opt.classList.add('out-of-stock', 'size-unavailable');
        opt.classList.remove('selected');
        const input = opt.querySelector('input[name="foundation"]');
        if (input) {
          input.value = '';
          input.setAttribute('data-variant-id', '');
          input.setAttribute('data-variant-title', typeVal);
          input.setAttribute('data-variant-available', 'false');
          input.setAttribute('data-price', '0');
          input.disabled = true;
          input.checked = false;
        }
        const titleEl = opt.querySelector('.foundation-title');
        if (titleEl) {
          titleEl.textContent = typeVal;
          titleEl.classList.remove('pdp-text-color');
        }
        const priceEl = opt.querySelector('.foundation-price');
        if (priceEl) {
          priceEl.textContent = '—';
          priceEl.classList.remove('pdp-text-color');
        }
        const subEl = opt.querySelector('.foundation-subtitle');
        if (subEl) {
          let subText = opt.getAttribute('data-foundation-subtitle-default');
          if (subText == null || subText === '') {
            if (!hasOneOption) {
              const anyForType = getFirstVariantForFoundationType(currentFoundationProduct, typeVal);
              subText = anyForType ? (anyForType.title || '') : '';
            }
          }
          subEl.textContent = subText || '';
          subEl.style.color = '#666';
        }
        const naBadge = document.createElement('span');
        naBadge.className = 'out-of-stock-badge foundation-size-na-badge';
        naBadge.textContent = suavePdpT('notAvailable', 'Not Available');
        opt.insertBefore(naBadge, opt.firstChild);
        opt.querySelectorAll('.out-of-stock-badge:not(.foundation-size-na-badge)').forEach(function (b) {
          b.remove();
        });
        return;
      }
      opt.classList.remove('size-unavailable');
      opt.removeAttribute('data-size-mismatch');
      const variantId = variant.id.toString();
      let isAvailable = false;
      if (variant.available === true) isAvailable = true;
      else if (variant.inventory_policy === 'continue') isAvailable = true;
      else if (variant.inventory_quantity != null && variant.inventory_quantity > 0) isAvailable = true;
      else if (variant.inventory_management == null && variant.available !== false) isAvailable = true;
      opt.setAttribute('data-variant-id', variantId);
      opt.setAttribute('data-variant-title', (hasOneOption ? typeVal : variant.title) || 'Default Title');
      opt.setAttribute('data-variant-price', variant.price || 0);
      opt.setAttribute('data-variant-available', isAvailable);
      opt.setAttribute('data-variant-inventory', variant.inventory_quantity || 0);
      opt.setAttribute('data-variant-inventory-policy', variant.inventory_policy || 'deny');
      opt.setAttribute('data-variant-inventory-management', variant.inventory_management || 'shopify');
      if (variant.featured_image && variant.featured_image.src) {
        opt.setAttribute('data-variant-image', variant.featured_image.src);
      } else {
        opt.removeAttribute('data-variant-image');
      }
      const input = opt.querySelector('input[name="foundation"]');
      if (input) {
        input.value = variantId;
        input.setAttribute('data-variant-id', variantId);
        input.setAttribute('data-variant-title', (hasOneOption ? typeVal : variant.title) || 'Default Title');
        input.setAttribute('data-variant-available', isAvailable);
        input.setAttribute('data-price', variant.price || 0);
        input.disabled = !isAvailable;
      }
      const titleEl = opt.querySelector('.foundation-title');
      if (titleEl) titleEl.textContent = typeVal || variant.title || 'Default Title';
      const priceEl = opt.querySelector('.foundation-price');
      if (priceEl) priceEl.textContent = (variant.price && variant.price > 0) ? '+' + formatMoney(variant.price) : formatMoney(variant.price || 0);
      const subEl = opt.querySelector('.foundation-subtitle');
      if (subEl) {
        subEl.style.color = isAvailable ? '#666' : '#ff4444';
        const preservedSub = opt.getAttribute('data-foundation-subtitle-default');
        if (isAvailable) {
          subEl.textContent =
            preservedSub != null && String(preservedSub).trim() !== ''
              ? preservedSub
              : (variant.title || '');
        } else {
          subEl.textContent = suavePdpT('outOfStock', 'Out of Stock');
        }
      }
      opt.classList.toggle('out-of-stock', !isAvailable);
      opt.querySelectorAll('.out-of-stock-badge:not(.foundation-size-na-badge)').forEach(function (b) {
        b.remove();
      });
      if (!isAvailable) {
        const os = document.createElement('span');
        os.className = 'out-of-stock-badge';
        os.textContent = suavePdpT('outOfStock', 'Out of Stock');
        opt.insertBefore(os, opt.firstChild);
      }
      if (typeVal === previouslySelectedType && isAvailable) newSelectedVariant = variant;
    });
    if (previouslySelectedType && newSelectedVariant) {
      let selectedOpt = null;
      foundationContainer.querySelectorAll('.foundation-option[data-foundation-type]').forEach(function (o) {
        if (o.getAttribute('data-foundation-type') === previouslySelectedType) selectedOpt = o;
      });
      if (selectedOpt) {
        const radio = selectedOpt.querySelector('input[name="foundation"]');
        if (radio) radio.checked = true;
        foundationContainer.querySelectorAll('.foundation-option').forEach(function (o) {
          o.classList.remove('selected');
          const t = o.querySelector('.foundation-title');
          const p = o.querySelector('.foundation-price');
          if (t) t.classList.remove('pdp-text-color');
          if (p) p.classList.remove('pdp-text-color');
        });
        selectedOpt.classList.add('selected');
        const st = selectedOpt.querySelector('.foundation-title');
        const sp = selectedOpt.querySelector('.foundation-price');
        if (st) st.classList.add('pdp-text-color');
        if (sp) sp.classList.add('pdp-text-color');
        currentFoundationVariant = {
          id: newSelectedVariant.id.toString(),
          title: hasOneOption ? previouslySelectedType : newSelectedVariant.title,
          price: parseInt(newSelectedVariant.price) || 0,
          available: true,
          inventoryPolicy: newSelectedVariant.inventory_policy,
          inventoryQuantity: newSelectedVariant.inventory_quantity,
          inventoryManagement: newSelectedVariant.inventory_management
        };
      }
    } else {
      const firstAvailable = foundationContainer.querySelector('.foundation-option:not(.out-of-stock)');
      if (firstAvailable) {
        const radio = firstAvailable.querySelector('input[name="foundation"]');
        if (radio && !radio.disabled) {
          radio.checked = true;
          foundationContainer.querySelectorAll('.foundation-option').forEach(function (o) {
            o.classList.remove('selected');
            const t = o.querySelector('.foundation-title');
            const p = o.querySelector('.foundation-price');
            if (t) t.classList.remove('pdp-text-color');
            if (p) p.classList.remove('pdp-text-color');
          });
          firstAvailable.classList.add('selected');
          const st = firstAvailable.querySelector('.foundation-title');
          const sp = firstAvailable.querySelector('.foundation-price');
          if (st) st.classList.add('pdp-text-color');
          if (sp) sp.classList.add('pdp-text-color');
          const variantId = firstAvailable.getAttribute('data-variant-id');
          if (variantId) {
            selectedFoundationType = firstAvailable.getAttribute('data-foundation-type');
            currentFoundationVariant = {
              id: variantId,
              title: firstAvailable.getAttribute('data-variant-title'),
              price: parseInt(firstAvailable.getAttribute('data-variant-price'), 10) || 0,
              available: firstAvailable.getAttribute('data-variant-available') === 'true',
              inventoryPolicy: firstAvailable.getAttribute('data-variant-inventory-policy'),
              inventoryQuantity: firstAvailable.getAttribute('data-variant-inventory'),
              inventoryManagement: firstAvailable.getAttribute('data-variant-inventory-management')
            };
            isFoundationSelected = true;
          }
        }
      } else {
        currentFoundationVariant = null;
        isFoundationSelected = false;
      }
    }
    updateTotalPrice();
    updateVariantNameDisplay();
    updateButtonStates();
    var activeTabAfterSizeSync = document.querySelector('#custom-product-container .tab.active');
    applyFoundationOptionTabColor(
      activeTabAfterSizeSync ? activeTabAfterSizeSync.getAttribute('data-tab-color') : ''
    );
  }
  
  // Function to merge metafields from data attributes into product data
  function mergeVariantMetafields(productData, tabElement) {
    if (!tabElement || !productData || !productData.variants) return productData;
    
    mergeLocalizedVariantsFromTab(productData, tabElement);
    
    // Get metafields from data attribute
    const metafieldsData = tabElement.getAttribute('data-variant-metafields');
    if (metafieldsData) {
      // Parse metafields data: format is "variantId:field1|field2|field3||variantId2:..."
      const variantMetafields = metafieldsData.split('||');
      variantMetafields.forEach((variantData, idx) => {
        if (variantData) {
          const [variantId, metafields] = variantData.split(':');
          if (variantId && metafields) {
            const fields = metafields.split('|');
            const variant = productData.variants.find(v => v.id.toString() === variantId);
            if (variant) {
              if (!variant.metafields) variant.metafields = {};
              if (!variant.metafields.custom) variant.metafields.custom = {};
              
              // Set metafields based on card index (0, 1, 2) - each variant can have all three
              if (fields[0] && fields[0].trim() !== '') {
                variant.metafields.custom.firmness_variant_option_text = fields[0];
              }
              if (fields[1] && fields[1].trim() !== '') {
                variant.metafields.custom.firmness_variant_option_text_2 = fields[1];
              }
              if (fields[2] && fields[2].trim() !== '') {
                variant.metafields.custom.firmness_variant_option_text_3 = fields[2];
              }
            }
          }
        }
      });
    }
    
    return productData;
  }

  function parseTabProductVariants(tabElement) {
    if (!tabElement) return null;
    var raw = tabElement.getAttribute('data-product-variants');
    if (!raw) return null;
    try {
      var decoded = raw.replace(/&quot;/g, '"').replace(/&#39;/g, "'");
      var parsed = JSON.parse(decoded);
      return Array.isArray(parsed) ? parsed : null;
    } catch (parseErr) {
      return null;
    }
  }

  function mergeLocalizedVariantsById(productData, localizedVariants) {
    if (!productData || !productData.variants || !localizedVariants || !localizedVariants.length) {
      return productData;
    }
    var byId = new Map();
    localizedVariants.forEach(function (v) {
      if (v && v.id != null) byId.set(String(v.id), v);
    });
    productData.variants.forEach(function (variant) {
      var loc = byId.get(String(variant.id));
      if (!loc) return;
      if (loc.title) variant.title = loc.title;
      if (loc.option1 != null) variant.option1 = loc.option1;
      if (loc.option2 != null) variant.option2 = loc.option2;
      if (loc.option3 != null) variant.option3 = loc.option3;
      if (loc.options) variant.options = loc.options;
      if (loc.available != null) variant.available = loc.available;
      if (loc.price != null) variant.price = loc.price;
      if (loc.compare_at_price != null) variant.compare_at_price = loc.compare_at_price;
      if (loc.inventory_quantity != null) variant.inventory_quantity = loc.inventory_quantity;
      if (loc.inventory_policy != null) variant.inventory_policy = loc.inventory_policy;
      if (loc.inventory_management != null) variant.inventory_management = loc.inventory_management;
    });
    return productData;
  }

  function mergeLocalizedVariantsFromTab(productData, tabElement) {
    if (!tabElement || !productData) return productData;
    var tabHandle = tabElement.getAttribute('data-product-handle') || tabElement.getAttribute('data-tab') || '';
    if (tabHandle && productData.handle && tabHandle !== productData.handle) return productData;
    return mergeLocalizedVariantsById(productData, parseTabProductVariants(tabElement));
  }

  function mergeLocalizedVariantsFromCollectionItem(productData, collectionItem) {
    if (!productData || !collectionItem || !collectionItem.variants) return productData;
    return mergeLocalizedVariantsById(productData, collectionItem.variants);
  }

  var PDP_LAYER_DEFAULT_PIN_POS = [
    null,
    { top: 15, left: 62 },
    { top: 23, left: 60 },
    { top: 35, left: 58 },
    { top: 42, left: 56 },
    { top: 52, left: 44 },
    { top: 50, left: 65 },
    { top: 70, left: 63 },
    { top: 78, left: 52 },
    { top: 84, left: 58 },
    { top: 90, left: 49 }
  ];

  function normalizePdpLayersLabel(value) {
    if (value == null) return '';
    return String(value).trim();
  }

  function escapeRegExpForLayers(str) {
    return String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /** Layer section tabs: show product name only (strip collection / line name from Shopify title). */
  function getPdpLayersProductTabLabel(productItem, collectionTitle, collectionHandle) {
    if (!productItem) return '';
    if (productItem.tabLabel) {
      return normalizePdpLayersLabel(productItem.tabLabel);
    }

    var title = normalizePdpLayersLabel(productItem.title);
    if (!title) return normalizePdpLayersLabel(productItem.handle);

    var prefixes = [];
    var seen = {};

    function addPrefix(value) {
      var p = normalizePdpLayersLabel(value);
      if (!p) return;
      var key = p.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      prefixes.push(p);
    }

    addPrefix(collectionTitle);
    if (collectionHandle) {
      addPrefix(collectionHandle);
      var handle = collectionHandle.toLowerCase();
      if (handle === 'flamenco') {
        addPrefix('Flamenco');
        addPrefix('Moderno');
        addPrefix('Modreno');
      } else if (handle === 'tango') {
        addPrefix('Classico');
        addPrefix('Tango');
      }
    }

    ['Classico', 'Flamenco', 'Tango', 'Moderno', 'Modreno', 'Suave'].forEach(addPrefix);

    prefixes.sort(function (a, b) {
      return b.length - a.length;
    });

    var stripped = title;
    var i;
    for (i = 0; i < prefixes.length; i++) {
      var pattern = new RegExp(
        '^' + escapeRegExpForLayers(prefixes[i]) + '\\s*[-–—|:·•]?\\s*',
        'i'
      );
      if (pattern.test(stripped)) {
        stripped = stripped.replace(pattern, '').trim();
      }
    }

    return stripped || title;
  }

  function getActiveFirmnessProductHandle() {
    var checked = document.querySelector('input[name="firmness"]:checked');
    if (checked && checked.value) return checked.value.trim();
    var selectedCard = document.querySelector('.firmness-card.selected');
    if (selectedCard && selectedCard.dataset.productHandle) {
      return selectedCard.dataset.productHandle.trim();
    }
    return '';
  }

  function activatePdpLayersTab(section, handle) {
    if (window.SuavePdpLayers) {
      window.SuavePdpLayers.activate(handle);
      return;
    }
    if (!section || !handle) return;
    var tabBtn = section.querySelector('[data-firmness-tab="' + handle + '"]');
    if (tabBtn) tabBtn.click();
  }

  function resolvePdpLayersImageUrl(productItem) {
    if (!productItem) return '';
    var tabsImage = productItem.tabsImage;
    if (tabsImage != null && String(tabsImage).trim() && String(tabsImage).trim() !== 'null') {
      return String(tabsImage).trim();
    }
    if (productItem.image && String(productItem.image).trim() && String(productItem.image).trim() !== 'null') {
      return String(productItem.image).trim();
    }
    return '';
  }

  function resolvePdpLayersIntro(productItem, collectionIntro) {
    if (productItem && productItem.tabsDescription != null) {
      var tabsDesc = String(productItem.tabsDescription).trim();
      if (tabsDesc && tabsDesc !== 'null') {
        return normalizePdpLayersLabel(tabsDesc);
      }
    }
    return normalizePdpLayersLabel(collectionIntro);
  }

  function resolvePdpLayersHeading(productItem, headingFallback) {
    if (productItem && productItem.tabsHeading != null) {
      var heading = String(productItem.tabsHeading).trim();
      if (heading && heading !== 'null') {
        return normalizePdpLayersLabel(heading);
      }
    }
    return normalizePdpLayersLabel(headingFallback);
  }

  function parsePdpLayersPinPercent(value, fallback) {
    if (value == null || value === '' || value === 'null') return fallback;
    var n = parseFloat(String(value).replace('%', '').trim());
    if (isNaN(n)) return fallback;
    return Math.max(0, Math.min(100, n));
  }

  function resolvePdpLayersPinPosition(productItem, pinIndex) {
    var defPos = PDP_LAYER_DEFAULT_PIN_POS[pinIndex] || { top: 15, left: 62 };
    var entry = null;
    if (productItem && Array.isArray(productItem.tabsLayers)) {
      entry = productItem.tabsLayers[pinIndex - 1] || null;
    }
    return {
      top: parsePdpLayersPinPercent(entry ? entry.pinTop : null, defPos.top),
      left: parsePdpLayersPinPercent(entry ? entry.pinLeft : null, defPos.left)
    };
  }

  function resolvePdpLayersContent(productItem) {
    var layers = [];
    if (productItem && Array.isArray(productItem.tabsLayers)) {
      productItem.tabsLayers.forEach(function (entry) {
        if (!entry) return;
        var q = normalizePdpLayersLabel(entry.q);
        var a = normalizePdpLayersLabel(entry.a);
        if (!q && !a) return;
        layers.push({
          title: q || 'Layer ' + (layers.length + 1),
          body: a
        });
      });
    }
    return {
      layers: layers,
      pointCount: layers.length ? Math.min(layers.length, 7) : 0
    };
  }

  function buildPdpLayersPanel(productItem, isActive, headingFallback, collectionIntro) {
    var handle = productItem.handle;
    var panel = document.createElement('div');
    panel.className = 'collection-layers-grid collection-layers-tab-panel' + (isActive ? ' is-active' : '');
    panel.id = 'firmness-panel-' + handle;
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', 'firmness-tab-' + handle);
    panel.setAttribute('data-collection-layers', '');
    panel.setAttribute('data-firmness-panel', handle);
    if (!isActive) panel.hidden = true;

    var layerContent = resolvePdpLayersContent(productItem);
    var pointCount = layerContent.pointCount;
    var layers = layerContent.layers;

    var imageWrap = document.createElement('div');
    imageWrap.className = 'collection-layers-image-wrap';

    var imageUrl = resolvePdpLayersImageUrl(productItem);
    var imageAlt = productItem.title || 'Mattress exploded layers';

    if (imageUrl) {
      var img = document.createElement('img');
      img.className = 'collection-layers-image';
      img.src = imageUrl;
      img.alt = imageAlt;
      img.width = 1200;
      img.height = 800;
      img.loading = 'lazy';
      imageWrap.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'collection-layers-image collection-layers-image--placeholder';
      ph.setAttribute('role', 'img');
      ph.setAttribute('aria-label', imageAlt);
      imageWrap.appendChild(ph);
    }

    var pinIndex;
    for (pinIndex = 1; pinIndex <= pointCount; pinIndex++) {
      var pinPos = resolvePdpLayersPinPosition(productItem, pinIndex);
      var pin = document.createElement('button');
      pin.type = 'button';
      pin.className = 'collection-layer-pin' + (pinIndex === 1 && isActive ? ' is-active' : '');
      pin.style.top = pinPos.top + '%';
      pin.style.left = pinPos.left + '%';
      pin.setAttribute('data-layer-pin', String(pinIndex));
      pin.setAttribute('aria-label', 'Show layer ' + pinIndex);
      pin.textContent = String(pinIndex);
      imageWrap.appendChild(pin);
    }
    panel.appendChild(imageWrap);

    var copy = document.createElement('div');
    copy.className = 'collection-layers-copy';

    var titleEl = document.createElement('h3');
    titleEl.className = 'collection-layers-title';
    titleEl.setAttribute('data-pdp-layers-collection-title', '');
    titleEl.textContent = resolvePdpLayersHeading(productItem, headingFallback) || '';
    if (!titleEl.textContent) titleEl.setAttribute('hidden', '');
    copy.appendChild(titleEl);

    var introEl = document.createElement('p');
    introEl.className = 'collection-layers-intro';
    introEl.setAttribute('data-pdp-layers-collection-intro', '');
    introEl.textContent = resolvePdpLayersIntro(productItem, collectionIntro) || '';
    if (!introEl.textContent) introEl.setAttribute('hidden', '');
    copy.appendChild(introEl);

    if (!pointCount) {
      var noData = document.createElement('p');
      noData.className = 'pdp-layers-no-data';
      noData.textContent = 'Layer details are not available for this product yet.';
      copy.appendChild(noData);
      panel.appendChild(copy);
      return panel;
    }

    var list = document.createElement('div');
    list.className = 'collection-layer-list';
    list.setAttribute('role', 'list');

    var layerNum;
    for (layerNum = 1; layerNum <= pointCount; layerNum++) {
      var layerData = layers[layerNum - 1] || {};
      var layerTitle = layerData.title || layerData.q || 'Layer ' + layerNum;
      var layerBody = layerData.body || layerData.a || '';
      var layerOpen = layerNum === 1 && isActive;

      var item = document.createElement('div');
      item.className =
        'collection-layer-item collection-layer-item--accordion' + (layerOpen ? ' is-open' : '');
      item.setAttribute('data-layer-item', String(layerNum));

      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'collection-layer-option' + (layerOpen ? ' is-active' : '');
      opt.setAttribute('data-layer-option', String(layerNum));
      opt.appendChild(document.createTextNode(layerTitle + ' '));

      var caret = document.createElement('span');
      caret.className = 'collection-layer-caret';
      caret.textContent = layerOpen ? '\u25B2' : '\u25BC';
      opt.appendChild(caret);
      item.appendChild(opt);

      var layerPanel = document.createElement('div');
      layerPanel.className = 'collection-layer-panel';
      layerPanel.setAttribute('data-layer-panel', String(layerNum));
      if (layerBody) {
        var body = document.createElement('p');
        body.className = 'collection-layer-body';
        body.textContent = layerBody;
        layerPanel.appendChild(body);
      }
      item.appendChild(layerPanel);
      list.appendChild(item);
    }

    copy.appendChild(list);
    panel.appendChild(copy);
    return panel;
  }

  function buildPdpLayersTabButton(productItem, isActive, collectionTitle, collectionHandle) {
    var handle = productItem.handle;
    var mapLabel = normalizePdpLayersLabel(productItem.title);
    var tabText =
      getPdpLayersProductTabLabel(productItem, collectionTitle, collectionHandle) || handle;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'collection-firmness-option' + (isActive ? ' is-active' : '');
    btn.setAttribute('role', 'tab');
    btn.id = 'firmness-tab-' + handle;
    btn.setAttribute('data-firmness-tab', handle);
    btn.setAttribute('data-map-firmness-label', mapLabel);
    btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    btn.setAttribute('aria-controls', 'firmness-panel-' + handle);
    btn.textContent = tabText;
    return btn;
  }

  /** Build PDP layers tabs/panels from active collection tab products. */
  async function rebuildPdpLayersProductTabs(tabElement) {
    var tab = tabElement || document.querySelector('#custom-product-container .tab.active');
    if (!window.SuavePdpLayers) return;

    var products = parseCollectionProductsFromTab(tab);
    var layersSection = document.querySelector('[data-pdp-collection-layers-section]');
    var sectionDefaultTitle = layersSection
      ? normalizePdpLayersLabel(layersSection.getAttribute('data-pdp-layers-default-title'))
      : '';
    var collectionTitleFallback = tab
      ? normalizePdpLayersLabel(
          tab.getAttribute('data-collection-title') || tab.getAttribute('data-product-title')
        )
      : '';
    if (!collectionTitleFallback) collectionTitleFallback = sectionDefaultTitle;
    var collectionIntro = tab
      ? normalizePdpLayersLabel(
          tab.getAttribute('data-collection-description') ||
            tab.getAttribute('data-product-description')
        )
      : '';
    var collectionHandle = tab
      ? normalizePdpLayersLabel(tab.getAttribute('data-collection-handle'))
      : '';

    var activeHandle = getActiveFirmnessProductHandle();
    var hasActiveInList = products.some(function (p) {
      return p.handle === activeHandle;
    });
    if (!hasActiveInList) activeHandle = products.length ? products[0].handle : '';

    return window.SuavePdpLayers.rebuild(products, activeHandle, {
      collectionTitle: collectionTitleFallback,
      collectionIntro: collectionIntro,
      collectionHandle: collectionHandle
    });
  }

  /** Sync PDP layers tabs + title/intro from active mattress collection tab (custom-product). */
  function syncPdpLayersCollectionCopy(tabElement) {
    var tab = tabElement;
    if (!tab) {
      tab = document.querySelector('#custom-product-container .tab.active');
    }
    if (!tab) return;

    var layersSection = document.querySelector('[data-pdp-collection-layers-section]');
    if (!layersSection) return;

    var title = (
      tab.getAttribute('data-collection-title') ||
      tab.getAttribute('data-product-title') ||
      ''
    ).trim();
    var collectionIntroFallback = (
      tab.getAttribute('data-collection-description') ||
      tab.getAttribute('data-product-description') ||
      ''
    ).trim();
    var products = parseCollectionProductsFromTab(tab);
    var activeHandle = getActiveFirmnessProductHandle();
    var activeProduct = products.find(function (p) {
      return p.handle === activeHandle;
    });
    if (!activeProduct && products.length) activeProduct = products[0];
    var intro = activeProduct
      ? resolvePdpLayersIntro(activeProduct, collectionIntroFallback)
      : collectionIntroFallback;

    return rebuildPdpLayersProductTabs(tab).then(function () {
      var syncedHandle = getActiveFirmnessProductHandle();
      if (syncedHandle) {
        activatePdpLayersTab(layersSection, syncedHandle);
      }
      document.dispatchEvent(
        new CustomEvent('suave:collection-change', {
          detail: {
            title: title,
            description: intro,
            collectionHandle: tab.getAttribute('data-collection-handle') || '',
            tabElement: tab
          }
        })
      );
    });
  }

  function dispatchPdpProductUpdated(productData) {
    if (!productData) return;
    var image = '';
    if (productData.images && productData.images.length > 0) {
      var img = productData.images[0];
      image = typeof img === 'string' ? img : (img.src || img.url || '');
    }
    var mainImg = document.getElementById('main-image');
    if (mainImg && mainImg.src) image = mainImg.src;

    document.dispatchEvent(
      new CustomEvent('suave:pdp-product-updated', {
        detail: {
          title: productData.title || '',
          handle: productData.handle || '',
          url: window.location.href.split('#')[0],
          image: image,
          productId: productData.id ? String(productData.id) : ''
        }
      })
    );
  }

  function parseTabProductDescriptionHtml(tabElement) {
    if (!tabElement) return '';
    var raw = tabElement.getAttribute('data-product-description-html');
    if (!raw) return '';
    try {
      return JSON.parse(raw);
    } catch (parseErr) {
      return raw;
    }
  }

  function applyProductDescriptionHtml(html) {
    var descriptionElement = document.querySelector('.product-description');
    if (!descriptionElement || html == null || String(html).trim() === '') return;
    var content = String(html).trim();
    if (content.indexOf('<') !== -1) {
      descriptionElement.innerHTML = content;
    } else {
      descriptionElement.textContent = content;
    }
  }

  function resolveLocalizedProductDescriptionHtml(tabElement, productHandle) {
    if (tabElement && productHandle) {
      var tabHandle =
        tabElement.getAttribute('data-product-handle') ||
        tabElement.getAttribute('data-tab') ||
        '';
      if (tabHandle === productHandle) {
        var fromTab = parseTabProductDescriptionHtml(tabElement);
        if (fromTab && String(fromTab).trim()) return fromTab;
      }
      var collectionItems = parseCollectionProductsFromTab(tabElement);
      var collectionItem = collectionItems.find(function (item) {
        return item && item.handle === productHandle;
      });
      if (collectionItem && collectionItem.descriptionHtml && String(collectionItem.descriptionHtml).trim()) {
        return collectionItem.descriptionHtml;
      }
    }
    if (tabElement) {
      var tabHtml = parseTabProductDescriptionHtml(tabElement);
      if (tabHtml && String(tabHtml).trim()) return tabHtml;
    }
    if (pdpInitialProductDescriptionHtml) return pdpInitialProductDescriptionHtml;
    return '';
  }

  function attachLocalizedDescriptionToProduct(productData, tabElement) {
    if (!productData) return productData;
    var localizedHtml = resolveLocalizedProductDescriptionHtml(tabElement, productData.handle);
    if (localizedHtml) {
      productData.descriptionHtml = localizedHtml;
    }
    return productData;
  }

  function restoreLocalizedProductDescription(tabElement) {
    if (!currentMattressProduct) return;
    var localizedHtml = resolveLocalizedProductDescriptionHtml(
      tabElement || currentActiveTab || document.querySelector('#custom-product-container .tab.active'),
      currentMattressProduct.handle
    );
    if (!localizedHtml) return;
    currentMattressProduct.descriptionHtml = localizedHtml;
    applyProductDescriptionHtml(localizedHtml);
  }

  // Function to update product display when mattress product changes
  async function updateMattressProduct(productData, tabElement) {
    // Merge metafields from data attributes
    productData = mergeVariantMetafields(productData, tabElement);
    attachLocalizedDescriptionToProduct(productData, tabElement);
    
    // Fetch metafields from custom endpoint
    productData = await fetchVariantMetafields(productData);
    
    // Load variant info data for this product handle
    if (productData.handle) {
      loadVariantInfoForProduct(productData.handle);
    }
    
    currentMattressProduct = productData;
    currentMattressImages = productData.images;

    if (productData.descriptionHtml) {
      applyProductDescriptionHtml(productData.descriptionHtml);
    }
    
    // Update active tab reference
    currentActiveTab = tabElement;
    
    // Update colors based on active tab using existing function
    updateTitleLastWordColor();
    
    // Reset foundation selection
    isFoundationSelected = false;
    selectedModelValue = '';
    selectedUnderbedProduct = null;
    currentFoundationVariant = null;
    currentFoundationProduct = null;
    currentFoundationImages = null;
    
    // Load mattress images initially
    if (productData.images && productData.images.length > 0) {
      loadProductImages(productData.images);
    }
    
    // Update title
    updateProductTitle(productData.title);
    
    // Update description - will be updated when variant is selected (from variant info metafield: short)
    // Initial description will be updated when first variant is selected
    
    // Update accessories title
    const accessoriesTitleElement = document.getElementById('accessories-product-title');
    if (accessoriesTitleElement) {
      accessoriesTitleElement.textContent = productData.title;
    }
    
    // Price will be updated by updateButtonStates() which calls updateTotalPrice()
    
    // Update compare price
    const comparePriceElement = document.querySelector('.compare-at-price');
    if (comparePriceElement && productData.variants && productData.variants[0].compare_at_price > productData.variants[0].price) {
      comparePriceElement.textContent = formatMoney(productData.variants[0].compare_at_price);
      comparePriceElement.style.display = 'inline';
    } else if (comparePriceElement) {
      comparePriceElement.style.display = 'none';
    }
    
    // Show firmness section
    const firmnessSection = document.getElementById('firmness-section');
    if (firmnessSection) {
      firmnessSection.style.display = 'block';
    }
    
    // Load comfort options (collection products if available, otherwise product variants)
    await loadFirmnessOptions(productData, tabElement);
    
    // Load foundation options for this mattress from metafield
    await loadFoundationOptions(productData.handle);
    
    // Update button states
    updateButtonStates();

    syncPdpLayersCollectionCopy(tabElement);
    dispatchPdpProductUpdated(productData);
  }
  
  
  // Function to update product title with styling (last 1 word if 2 words, last 2 words if 3+)
  function updateProductTitle(newTitle) {
    const titleElement = document.getElementById('dynamic-product-title');
    if (!titleElement) return;
    
    const titleWords = newTitle.trim().split(/\s+/).filter(Boolean);
    const len = titleWords.length;
    const applyColor = len >= 2;
    const colorLastTwo = len >= 3;
    
    let newTitleHTML = '';
    titleWords.forEach((word, index) => {
      const isColored = applyColor && (index === len - 1 || (colorLastTwo && index === len - 2));
      if (isColored) {
        newTitleHTML += `<span class="title-last-word pdp-text-color" data-pdp-color="text">${word}</span>`;
      } else {
        newTitleHTML += word;
      }
      if (index < len - 1) newTitleHTML += ' ';
    });
    
    titleElement.innerHTML = newTitleHTML;
    
    // Apply color from current active tab to all colored words
    if (currentActiveTab) {
      const tabColor = currentActiveTab.getAttribute('data-tab-color');
      const titleLastWords = titleElement.querySelectorAll('.title-last-word');
      if (tabColor && titleLastWords.length) {
        titleLastWords.forEach(function (el) { el.style.color = tabColor; });
      }
    }
  }
  
  // Function to detect which option is firmness and which is size
  function detectOptionTypes(productData) {
    
    if (!productData.options || !Array.isArray(productData.options)) {
      console.warn('No options array found in product data');
      return { firmnessIndex: 0, sizeIndex: 1 };
    }
    
    // Get option names
    const optionNames = productData.options.map(opt => {
      if (typeof opt === 'string') return opt.toLowerCase();
      else if (opt && typeof opt === 'object' && opt.name) return opt.name.toLowerCase();
      else if (opt && typeof opt === 'object' && opt.title) return opt.title.toLowerCase();
      else if (opt && typeof opt === 'number') return opt.toString().toLowerCase();
      else return '';
    });
    
    const sizeKeywords = ['size', 'dimension', 'tamaño', 'tamano', 'medida', 'twin', 'full', 'queen', 'king', 'california', 'xl'];
    const firmnessKeywords = ['firmness', 'firm', 'soft', 'medium', 'plush', 'comfort', 'support', 'feel', 'confort', 'firmeza'];
    const modelKeywords = ['model', 'models', 'type', 'style', 'version', 'base'];
    
    let firmnessIndex = -1;
    let sizeIndex = -1;
    let modelIndex = -1;
    
    // First, check option names
    optionNames.forEach((name, index) => {
      if (name && sizeKeywords.some(keyword => name.includes(keyword))) {
        sizeIndex = index;
      } else if (name && modelKeywords.some(keyword => name.includes(keyword))) {
        modelIndex = index;
      } else if (name && firmnessKeywords.some(keyword => name.includes(keyword))) {
        firmnessIndex = index;
      }
    });
    
    // If not detected by name, check variant values
    if (productData.variants && productData.variants.length > 0) {
      const sampleVariant = productData.variants[0];
      if (sampleVariant && sampleVariant.options) {
        sampleVariant.options.forEach((value, index) => {
          if (!value) return;
          const valLower = value.toString().toLowerCase();
          
          // Check for size values
          if (valLower.includes('twin') || valLower.includes('queen') || 
              valLower.includes('king') || valLower.includes('full') ||
              valLower.includes('xl') || valLower.includes('california') ||
              valLower.includes('single') || valLower.includes('double') ||
              valLower.includes('individual') || valLower.includes('sencillo') ||
              valLower.includes('matrimonial') || valLower.includes('doble') ||
              valLower.includes('tamano') || valLower.includes('tamaño')) {
            sizeIndex = index;
          } 
          // Check for firmness values
          else if (valLower.includes('firm') || valLower.includes('soft') || 
                   valLower.includes('medium') || valLower.includes('plush') ||
                   valLower.includes('luxury') || valLower.includes('standard') ||
                   valLower.includes('comfort') || valLower.includes('support')) {
            firmnessIndex = index;
          }
        });
      }
    }
    
    // Never treat Models / Size slots as firmness
    if (firmnessIndex === modelIndex) firmnessIndex = -1;
    if (firmnessIndex === sizeIndex) firmnessIndex = -1;

    if (sizeIndex === -1 && productData.options.length > 1) {
      sizeIndex = 1;
    } else if (sizeIndex === -1) {
      sizeIndex = 0;
    }

    if (modelIndex === -1 && productData.options && productData.options.length >= 2) {
      for (let mi = 0; mi < productData.options.length; mi += 1) {
        if (mi !== sizeIndex && mi !== firmnessIndex) {
          modelIndex = mi;
          break;
        }
      }
    }

    if (firmnessIndex === -1) {
      for (let fi = 0; fi < productData.options.length; fi += 1) {
        if (fi !== modelIndex && fi !== sizeIndex) {
          const name = optionNames[fi] || '';
          if (name && firmnessKeywords.some((keyword) => name.includes(keyword))) {
            firmnessIndex = fi;
            break;
          }
        }
      }
    }

    if (firmnessIndex === modelIndex) firmnessIndex = -1;
    if (firmnessIndex === sizeIndex) firmnessIndex = -1;

    return { firmnessIndex, sizeIndex, modelIndex };
  }

  function getModelLabelFromVariant(variant, modelIndex) {
    if (!variant) return '';
    if (variant.options && variant.options[modelIndex] !== undefined) {
      return String(variant.options[modelIndex] || '').trim();
    }
    if (modelIndex === 0 && variant.option1) return String(variant.option1).trim();
    if (modelIndex === 1 && variant.option2) return String(variant.option2).trim();
    if (modelIndex === 2 && variant.option3) return String(variant.option3).trim();
    return '';
  }

  function getFirmnessLabelFromVariant(variant, firmnessIndex) {
    if (!variant || firmnessIndex < 0) return '';
    if (variant.options && variant.options[firmnessIndex] !== undefined) {
      return String(variant.options[firmnessIndex] || '').trim();
    }
    if (firmnessIndex === 0 && variant.option1) return String(variant.option1).trim();
    if (firmnessIndex === 1 && variant.option2) return String(variant.option2).trim();
    if (firmnessIndex === 2 && variant.option3) return String(variant.option3).trim();
    return '';
  }

  function normalizeModelLabelForMatch(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
  }

  function isNoFoundationModelLabel(label) {
    var nm = normalizeModelLabelForMatch(label);
    if (!nm) return false;
    return (
      nm.includes('no foundation') ||
      nm.includes('no base') ||
      nm.includes('sin base') ||
      nm.includes('sin fundacion') ||
      nm.includes('without foundation') ||
      nm.includes('ninguna base') ||
      nm.includes('ningun base') ||
      nm === 'none' ||
      nm === 'ninguno'
    );
  }

  function filterVariantsByModelLabel(variants, modelFilter, modelIndex) {
    if (!variants || !variants.length || !modelFilter || modelIndex === -1) return variants || [];
    var exact = variants.filter(function (v) {
      return getModelLabelFromVariant(v, modelIndex) === modelFilter;
    });
    if (exact.length) return exact;
    var fuzzy = variants.filter(function (v) {
      return variantHasModelLabel(v, modelFilter);
    });
    if (fuzzy.length) return fuzzy;
    if (isNoFoundationModelLabel(modelFilter)) {
      var noFoundation = variants.filter(function (v) {
        return isNoFoundationModelLabel(getModelLabelFromVariant(v, modelIndex));
      });
      if (noFoundation.length) return noFoundation;
    }
    return variants;
  }

  function normalizeModelLabelStrippedBase(value) {
    return normalizeModelLabelForMatch(String(value || '').trim().replace(/\s+Base\s*$/i, ''));
  }

  function getNoFoundationModelLabel() {
    const cfg = getUnderbedConfig();
    const preferred = (cfg && cfg.noFoundationLabel)
      ? String(cfg.noFoundationLabel).trim()
      : suaveT('noFoundation', 'No Foundation');
    if (!currentMattressProduct || !currentMattressProduct.variants) return '';

    const { modelIndex } = detectOptionTypes(currentMattressProduct);
    if (modelIndex === -1) return '';

    const modelValues = [];
    currentMattressProduct.variants.forEach((v) => {
      const lbl = getModelLabelFromVariant(v, modelIndex);
      if (lbl && !modelValues.includes(lbl)) modelValues.push(lbl);
    });

    const want = normalizeModelLabelForMatch(preferred);
    for (let i = 0; i < modelValues.length; i += 1) {
      if (normalizeModelLabelForMatch(modelValues[i]) === want) return modelValues[i];
    }
    for (let j = 0; j < modelValues.length; j += 1) {
      if (isNoFoundationModelLabel(modelValues[j])) {
        return modelValues[j];
      }
    }
    return modelValues.length === 1 ? modelValues[0] : '';
  }

  /** Map underbed product title (e.g. "Eleva Adjustable Base", "Suave Base") to mattress Models option value. */
  function resolveModelLabelFromUnderbedTitle(underbedTitle) {
    if (!underbedTitle) return suavePdpNoFoundationLabel();
    const raw = String(underbedTitle).trim();
    if (!currentMattressProduct || !currentMattressProduct.variants) return raw;

    const { modelIndex } = detectOptionTypes(currentMattressProduct);
    if (modelIndex === -1) return raw.replace(/\s+Base\s*$/i, '').trim() || raw;

    const modelValues = [];
    currentMattressProduct.variants.forEach((v) => {
      const lbl = getModelLabelFromVariant(v, modelIndex);
      if (lbl && !modelValues.includes(lbl)) modelValues.push(lbl);
    });

    const want = normalizeModelLabelForMatch(raw);
    const wantStripped = normalizeModelLabelStrippedBase(raw);

    for (let i = 0; i < modelValues.length; i += 1) {
      const nm = normalizeModelLabelForMatch(modelValues[i]);
      if (nm === want || nm === wantStripped) return modelValues[i];
    }
    for (let j = 0; j < modelValues.length; j += 1) {
      const m = modelValues[j];
      const nm = normalizeModelLabelForMatch(m);
      if (want.includes(nm) || nm.includes(want) || wantStripped.includes(nm) || nm.includes(wantStripped)) {
        return m;
      }
    }
    return raw.replace(/\s+Base\s*$/i, '').trim() || raw;
  }

  function getMattressModelLabelForCart() {
    const underbedInput = getSelectedUnderbedInput();
    if (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) {
      const title = underbedInput.getAttribute('data-foundation-type') || '';
      return resolveModelLabelFromUnderbedTitle(title);
    }
    if (selectedModelValue) return String(selectedModelValue).trim();
    return getNoFoundationModelLabel();
  }

  function isMattressVariantSellable(v) {
    if (!v) return false;
    if (v.available === true) return true;
    if (v.inventory_policy === 'continue') return true;
    if (v.inventory_quantity != null && parseInt(v.inventory_quantity, 10) > 0) return true;
    if (v.inventory_management == null && v.available !== false) return true;
    return false;
  }

  function getVariantSizeLabel(variant, sizeIndex) {
    if (!variant || sizeIndex < 0) return '';
    if (variant.options && variant.options[sizeIndex] !== undefined) {
      return String(variant.options[sizeIndex] || '').trim();
    }
    if (sizeIndex === 0 && variant.option1) return String(variant.option1).trim();
    if (sizeIndex === 1 && variant.option2) return String(variant.option2).trim();
    if (sizeIndex === 2 && variant.option3) return String(variant.option3).trim();
    return '';
  }

  function variantHasModelLabel(variant, modelLabel) {
    if (!variant || !modelLabel) return false;
    const want = normalizeModelLabelForMatch(modelLabel);
    const values = [];
    if (variant.options && variant.options.length) {
      variant.options.forEach((opt) => {
        if (opt != null && String(opt).trim() !== '') values.push(String(opt).trim());
      });
    } else {
      if (variant.option1) values.push(String(variant.option1).trim());
      if (variant.option2) values.push(String(variant.option2).trim());
      if (variant.option3) values.push(String(variant.option3).trim());
    }
    for (let i = 0; i < values.length; i += 1) {
      const nv = normalizeModelLabelForMatch(values[i]);
      if (nv === want) return true;
      if (nv && want && (nv.includes(want) || want.includes(nv))) return true;
    }
    return false;
  }

  /** Mattress line item variant: current size + firmness + model matching selected underbed (not always "No Foundation"). */
  function findMattressVariantForAddToCart(sizeOverride) {
    if (!currentMattressProduct || !currentMattressProduct.variants || !currentMattressProduct.variants.length) {
      return currentSizeVariant;
    }
    const { firmnessIndex, sizeIndex, modelIndex } = detectOptionTypes(currentMattressProduct);
    const sizeValue = (sizeOverride && String(sizeOverride).trim()) || getCurrentMattressSizeValue();
    const modelLabel = getMattressModelLabelForCart();
    let firmnessLabel = '';
    if (currentFirmnessVariant && firmnessIndex >= 0) {
      firmnessLabel = getFirmnessLabelFromVariant(currentFirmnessVariant, firmnessIndex);
    }

    let candidates = currentMattressProduct.variants.slice();
    if (modelLabel) {
      if (modelIndex >= 0) {
        const byIndex = candidates.filter((v) => getModelLabelFromVariant(v, modelIndex) === modelLabel);
        if (byIndex.length) candidates = byIndex;
        else candidates = candidates.filter((v) => variantHasModelLabel(v, modelLabel));
      } else {
        candidates = candidates.filter((v) => variantHasModelLabel(v, modelLabel));
      }
    }
    if (sizeValue && sizeIndex >= 0) {
      candidates = candidates.filter((v) => mattressSizesMatch(getVariantSizeLabel(v, sizeIndex), sizeValue));
    }
    const hasDistinctFirmness =
      firmnessLabel &&
      firmnessIndex >= 0 &&
      firmnessIndex !== modelIndex &&
      firmnessIndex !== sizeIndex;
    if (hasDistinctFirmness) {
      candidates = candidates.filter((v) => getFirmnessLabelFromVariant(v, firmnessIndex) === firmnessLabel);
    }

    if (!candidates.length && modelLabel) {
      candidates = currentMattressProduct.variants.filter((v) => variantHasModelLabel(v, modelLabel));
      if (sizeValue && sizeIndex >= 0) {
        candidates = candidates.filter((v) => mattressSizesMatch(getVariantSizeLabel(v, sizeIndex), sizeValue));
      }
      if (hasDistinctFirmness) {
        candidates = candidates.filter((v) => getFirmnessLabelFromVariant(v, firmnessIndex) === firmnessLabel);
      }
    }

    if (!candidates.length) return currentSizeVariant;
    const sellable = candidates.find(isMattressVariantSellable);
    return sellable || candidates[0] || currentSizeVariant;
  }

  /** When underbed collection base is selected, sync mattress model + size dropdown to matching variants. */
  function syncMattressModelFromUnderbedSelection() {
    if (!currentMattressProduct || !currentMattressProduct.variants) return;
    const { modelIndex, sizeIndex } = detectOptionTypes(currentMattressProduct);
    if (modelIndex === -1) return;

    const modelLabel = getMattressModelLabelForCart();
    selectedModelValue = modelLabel;

    const underbedInput = getSelectedUnderbedInput();
    if (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) {
      selectedFoundationType = underbedInput.getAttribute('data-foundation-type') || modelLabel;
    } else {
      selectedFoundationType = suavePdpNoFoundationLabel();
    }

    let matchingVariants = currentMattressProduct.variants.filter(function (v) {
      return getModelLabelFromVariant(v, modelIndex) === modelLabel;
    });
    if (!matchingVariants.length) {
      matchingVariants = currentMattressProduct.variants.filter(function (v) {
        return variantHasModelLabel(v, modelLabel);
      });
    }
    if (!matchingVariants.length && isNoFoundationModelLabel(modelLabel)) {
      matchingVariants = currentMattressProduct.variants.filter(function (v) {
        return isNoFoundationModelLabel(getModelLabelFromVariant(v, modelIndex));
      });
    }
    const { firmnessIndex } = detectOptionTypes(currentMattressProduct);
    if (
      currentFirmnessVariant &&
      firmnessIndex >= 0 &&
      firmnessIndex !== modelIndex &&
      firmnessIndex !== sizeIndex
    ) {
      const firmnessLabel = getFirmnessLabelFromVariant(currentFirmnessVariant, firmnessIndex);
      if (firmnessLabel) {
        matchingVariants = matchingVariants.filter(
          (v) => getFirmnessLabelFromVariant(v, firmnessIndex) === firmnessLabel
        );
      }
    }
    if (matchingVariants.length) {
      applyMattressVariantsForModelSelection(currentMattressProduct, modelIndex, sizeIndex, matchingVariants);
    }
  }

  function buildVariantGalleryImages(variantId) {
    const featured = getVariantFeaturedImageData(variantId);
    const galleryUrls = getVariantMetafieldGalleryUrls(variantId);
    const images = [];
    const seen = new Set();

    if (featured && featured.src && !seen.has(featured.src)) {
      images.push(featured);
      seen.add(featured.src);
    }

    galleryUrls.forEach(function (src) {
      const normalized = normalizePdpImageUrl(String(src || '').trim());
      if (normalized && !seen.has(normalized)) {
        images.push({
          src: normalized,
          alt: (featured && featured.alt) || 'Variant image'
        });
        seen.add(normalized);
      }
    });

    return images;
  }

  function getUnderbedConfig() {
    if (typeof window === 'undefined' || !window.__PDP_UNDERBED_CONFIG__) return null;
    const cfg = window.__PDP_UNDERBED_CONFIG__;
    if (!cfg.products || !Array.isArray(cfg.products) || cfg.products.length === 0) return null;
    return cfg;
  }

  function isUnderbedReplacementModelLabel(modelValue) {
    const cfg = getUnderbedConfig();
    if (!cfg) return false;
    const trigger = cfg.modelLabel ? String(cfg.modelLabel).trim().toLowerCase() : 'base';
    if (!trigger) return false;
    const normalized = String(modelValue || '').trim().toLowerCase();
    return normalized === trigger || normalized.includes(trigger) || trigger.includes(normalized);
  }

  function clearFoundationOptionSelection(container) {
    if (!container) return;
    container.querySelectorAll('.foundation-option').forEach((o) => {
      o.classList.remove('selected');
      const input = o.querySelector('input[type="radio"]');
      if (input) input.checked = false;
    });
    var activeTabForFoundation = document.querySelector('#custom-product-container .tab.active');
    applyFoundationOptionTabColor(
      activeTabForFoundation ? activeTabForFoundation.getAttribute('data-tab-color') : ''
    );
  }

  function selectFoundationOptionElement(optionEl, container) {
    if (!optionEl || !container) return;
    clearFoundationOptionSelection(container);
    optionEl.classList.add('selected');
    const input = optionEl.querySelector('input[type="radio"]');
    if (input) input.checked = true;
    var activeTabForFoundation = document.querySelector('#custom-product-container .tab.active');
    applyFoundationOptionTabColor(
      activeTabForFoundation ? activeTabForFoundation.getAttribute('data-tab-color') : ''
    );
  }

  function applyMattressVariantsForModelSelection(productData, modelIndex, sizeIndex, matchingVariants) {
    if (!matchingVariants || matchingVariants.length === 0) return;
    const preserveSize =
      getCurrentMattressSizeValueFromUI() || getCurrentMattressSizeValue();
    updateSizeOptionsForFirmness(matchingVariants, sizeIndex, preserveSize);

    let variantToUse = null;
    if (preserveSize && sizeIndex >= 0) {
      variantToUse = matchingVariants.find((v) =>
        mattressSizesMatch(getVariantSizeLabel(v, sizeIndex), preserveSize)
      );
    }
    if (!variantToUse && currentSizeVariant && matchingVariants.some((v) => v.id === currentSizeVariant.id)) {
      variantToUse = currentSizeVariant;
    }
    if (!variantToUse) {
      variantToUse =
        matchingVariants.find(isMattressVariantSellable) || matchingVariants[0];
    }
    if (variantToUse) currentSizeVariant = variantToUse;
    currentFirmnessVariant = variantToUse;
    if (variantToUse && variantToUse.id) {
      const variantId = variantToUse.id.toString();
      if (!isFoundationSelected) {
        loadVariantImageGallery(variantId);
      } else if (currentMattressImages && currentMattressImages.length > 0) {
        loadProductImages(currentMattressImages);
      }
      updateVariantInfo(variantId);
      updateVariantImageAndFeatures(variantId);
      updateVariantTechnicalSpecs(variantId);
      updateVariantPerformanceBlocks(variantId);
    }
    updateVariantNameDisplay();
    updateButtonStates();
  }

  function buildModelOptionHtml(modelValue, variants, checked) {
    const isAvailable = variants.some(v => v && v.available !== false);
    const firstVariant = variants[0] || null;
    const modelPrice = firstVariant && typeof firstVariant.price === 'number' ? firstVariant.price : 0;
    const modelSubtitle = isAvailable
      ? `Select ${modelValue} model for your bed setup.`
      : 'Out of stock for selected product';
    return `
      <label class="foundation-option model-option${checked ? ' selected' : ''}${!isAvailable ? ' out-of-stock' : ''}" data-model-value="${escapeAttr(modelValue)}" data-foundation-type="${escapeAttr(modelValue)}">
        ${!isAvailable ? '<span class="out-of-stock-badge">Out of Stock</span>' : ''}
        <input type="radio" name="model" value="${escapeAttr(modelValue)}" data-foundation-type="${escapeAttr(modelValue)}" ${checked ? 'checked' : ''} ${!isAvailable ? 'disabled' : ''} class="foundation-input">
        <span class="foundation-indicator"></span>
        <div class="foundation-content">
          <p class="foundation-title ${checked ? 'pdp-text-color' : ''}">${escapeHtmlText(modelValue)}</p>
          <p class="foundation-subtitle" style="color: ${isAvailable ? '#666' : '#ff4444'};">
            ${escapeHtmlText(modelSubtitle)}
          </p>
        </div>
        <p class="foundation-price ${checked ? 'pdp-text-color' : ''}">${modelPrice > 0 ? '+' + formatMoney(modelPrice) : formatMoney(modelPrice)}</p>
      </label>
    `;
  }

  function renderModelOptionsForCurrentProduct(productData) {
    const foundationContainer = document.getElementById('foundation-options-container');
    if (!foundationContainer || !productData || !productData.variants || !productData.variants.length) return false;
    const { modelIndex, sizeIndex } = detectOptionTypes(productData);
    if (modelIndex === -1 || modelIndex === sizeIndex) return false;

    const modelMap = new Map();
    productData.variants.forEach((variant) => {
      const modelValue = getModelLabelFromVariant(variant, modelIndex);
      if (!modelValue) return;
      if (!modelMap.has(modelValue)) modelMap.set(modelValue, []);
      modelMap.get(modelValue).push(variant);
    });
    if (modelMap.size === 0) return false;

    let modelsHtml = '';
    let optionIndex = 0;
    let firstModel = '';

    modelMap.forEach((variants, modelValue) => {
      const checked = optionIndex === 0;
      if (checked) {
        firstModel = modelValue;
        selectedUnderbedProduct = null;
      }
      modelsHtml += buildModelOptionHtml(modelValue, variants, checked);
      optionIndex += 1;
    });

    foundationContainer.innerHTML = modelsHtml;
    selectedModelValue = firstModel;
    selectedFoundationType = firstModel;
    selectedUnderbedProduct = null;

    const modelOptions = foundationContainer.querySelectorAll('.model-option');
    modelOptions.forEach((optionEl) => {
      optionEl.addEventListener('click', function () {
        const modelValue = this.getAttribute('data-model-value') || '';
        if (!modelValue) return;
        selectedModelValue = modelValue;
        selectedFoundationType = modelValue;
        selectedUnderbedProduct = null;
        foundationContainer.querySelectorAll('input[name="underbed"]').forEach((i) => { i.checked = false; });
        selectFoundationOptionElement(this, foundationContainer);
        const input = this.querySelector('input[name="model"]');
        foundationContainer.querySelectorAll('input[name="model"]').forEach((i) => { i.checked = false; });
        if (input) input.checked = true;

        const matchingVariants = productData.variants.filter(v => getModelLabelFromVariant(v, modelIndex) === modelValue);
        applyMattressVariantsForModelSelection(productData, modelIndex, sizeIndex, matchingVariants);
      });
    });

    return true;
  }
  
  /** Normalize mattress/foundation size labels for comparison (spacing, dashes, case). */
  function normalizeMattressSizeLabel(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/[-–—]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compactBedSizeKey(value) {
    return normalizeMattressSizeLabel(value).replace(/\s+/g, '');
  }

  function mattressSizesMatch(a, b) {
    const na = normalizeMattressSizeLabel(a);
    const nb = normalizeMattressSizeLabel(b);
    if (!na || !nb) return false;
    if (na === nb) return true;
    if (compactBedSizeKey(a) === compactBedSizeKey(b)) return true;
    var ca = bedSizeCanonicalKey(a);
    var cb = bedSizeCanonicalKey(b);
    return !!(ca && cb && ca === cb);
  }

  /**
   * True if the foundation product lists this mattress size on its size option (1-option = size only, 2-option = size on option2).
   * When unknown structure or no foundation loaded, do not restrict the size dropdown.
   */
  function foundationProductHasMattressSizeForDropdown(foundationProduct, mattressSizeLabel) {
    if (!foundationProduct || !foundationProduct.variants || !foundationProduct.variants.length) return true;
    const opts = foundationProduct.options || [];
    const hasTwo = opts.length >= 2;
    const hasOne = opts.length === 1;
    if (!hasTwo && !hasOne) return true;
    const sizeVal = (mattressSizeLabel || '').toString().trim();
    if (!sizeVal) return true;
    if (hasOne) {
      return foundationProduct.variants.some(function (v) {
        const vSize = (v.option1 || (v.options && v.options[0]) || '').toString().trim();
        return mattressSizesMatch(vSize, sizeVal);
      });
    }
    return foundationProduct.variants.some(function (v) {
      const vSize = (v.option2 || (v.options && v.options[1]) || '').toString().trim();
      return mattressSizesMatch(vSize, sizeVal);
    });
  }

  /** Size label from size dropdown UI only (not currentSizeVariant, which can be stale after model sync). */
  function getCurrentMattressSizeValueFromUI() {
    const sizeSelect = document.getElementById('size-select');
    if (sizeSelect && sizeSelect.selectedIndex >= 0) {
      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      if (selectedOption && selectedOption.value && currentMattressProduct && currentMattressProduct.variants) {
        const variantId = String(selectedOption.value).trim();
        const variant = currentMattressProduct.variants.find(function (v) {
          return v && String(v.id) === variantId;
        });
        if (variant) {
          const detected = detectOptionTypes(currentMattressProduct);
          const sizeLabel = getVariantSizeLabel(variant, detected.sizeIndex);
          if (sizeLabel) return sizeLabel;
        }
        const fromDataset = selectedOption.getAttribute('data-size');
        if (fromDataset && String(fromDataset).trim()) return String(fromDataset).trim();
        const text = (selectedOption.textContent || '').trim();
        const sizeOnly = text.split(' - ')[0].split('|')[0].trim();
        if (sizeOnly && sizeOnly !== 'No sizes available') return sizeOnly;
      }
    }
    const customSelected = document.querySelector('#custom-product-container .custom-dropdown-selected .selected-size');
    if (customSelected && customSelected.textContent) {
      const t = customSelected.textContent.trim();
      const sizeOnly = t.split('|')[0].trim();
      if (sizeOnly && sizeOnly !== suavePdpT('selectSize', 'Select Size')) return sizeOnly;
    }
    return '';
  }

  /** Returns current mattress size value (e.g. "Twin", "Queen") or empty string if none selected. Used to sync foundation variant. */
  function getCurrentMattressSizeValue() {
    const fromUI = getCurrentMattressSizeValueFromUI();
    if (fromUI) return fromUI;
    if (currentMattressProduct && currentSizeVariant) {
      const { sizeIndex } = detectOptionTypes(currentMattressProduct);
      if (currentSizeVariant.options && currentSizeVariant.options[sizeIndex] !== undefined) {
        const v = String(currentSizeVariant.options[sizeIndex]).trim();
        if (v) return v;
      }
      if (sizeIndex === 0 && currentSizeVariant.option1) return String(currentSizeVariant.option1).trim();
      if (sizeIndex === 1 && currentSizeVariant.option2) return String(currentSizeVariant.option2).trim();
      if (sizeIndex === 2 && currentSizeVariant.option3) return String(currentSizeVariant.option3).trim();
    }
    return '';
  }
  
  /** Foundation product: option1 = Foundation Type, option2 = Size. Returns variant matching (foundation type + mattress size) or null. */
  function getFoundationVariantBySizeAndType(foundationProduct, sizeValue, foundationTypeValue) {
    if (!foundationProduct || !foundationProduct.variants || !foundationTypeValue) return null;
    const sizeVal = (sizeValue || '').toString().trim();
    const typeVal = foundationTypeValue.toString().trim();
    return foundationProduct.variants.find(function (v) {
      const vType = (v.option1 || (v.options && v.options[0]) || '').toString().trim();
      const vSize = (v.option2 || (v.options && v.options[1]) || '').toString().trim();
      return vType === typeVal && (sizeVal === '' || mattressSizesMatch(vSize, sizeVal));
    }) || null;
  }
  
  /** Get first variant for a foundation type (option1 = Foundation Type). For display when no size selected. */
  function getFirstVariantForFoundationType(foundationProduct, foundationTypeValue) {
    if (!foundationProduct || !foundationProduct.variants || !foundationTypeValue) return null;
    const typeVal = foundationTypeValue.toString().trim();
    return foundationProduct.variants.find(function (v) {
      const vType = (v.option1 || (v.options && v.options[0]) || '').toString().trim();
      return vType === typeVal;
    }) || null;
  }
  
  /** Foundation product with only size variants: find variant matching size (option1 / options[0]). */
  function getFoundationVariantBySize(foundationProduct, sizeValue) {
    if (!foundationProduct || !foundationProduct.variants) return null;
    const sizeVal = (sizeValue || '').toString().trim();
    if (!sizeVal) return foundationProduct.variants[0] || null;
    return foundationProduct.variants.find(function (v) {
      const vSize = (v.option1 || (v.options && v.options[0]) || '').toString().trim();
      return mattressSizesMatch(vSize, sizeVal);
    }) || null;
  }
  
  async function fetchProductByHandle(handle) {
    if (!handle) return null;
    if (collectionProductCache.has(handle)) {
      return collectionProductCache.get(handle);
    }
    try {
      const response = await fetch(suavePdpProductJsonUrl(handle));
      if (!response.ok) return null;
      const product = await response.json();
      collectionProductCache.set(handle, product);
      return product;
    } catch (error) {
      console.error('Error fetching collection product:', handle, error);
      return null;
    }
  }

  function parseCollectionProductsFromTab(tabElement) {
    if (!tabElement) return [];
    const raw = tabElement.getAttribute('data-collection-products');
    if (!raw) return [];
    var candidates = [raw];
    try {
      var ta = document.createElement('textarea');
      ta.innerHTML = raw;
      if (ta.value && ta.value !== raw) candidates.push(ta.value);
    } catch (decodeErr) {
      /* ignore */
    }
    var i;
    for (i = 0; i < candidates.length; i++) {
      try {
        const parsed = JSON.parse(candidates[i]);
        if (Array.isArray(parsed)) {
          return parsed.filter(function (item) {
            return item && item.handle;
          });
        }
      } catch (e) {
        /* try next */
      }
    }
    return [];
  }

  /** Best URL for comfort card when each card = a full product from collection JSON + /products/{handle}.js */
  function resolveProductHeroImageUrl(product) {
    if (!product) return null;
    const fi = product.featured_image;
    if (fi) {
      if (typeof fi === 'string' && fi.trim()) return fi.trim();
      if (fi.src) return fi.src;
    }
    if (product.image) {
      if (typeof product.image === 'string' && product.image.trim()) return product.image.trim();
      if (product.image.src) return product.image.src;
    }
    const imgs = product.images;
    if (imgs && imgs.length) {
      const img = imgs[0];
      if (typeof img === 'string' && img.trim()) return img.trim();
      if (img && img.src) return img.src;
      if (img && img.url) return img.url;
    }
    if (product.variants && product.variants.length) {
      for (let i = 0; i < product.variants.length; i++) {
        const v = product.variants[i];
        if (!v || !v.featured_image) continue;
        const vf = v.featured_image;
        if (typeof vf === 'string' && vf.trim()) return vf.trim();
        if (vf.src) return vf.src;
      }
    }
    return null;
  }

  function comfortCardImageUrlFromItem(item, itemProduct) {
    if (item && item.image && typeof item.image === 'string' && item.image.trim()) {
      return item.image.trim();
    }
    return resolveProductHeroImageUrl(itemProduct);
  }

  // Function to load firmness options from variants (fallback) or collection products
  async function loadFirmnessOptions(productData, tabElement = null) {
    // Store productData for image access
    const currentProductData = productData;
    
    const firmnessContainer = document.getElementById('firmness-options-container');
    if (!firmnessContainer) return;
    
    const activeTab = tabElement || document.querySelector('#custom-product-container .tab.active');
    const collectionProducts = parseCollectionProductsFromTab(activeTab);

    if (collectionProducts.length > 0) {
      firmnessContainer.innerHTML = '';
      const comfortTitle = document.querySelector('#firmness-section .section-title');
      if (comfortTitle) {
        comfortTitle.textContent = suavePdpT('chooseComfort', 'Choose your comfort preference.');
      }
      currentFirmnessTitle = suavePdpT('chooseComfort', 'Choose your comfort preference.');

      let firstLoadedProduct = null;
      let index = 0;

      for (const item of collectionProducts) {
        const itemProduct = await fetchProductByHandle(item.handle);
        if (!itemProduct || !itemProduct.variants || itemProduct.variants.length === 0) {
          continue;
        }
        attachLocalizedDescriptionToProduct(itemProduct, activeTab);
        mergeLocalizedVariantsFromCollectionItem(itemProduct, item);

        const card = document.createElement('div');
        card.className = `firmness-card${index === 0 ? ' selected' : ''}`;
        card.dataset.productHandle = itemProduct.handle;
        card.dataset.productId = itemProduct.id;

        const indicator = document.createElement('span');
        indicator.className = `card-indicator${index === 0 ? ' active' : ''}`;
        card.appendChild(indicator);

        const cardImgUrl = comfortCardImageUrlFromItem(item, itemProduct);
        if (cardImgUrl) {
          const previewImage = document.createElement('img');
          previewImage.className = 'firmness-image';
          previewImage.src = cardImgUrl;
          previewImage.alt = itemProduct.title || 'Comfort option';
          previewImage.loading = 'lazy';
          card.appendChild(previewImage);
        }

        const label = document.createElement('h4');
        label.className = 'firmness-label';
        label.textContent = itemProduct.title;
        card.appendChild(label);

        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'firmness';
        radio.value = itemProduct.handle;
        radio.style.display = 'none';
        if (index === 0) radio.checked = true;
        card.appendChild(radio);

        card.addEventListener('click', async function() {
          document.querySelectorAll('.firmness-card').forEach(c => {
            c.classList.remove('selected');
            const ci = c.querySelector('.card-indicator');
            if (ci) ci.classList.remove('active');
          });
          this.classList.add('selected');
          document.querySelectorAll('.firmness-card input[type="radio"]').forEach(r => { r.checked = false; });
          radio.checked = true;

          const activeTabForFirmness = document.querySelector('#custom-product-container .tab.active');
          if (activeTabForFirmness) {
            applyPdpSelectionTabColors(activeTabForFirmness.getAttribute('data-tab-color'));
          }

          currentMattressProduct = itemProduct;
          currentMattressImages = itemProduct.images || [];
          selectedModelValue = '';
          selectedUnderbedProduct = null;
          currentSizeVariant = null;
          currentFirmnessVariant = itemProduct.variants[0] || null;

          if (currentMattressImages.length > 0) {
            loadProductImages(currentMattressImages);
          }
          updateProductTitle(itemProduct.title || '');
          dispatchPdpProductUpdated(itemProduct);
          const accessoriesTitleElement = document.getElementById('accessories-product-title');
          if (accessoriesTitleElement) accessoriesTitleElement.textContent = itemProduct.title || '';
          const { sizeIndex } = detectOptionTypes(itemProduct);
          updateSizeOptionsForFirmness(itemProduct.variants, sizeIndex);

          if (currentFirmnessVariant) {
            const firstVariantId = currentFirmnessVariant.id.toString();
            updateVariantInfo(firstVariantId);
            await updateVariantImageAndFeatures(firstVariantId);
            updateVariantTechnicalSpecs(firstVariantId);
            updateVariantPerformanceBlocks(firstVariantId);
          }
          await loadFoundationOptions(itemProduct.handle);
          updateVariantNameDisplay();
          updateButtonStates();
          syncPdpLayersActiveProduct(itemProduct.handle, itemProduct.title || '');
        });

        firmnessContainer.appendChild(card);

        if (index === 0) {
          firstLoadedProduct = itemProduct;
        }
        index += 1;
      }

      if (firstLoadedProduct) {
        currentMattressProduct = firstLoadedProduct;
        currentMattressImages = firstLoadedProduct.images || [];
        selectedModelValue = '';
        selectedUnderbedProduct = null;
        currentSizeVariant = null;
        currentFirmnessVariant = firstLoadedProduct.variants[0] || null;
        if (currentMattressImages.length > 0) {
          loadProductImages(currentMattressImages);
        }
        updateProductTitle(firstLoadedProduct.title || '');
        const accessoriesTitleElement = document.getElementById('accessories-product-title');
        if (accessoriesTitleElement) accessoriesTitleElement.textContent = firstLoadedProduct.title || '';
        const { sizeIndex } = detectOptionTypes(firstLoadedProduct);
        updateSizeOptionsForFirmness(firstLoadedProduct.variants, sizeIndex);
        if (currentFirmnessVariant) {
          const firstVariantId = currentFirmnessVariant.id.toString();
          updateVariantInfo(firstVariantId);
          updateVariantImageAndFeatures(firstVariantId);
          updateVariantTechnicalSpecs(firstVariantId);
          updateVariantPerformanceBlocks(firstVariantId);
        }
        updateVariantNameDisplay();
        syncPdpLayersActiveProduct(
          firstLoadedProduct.handle,
          firstLoadedProduct.title || ''
        );
        await loadFoundationOptions(firstLoadedProduct.handle);
      } else {
        firmnessContainer.innerHTML = '<p class="error-message">No products found in selected collection</p>';
      }
      if (activeTab) {
        applyPdpSelectionTabColors(activeTab.getAttribute('data-tab-color'));
      }
      return;
    }

    if (!productData.variants || !Array.isArray(productData.variants) || productData.variants.length === 0) {
      firmnessContainer.innerHTML = '<p class="error-message">No variants available</p>';
      return;
    }
    
    firmnessContainer.innerHTML = '';
    
    // Get firmness_option blocks from JSON
    let firmnessOptionBlocks = [];
    try {
      const blocksJson = document.getElementById('firmness-option-blocks');
      if (blocksJson) {
        firmnessOptionBlocks = JSON.parse(blocksJson.textContent);
      }
    } catch (e) {
      console.log('Could not parse firmness option blocks:', e);
    }
    
    const { firmnessIndex, sizeIndex } = detectOptionTypes(productData);
    const firmnessMap = new Map();
    
    // First pass: group variants by firmness
    productData.variants.forEach(variant => {
      let firmnessValue = 'Standard';
      
      if (variant.options && variant.options[firmnessIndex] !== undefined) {
        firmnessValue = variant.options[firmnessIndex];
      } else if (variant.option1 && firmnessIndex === 0) {
        firmnessValue = variant.option1;
      } else if (variant.option2 && firmnessIndex === 1) {
        firmnessValue = variant.option2;
      } else if (variant.option3 && firmnessIndex === 2) {
        firmnessValue = variant.option3;
      } else if (variant.title) {
        const titleParts = variant.title.split(' / ');
        firmnessValue = titleParts[0] || variant.title;
      }
      
      firmnessValue = firmnessValue.toString();
      const firmnessKey = firmnessValue.toLowerCase().replace(/\s+/g, '-');
      
      if (!firmnessMap.has(firmnessKey)) {
        // Try to find matching firmness option block
        let matchingBlock = null;
        for (let block of firmnessOptionBlocks) {
          const blockValue = (block.firmness_value || '').toLowerCase().replace(/\s+/g, '-');
          if (blockValue === firmnessKey || blockValue === firmnessValue.toLowerCase().replace(/\s+/g, '-')) {
            matchingBlock = block;
            break;
          }
        }
        
        firmnessMap.set(firmnessKey, {
          label: firmnessValue,
          value: firmnessKey,
          variants: [],
          variantImage: variant.featured_image || null,
          blockData: matchingBlock
        });
      }
      
      firmnessMap.get(firmnessKey).variants.push(variant);
    });
    
    if (firmnessMap.size === 0) {
      firmnessContainer.innerHTML = '<p class="error-message">No firmness options available</p>';
      return;
    }
    
    // Set firmness header title to "Choose your comfort preference."
    const firmnessTitleTextElement = document.querySelector('#firmness-section .section-title');
    if (firmnessTitleTextElement) {
      firmnessTitleTextElement.textContent = suavePdpT('chooseComfort', 'Choose your comfort preference.');
      currentFirmnessTitle = suavePdpT('chooseComfort', 'Choose your comfort preference.');
    } else {
      currentFirmnessTitle = '';
    }
    
    let firstFirmnessVariant = null;
    let cardIndex = 0;
    
    firmnessMap.forEach((firmness, firmnessKey) => {
      const card = document.createElement('div');
      card.className = `firmness-card${cardIndex === 0 ? ' selected' : ''}`;
      card.dataset.firmnessValue = firmness.value;
      card.dataset.firmnessKey = firmnessKey;
      card.dataset.variantIds = firmness.variants.map(v => v.id).join(',');
      
      if (cardIndex === 0) {
        firstFirmnessVariant = firmness.variants[0];
        currentFirmnessVariant = firstFirmnessVariant;
      }
      
      const indicator = document.createElement('span');
      indicator.className = `card-indicator${cardIndex === 0 ? ' active' : ''}`;
      card.appendChild(indicator);
      
      // Add Custom Title - ABOVE IMAGE (from variant info metafield: title)
      const customTitle = document.createElement('p');
      customTitle.className = 'firmness-card-title';
      
      // Get title from variant info metafield (metaobject) - Use FIRST variant in firmness group
      let cardTitle = '';
      
      if (firmness.variants && firmness.variants.length > 0) {
        const firstVariant = firmness.variants[0];
        const variantId = firstVariant.id.toString();
        const variantInfo = variantInfoMetafieldsMap.get(variantId);
        // FLEXIBLE title check - accept any truthy value
        if (variantInfo && variantInfo.title) {
          const titleStr = String(variantInfo.title).trim();
          if (titleStr && titleStr.length > 0 && titleStr !== 'null' && titleStr !== 'undefined') {
            cardTitle = titleStr;
          }
        }
      }
      
      // Fallback to blockData.title if variant info not available
      if (!cardTitle && firmness.blockData && firmness.blockData.title) {
        cardTitle = firmness.blockData.title;
      }
      
      customTitle.textContent = cardTitle;
      card.appendChild(customTitle);
      
      // Add image if variant has one or from block
      const imageDiv = document.createElement('div');
      imageDiv.className = 'firmness-image';
      let imageUrl = null;
      
      // Priority: 1) blockData image, 2) variant featured_image (from variants array), 3) variantImage (stored), 4) product images
      if (firmness.blockData && firmness.blockData.image) {
        imageUrl = firmness.blockData.image;
      } else if (firmness.variants && firmness.variants.length > 0) {
        // Get product images for matching
        const productImages = currentMattressImages || (currentProductData && currentProductData.images) || [];
        // FIRST: Try to match product images with variant IDs (this is how Shopify stores variant images)
        // Shopify stores variant images in product.images array with variant_ids property
        for (let v of firmness.variants) {
          // Check if any product image is associated with this variant
          if (productImages.length > 0) {
            for (let imgIndex = 0; imgIndex < productImages.length; imgIndex++) {
              const img = productImages[imgIndex];
              let imgSrc = null;
              
              // Try multiple ways to get image source
              if (img.src) {
                imgSrc = img.src;
              } else if (img.url) {
                imgSrc = img.url;
              } else if (typeof img === 'string') {
                imgSrc = img;
              } else if (img.original) {
                imgSrc = img.original;
              } else if (img.original_src) {
                imgSrc = img.original_src;
              }
              
              if (!imgSrc) {
                continue;
              }
              
              // Check if image has variant_ids array and includes this variant
              if (img.variant_ids) {
                let variantIdsArray = [];
                
                // Handle different variant_ids formats
                if (Array.isArray(img.variant_ids)) {
                  variantIdsArray = img.variant_ids;
                } else if (typeof img.variant_ids === 'string') {
                  // Try to parse if it's a JSON string
                  try {
                    variantIdsArray = JSON.parse(img.variant_ids);
                  } catch (e) {
                    variantIdsArray = [img.variant_ids];
                  }
                } else {
                  variantIdsArray = [img.variant_ids];
                }
                
                // Convert variant ID to number and string for comparison
                const variantIdNum = typeof v.id === 'string' ? parseInt(v.id, 10) : v.id;
                const variantIdStr = String(v.id);
                
                // Check all possible ID formats
                if (variantIdsArray.includes(variantIdNum) || 
                    variantIdsArray.includes(v.id) || 
                    variantIdsArray.includes(variantIdStr) ||
                    variantIdsArray.some(id => String(id) === String(v.id)) ||
                    variantIdsArray.some(id => String(id) === String(variantIdNum))) {
                  imageUrl = imgSrc;
                  break;
                }
              }
            }
            if (imageUrl) break;
          }
          
          // SECOND: Check variant.featured_image (if it exists directly on variant)
          if (!imageUrl && v.featured_image) {
            if (v.featured_image.src) {
              imageUrl = v.featured_image.src;
              break;
            } else if (typeof v.featured_image === 'string') {
              imageUrl = v.featured_image;
              break;
            }
          }
          
          // THIRD: Check variant.image as fallback
          if (!imageUrl && v.image) {
            if (v.image.src) {
              imageUrl = v.image.src;
              break;
            } else if (v.image.url) {
              imageUrl = v.image.url;
              break;
            } else if (typeof v.image === 'string') {
              imageUrl = v.image;
              break;
            }
          }
        }
        
        // FOURTH: Fallback to variantImage (stored when creating firmnessMap)
        if (!imageUrl && firmness.variantImage) {
          if (firmness.variantImage.src) {
            imageUrl = firmness.variantImage.src;
          } else if (typeof firmness.variantImage === 'string') {
            imageUrl = firmness.variantImage;
          }
        }
        
        // FIFTH: Last resort - use first product image if no variant-specific image found
        if (!imageUrl && productImages.length > 0) {
          const firstImage = productImages[0];
          imageUrl = firstImage.src || firstImage.url || firstImage.original || firstImage.original_src || (typeof firstImage === 'string' ? firstImage : null);
        }
      }
      
      // Process and validate image URL
      if (imageUrl) {
        // Ensure imageUrl is a string
        if (typeof imageUrl !== 'string') {
          imageUrl = imageUrl.src || imageUrl.url || imageUrl.original || imageUrl.original_src || String(imageUrl);
        }
        
        // Skip if it's a no-image placeholder
        if (imageUrl && (imageUrl.includes('no-image') || imageUrl.includes('no_image'))) {
          imageUrl = null;
        }
      }
      
      // Only create and append image if we have a valid URL
      if (imageUrl && !imageUrl.includes('no-image') && !imageUrl.includes('no_image')) {
        // Process image URL
        if (imageUrl.includes('_medium.') || imageUrl.includes('_small.')) {
          imageUrl = imageUrl.replace('_medium.', '_400x.').replace('_small.', '_400x.');
        } else if (!imageUrl.includes('?')) {
          imageUrl = `${imageUrl}?width=400&height=400&crop=center`;
        }
        
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = firmness.label;
        img.loading = 'lazy';
        img.onerror = function() {
          // Remove the image element and hide the div on error
          if (img.parentNode) {
            img.parentNode.removeChild(img);
          }
          if (imageDiv.parentNode) {
            imageDiv.style.display = 'none';
          }
        };
        imageDiv.appendChild(img);
        card.appendChild(imageDiv);
      }
      
      // Add Variant Name - BELOW IMAGE
      const variantName = document.createElement('p');
      variantName.className = 'firmness-variant-name';
      variantName.textContent = firmness.label;
      card.appendChild(variantName);
      
      // Create div for variant features - BELOW firmness-variant-name
      const variantInfoDiv = document.createElement('div');
      variantInfoDiv.className = 'firmness-variant-info';
      variantInfoDiv.style.marginTop = '2px';
      variantInfoDiv.style.padding = '0 5px';
      
      // Get features from FIRST variant in the firmness group
      // Prefer variant-specific firmness_feature_text metafield so each card shows its own data
      let featureText = '';
      
      if (firmness.variants && firmness.variants.length > 0) {
        const firstVariant = firmness.variants[0];
        const variantId = firstVariant.id.toString();
        const variantInfo = variantInfoMetafieldsMap.get(variantId);
        console.log('variantInfo: ', variantInfo);
        
        var featureSource = (variantInfo && variantInfo.firmness_feature_text != null) ? variantInfo.firmness_feature_text : (variantInfo && variantInfo.feature) ? variantInfo.feature : null;
        if (variantInfo && featureSource) {
          // Parse rich text JSON to extract actual text
          let featureData = featureSource;
          
          // If it's a string that looks like JSON, try to parse it
          if (typeof featureData === 'string') {
            // Check if it looks like a JSON object (starts with { or [)
            if (featureData.trim().startsWith('{') || featureData.trim().startsWith('[')) {
              try {
                featureData = JSON.parse(featureData);
              } catch (e) {
                // If parsing fails, use as is
              }
            }
          }
          
          const parsedFeature = parseRichTextToText(featureData);
          if (parsedFeature && parsedFeature.trim().length > 0 && parsedFeature !== 'null' && parsedFeature !== 'undefined') {
            featureText = parsedFeature.trim();
          }
        }
      }
      
      // Add Features text only (preserve spaces, line breaks, show list bullets)
      if (featureText) {
        const featureElement = document.createElement('div');
        featureElement.className = 'firmness-feature-text';
        var formatted = featureText.replace(/\r\n/g, '\n').trim();
        var lines = formatted.split(/\n/).map(function(s) { return s.trim(); }).filter(function(s) { return s.length > 0; });
        var bodyHtml;
        if (lines.length > 1) {
          bodyHtml = '<ul class="firmness-feature-list">' + lines.map(function(line) {
            var t = line.replace(/^[\s•\-*]+\s*/, '');
            return '<li>' + t.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</li>';
          }).join('') + '</ul>';
        } else {
          bodyHtml = formatted.replace(/\n/g, '<br>').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
        featureElement.innerHTML = '<strong>Features:</strong> ' + bodyHtml;
        featureElement.style.fontSize = '12px';
        featureElement.style.margin = '4px 0';
        featureElement.style.color = '#666';
        variantInfoDiv.appendChild(featureElement);
      }
      
      // Append variant info div after variant name (only if features exist)
      if (featureText) {
        card.appendChild(variantInfoDiv);
      }
      
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'firmness';
      radio.value = firmness.value;
      radio.dataset.variantId = firmness.variants[0].id;
      radio.dataset.variantIds = firmness.variants.map(v => v.id).join(',');
      radio.style.display = 'none';
      if (cardIndex === 0) radio.checked = true;
      card.appendChild(radio);
      
      card.addEventListener('click', async function() {
        document.querySelectorAll('.firmness-card').forEach(c => {
          c.classList.remove('selected');
          const ci = c.querySelector('.card-indicator');
          if (ci) ci.classList.remove('active');
        });
        this.classList.add('selected');

        const activeTabForFirmness = document.querySelector('#custom-product-container .tab.active');
        if (activeTabForFirmness) {
          applyPdpSelectionTabColors(activeTabForFirmness.getAttribute('data-tab-color'));
        }
        
        document.querySelectorAll('.firmness-card input[type="radio"]').forEach(r => r.checked = false);
        const radio = this.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          const variantIds = radio.dataset.variantIds.split(',').map(id => parseInt(id));
          const selectedVariants = productData.variants.filter(v => variantIds.includes(v.id));
          updateSizeOptionsForFirmness(selectedVariants, sizeIndex);
          currentFirmnessVariant = productData.variants.find(v => v.id === parseInt(radio.dataset.variantId));
          
          // Update variant info when firmness changes
          // Priority: 1) Selected size variant (if size is already selected), 2) First variant in firmness group
          let variantIdToUse = null;
          if (currentSizeVariant && selectedVariants.some(v => v.id === currentSizeVariant.id)) {
            // If current size variant is in the selected firmness group, use it
            variantIdToUse = currentSizeVariant.id.toString();
          } else if (selectedVariants && selectedVariants.length > 0) {
            // Otherwise use first variant in the firmness group
            variantIdToUse = selectedVariants[0].id.toString();
          }
          
          if (variantIdToUse) {
            updateVariantInfo(variantIdToUse);
            // Await so images update on first click (no need for second click)
            await updateVariantImageAndFeatures(variantIdToUse);
            updateVariantTechnicalSpecs(variantIdToUse);
            updateVariantPerformanceBlocks(variantIdToUse);
          }
          
          // Update variant name display
          updateVariantNameDisplay();
          
          // If foundation is selected, update foundation images based on new firmness selection
          // Otherwise, show mattress images
          if (isFoundationSelected && currentFoundationProduct) {
            const selectedFoundation = document.querySelector('input[name="foundation"]:checked');
            if (selectedFoundation) {
              const foundationOption = selectedFoundation.closest('.foundation-option');
              if (foundationOption) {
                handleFoundationVariantImageChange(foundationOption, currentFoundationProduct);
              }
            }
          } else if (!isFoundationSelected) {
            const activeVariantId = getActiveMattressVariantId();
            if (activeVariantId) {
              loadVariantImageGallery(activeVariantId);
            } else if (currentMattressImages && currentMattressImages.length > 0) {
              loadProductImages(currentMattressImages);
            }
          }
          
          // Update button states
          updateButtonStates();
        }
      });
      
      firmnessContainer.appendChild(card);
      cardIndex++;
    });
    
    if (firstFirmnessVariant) {
      const firstFirmness = firmnessMap.values().next().value;
      updateSizeOptionsForFirmness(firstFirmness.variants, sizeIndex);
      
      // Update variant info for first firmness variant
      if (firstFirmness.variants && firstFirmness.variants.length > 0) {
        const firstVariantId = firstFirmness.variants[0].id.toString();
        updateVariantInfo(firstVariantId);
        updateVariantImageAndFeatures(firstVariantId);
        updateVariantTechnicalSpecs(firstVariantId);
        updateVariantPerformanceBlocks(firstVariantId);
      }
      
      updateVariantNameDisplay();
    }

    if (activeTab) {
      applyPdpSelectionTabColors(activeTab.getAttribute('data-tab-color'));
    }
  }
  
  // Function to update size options based on selected firmness
  function updateSizeOptionsForFirmness(variants, sizeIndex = 1, preferredSizeLabel) {
    const preserveSize =
      (preferredSizeLabel && String(preferredSizeLabel).trim()) ||
      getCurrentMattressSizeValueFromUI() ||
      getCurrentMattressSizeValue();

    if (!variants || variants.length === 0) {
      loadSizeOptions([], preserveSize);
      return;
    }

    let modelFilter = selectedModelValue;
    if (!modelFilter && getUnderbedConfig()) {
      modelFilter = getNoFoundationModelLabel();
    }
    if (currentMattressProduct && modelFilter) {
      const { modelIndex } = detectOptionTypes(currentMattressProduct);
      if (modelIndex !== -1) {
        variants = filterVariantsByModelLabel(variants, modelFilter, modelIndex);
      }
    }
    if (!variants || variants.length === 0) {
      loadSizeOptions([], preserveSize);
      return;
    }
    
    // Sort variants to preserve product page order (by position in original product variants array)
    const sortedVariants = [...variants].sort((a, b) => {
      if (!currentMattressProduct || !currentMattressProduct.variants) {
        return 0; // If no product data, keep original order
      }
      
      // Find index in original product variants array
      const aIndex = currentMattressProduct.variants.findIndex(v => v.id === a.id);
      const bIndex = currentMattressProduct.variants.findIndex(v => v.id === b.id);
      
      // If both found, sort by original position
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      // If only one found, prioritize it
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
      // If neither found, keep original order
      return 0;
    });
    
    const sizeOptions = [];
    const seenSizeKeys = new Map();
    
    sortedVariants.forEach(variant => {
      let sizeValue = 'Standard';
      
      if (variant.options && variant.options[sizeIndex] !== undefined) {
        sizeValue = variant.options[sizeIndex];
      } else if (variant.option1 && sizeIndex === 0) {
        sizeValue = variant.option1;
      } else if (variant.option2 && sizeIndex === 1) {
        sizeValue = variant.option2;
      } else if (variant.option3 && sizeIndex === 2) {
        sizeValue = variant.option3;
      } else if (variant.title) {
        const titleParts = variant.title.split(' / ');
        if (titleParts.length > 1) {
          sizeValue = titleParts[1];
        } else if (titleParts.length === 1) {
          sizeValue = titleParts[0];
        }
      }
      
      sizeValue = sizeValue.toString();
      
      // IMPROVED availability check
      let isAvailable = false;
      let availabilityText = suavePdpT('inStock', 'In Stock');
      
      // Check if variant.available is explicitly true
      if (variant.available === true) {
        isAvailable = true;
      }
      // Check inventory policy - if continue, always available for backorder
      else if (variant.inventory_policy === 'continue') {
        isAvailable = true;
        availabilityText = suavePdpT('availableBackorder', 'Available for Backorder');
      }
      // Check inventory quantity
      else if (variant.inventory_quantity !== null && variant.inventory_quantity > 0) {
        isAvailable = true;
        if (variant.inventory_quantity < 10) {
          availabilityText = `Only ${variant.inventory_quantity} left`;
        }
      }
      // If inventory management is disabled, check if available is not false
      else if (variant.inventory_management === null && variant.available !== false) {
        isAvailable = true;
      }
      
      const sizeKey = sizeValue.toString().trim().toLowerCase();
      const optionPayload = {
        label: sizeValue,
        value: variant.id.toString(),
        variant: variant,
        price: variant.price,
        comparePrice: variant.compare_at_price,
        available: isAvailable,
        availabilityText: availabilityText,
        inventoryQuantity: variant.inventory_quantity,
        inventoryPolicy: variant.inventory_policy,
        inventoryManagement: variant.inventory_management
      };

      if (seenSizeKeys.has(sizeKey)) {
        const existingIndex = seenSizeKeys.get(sizeKey);
        const existing = sizeOptions[existingIndex];
        // Prefer an available variant when duplicate size labels exist
        if (existing && !existing.available && optionPayload.available) {
          sizeOptions[existingIndex] = optionPayload;
        }
      } else {
        seenSizeKeys.set(sizeKey, sizeOptions.length);
        sizeOptions.push(optionPayload);
      }
    });
    
    loadSizeOptions(sizeOptions, preserveSize);
  }
  
  // Function to load size options with improved availability display
  function loadSizeOptions(sizeOptions, preferredSizeLabel) {
    const sizeSelect = document.getElementById('size-select');
    if (!sizeSelect) return;

    const preferredSize = (preferredSizeLabel && String(preferredSizeLabel).trim()) || '';
    
    sizeSelect.innerHTML = '';
    
    if (sizeOptions.length === 0) {
      const option = document.createElement('option');
      option.value = '';
      option.textContent = suavePdpT('noSizesAvailable', 'No sizes available');
      option.disabled = true;
      option.selected = true;
      sizeSelect.appendChild(option);
    } else {
      // Use size options in the order they come from the product page (already sorted by updateSizeOptionsForFirmness)
      // No custom sorting - preserve product page order
      
      let firstAvailableVariant = null;
      let hasAvailableVariant = false;
      let variantToSelect = null;

      if (preferredSize) {
        const preferredAvailable = sizeOptions.find(
          (o) => mattressSizesMatch(o.label, preferredSize) && o.available
        );
        const preferredAny = sizeOptions.find((o) => mattressSizesMatch(o.label, preferredSize));
        if (preferredAvailable) variantToSelect = preferredAvailable.variant;
        else if (preferredAny) variantToSelect = preferredAny.variant;
      }
      
      sizeOptions.forEach((sizeOption, index) => {
        const option = document.createElement('option');
        option.value = sizeOption.variant.id;
        option.dataset.price = formatMoney(sizeOption.price);
        option.dataset.comparePrice = sizeOption.comparePrice ? formatMoney(sizeOption.comparePrice) : '';
        option.dataset.size = sizeOption.label;
        option.dataset.available = sizeOption.available;
        option.dataset.availabilityText = sizeOption.availabilityText;
        option.dataset.inventoryQuantity = sizeOption.inventoryQuantity;
        option.dataset.inventoryPolicy = sizeOption.inventoryPolicy;
        option.dataset.inventoryManagement = sizeOption.inventoryManagement;
        
        // Format the display text with stock status
        let displayText = sizeOption.label;
        const priceText = formatMoney(sizeOption.price);
        
        if (!sizeOption.available) {
          displayText = `${sizeOption.label} - Out of Stock`;
          option.disabled = true;
        } else {
          displayText = `${sizeOption.label} - ${priceText}`;
          hasAvailableVariant = true;
          
          if (!firstAvailableVariant && sizeOption.available) {
            firstAvailableVariant = sizeOption.variant;
          }
        }
        
        option.textContent = displayText;
        sizeSelect.appendChild(option);
      });

      if (!variantToSelect) {
        variantToSelect = firstAvailableVariant || (sizeOptions[0] && sizeOptions[0].variant) || null;
      }

      if (variantToSelect) {
        currentSizeVariant = variantToSelect;
        for (let i = 0; i < sizeSelect.options.length; i += 1) {
          if (String(sizeSelect.options[i].value) === String(variantToSelect.id)) {
            sizeSelect.selectedIndex = i;
            sizeSelect.options[i].selected = true;
            break;
          }
        }
      }
    }
    
    if (typeof window.rebuildCustomDropdown === 'function') {
      // Run immediately so firmness/size change updates images on first click (no 100ms delay)
      window.rebuildCustomDropdown();
      updateProductForSelectedVariant();
      updateButtonStates();
    } else {
      updateProductForSelectedVariant();
      updateButtonStates();
    }
  }
  
  // Function to update total price (main product + foundation)
  function updateTotalPrice() {
    updateNoFoundationCardPrice();
    refreshUnderbedCollectionCardPrices();

    // Use more specific selector to target the correct price element
    const priceElement = document.querySelector('#custom-product-container .price-amount') || 
                         document.querySelector('.price-amount');
    
    if (!priceElement) {
      console.warn('⚠️ Price element not found');
      return;
    }
    
    // Get main product price - try multiple sources
    let mainProductPrice = 0;

    if (getUnderbedConfig()) {
      const mattressForPrice = findMattressVariantForAddToCart();
      if (mattressForPrice && mattressForPrice.price != null) {
        mainProductPrice = parseInt(mattressForPrice.price, 10) || 0;
      }
    }

    // Method 1: From currentSizeVariant
    if (mainProductPrice === 0 && currentSizeVariant && currentSizeVariant.price) {
      mainProductPrice = parseInt(currentSizeVariant.price);
    }
    // Method 2: From size select dropdown
    else if (mainProductPrice === 0) {
      const sizeSelect = document.getElementById('size-select');
      if (sizeSelect && sizeSelect.selectedIndex >= 0) {
        const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
        if (selectedOption) {
          // Try to get price from the variant object if available
          const variantId = selectedOption.value;
          if (currentMattressProduct && currentMattressProduct.variants) {
            const variant = currentMattressProduct.variants.find(v => v.id.toString() === variantId);
            if (variant && variant.price) {
              mainProductPrice = parseInt(variant.price);
            }
          }
          
          // Fallback: Try data-price attribute (formatted price)
          if (mainProductPrice === 0) {
            const priceAttr = selectedOption.getAttribute('data-price');
            if (priceAttr) {
              // Extract numeric value from formatted price string (e.g., "$1,299.00" -> 129900)
              // Remove $ and commas, then parse
              const priceStr = priceAttr.replace(/[$,]/g, '');
              const priceFloat = parseFloat(priceStr);
              if (!isNaN(priceFloat)) {
                mainProductPrice = Math.round(priceFloat * 100); // Convert to cents
              }
            }
          }
        }
      }
    }
    
    // Base / foundation add-on (underbed collection or legacy foundation product)
    let addonPriceCents = 0;
    const underbedInput = getSelectedUnderbedInput();
    if (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) {
      syncCurrentFoundationFromUnderbedInput(underbedInput);
      addonPriceCents = getUnderbedAddonPriceCents();
    } else {
      const selectedFoundation = document.querySelector('input[name="foundation"]:checked');
      if (selectedFoundation) {
        if (currentFoundationVariant && currentFoundationVariant.price !== undefined && currentFoundationVariant.price !== null) {
          addonPriceCents = parseInt(currentFoundationVariant.price, 10) || 0;
        } else {
          const foundationPriceAttr = selectedFoundation.getAttribute('data-variant-price');
          if (foundationPriceAttr !== null && foundationPriceAttr !== '' && foundationPriceAttr !== 'null') {
            addonPriceCents = parseInt(foundationPriceAttr, 10) || 0;
          }
        }
      }
    }

    const totalPrice = mainProductPrice + addonPriceCents;
    
    // Update price display - use both textContent and innerHTML to ensure it updates
    const formattedPrice = formatMoney(totalPrice);
    
    // Try multiple methods to update the price
    if (priceElement) {
      priceElement.textContent = formattedPrice;
      priceElement.innerHTML = formattedPrice;
      
      // Also try to trigger a reflow to ensure the update is visible
      priceElement.style.display = 'none';
      priceElement.offsetHeight; // Trigger reflow
      priceElement.style.display = '';
    }
  }
  
  function updateButtonStates() {
    const addToCartBtn = document.getElementById('add-to-cart');
    const buyNowBtn = document.getElementById('buy-now');

    if (document.getElementById('custom-product-container') && document.querySelector('#md-sticky-atc')) {
      initMobileStickyATC();
    }

    if (!addToCartBtn || !buyNowBtn) return;
    
    // Update total price first
    updateTotalPrice();
    
    // Check mattress variant availability
    let isMattressAvailable = false;
    if (currentSizeVariant) {
      isMattressAvailable = 
        currentSizeVariant.available === true ||
        currentSizeVariant.inventory_policy === 'continue' ||
        (currentSizeVariant.inventory_quantity !== null && currentSizeVariant.inventory_quantity > 0) ||
        (currentSizeVariant.inventory_management === null && currentSizeVariant.available !== false);
    }
    
    // Check base/foundation availability if selected
    const underbedInput = getSelectedUnderbedInput();
    const selectedFoundation = document.querySelector('input[name="foundation"]:checked');
    let isFoundationAvailable = true;

    if (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) {
      isFoundationAvailable = isSelectedUnderbedSellable();
    } else if (selectedFoundation) {
      const isAvailable = selectedFoundation.getAttribute('data-variant-available') === 'true';
      const inventoryPolicy = selectedFoundation.getAttribute('data-variant-inventory-policy');
      const inventoryQuantity = selectedFoundation.getAttribute('data-variant-inventory');
      const inventoryManagement = selectedFoundation.getAttribute('data-variant-inventory-management');

      if (isAvailable === true) {
        isFoundationAvailable = true;
      } else if (inventoryPolicy === 'continue') {
        isFoundationAvailable = true;
      } else if (inventoryQuantity && parseInt(inventoryQuantity, 10) > 0) {
        isFoundationAvailable = true;
      } else if (inventoryManagement === 'null' || inventoryManagement === null) {
        isFoundationAvailable = true;
      } else {
        isFoundationAvailable = false;
      }
    }

    const hasBaseSelection =
      (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) || !!selectedFoundation;
    const isAllAvailable = isMattressAvailable && (isFoundationAvailable || !hasBaseSelection);
    
    if (!isAllAvailable) {
      addToCartBtn.textContent = suavePdpT('outOfStock', 'Out of Stock');
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('out-of-stock');
      
      buyNowBtn.disabled = true;
      buyNowBtn.classList.add('out-of-stock');
    } else {
      addToCartBtn.textContent = suavePdpT('addToCart', 'Add to Cart');
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('out-of-stock');
      
      buyNowBtn.disabled = false;
      buyNowBtn.classList.remove('out-of-stock');
    }

    if (document.getElementById('custom-product-container') && document.querySelector('#md-sticky-atc')) {
      updateStickyATC();
      const stickyBtn = document.querySelector('#md-sticky-atc [name="add"]');
      if (stickyBtn && addToCartBtn) {
        stickyBtn.disabled = addToCartBtn.disabled;
        stickyBtn.classList.toggle('out-of-stock', addToCartBtn.classList.contains('out-of-stock'));
        const stickyLabel = stickyBtn.querySelector('.md-sticky-atc-btn-label');
        if (stickyLabel) stickyLabel.textContent = addToCartBtn.textContent.trim();
      }
    }
  }

  function initMobileStickyATC() {
    const sticky = document.querySelector('#md-sticky-atc');
    const cta =
      document.querySelector('#custom-product-container .cta-buttons') ||
      document.getElementById('add-to-cart');
    if (!sticky || sticky.dataset.stickyBound === '1') return;
    sticky.dataset.stickyBound = '1';

    const mobileMq = window.matchMedia('(max-width: 989px)');

    const setBarVisible = (visible) => {
      if (!mobileMq.matches) {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('md-sticky-atc-visible');
        return;
      }
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('md-sticky-atc-visible', visible);
    };

    const evaluateVisibility = () => {
      if (!mobileMq.matches) {
        setBarVisible(false);
        return;
      }
      if (!cta) {
        setBarVisible(window.scrollY > 200);
        return;
      }
      const rect = cta.getBoundingClientRect();
      const ctaOffScreen = rect.bottom < 0 || rect.top > window.innerHeight - 80;
      setBarVisible(ctaOffScreen);
    };

    if (cta && typeof IntersectionObserver !== 'undefined') {
      const observer = new IntersectionObserver(
        (entries) => {
          if (!mobileMq.matches) return setBarVisible(false);
          const entry = entries[0];
          setBarVisible(entry ? !entry.isIntersecting : false);
        },
        { threshold: 0, rootMargin: '0px 0px -72px 0px' }
      );
      observer.observe(cta);
      sticky._suaveStickyAtcObserver = observer;
    } else {
      evaluateVisibility();
      window.addEventListener('scroll', evaluateVisibility, { passive: true });
    }

    mobileMq.addEventListener('change', evaluateVisibility);
    window.addEventListener('resize', evaluateVisibility, { passive: true });
    evaluateVisibility();
    updateStickyATC();
  }

  function updateStickyATC() {
    const sticky = document.querySelector('#md-sticky-atc');
    if (!sticky) return;
    const titleEl = sticky.querySelector('.product__title');
    const imgEl = sticky.querySelector('.sticky-atc-img, .product-content img');
    const selectionsEl = document.getElementById('sticky-atc-selections');
    const qtyWrap = sticky.querySelector('.sticky-atc-quantity-wrap');

    if (titleEl) {
      titleEl.textContent =
        (currentMattressProduct && currentMattressProduct.title) ||
        document.querySelector('#custom-product-container .product-title')?.textContent?.trim() ||
        '';
    }
    if (imgEl) {
      const mainImg = document.getElementById('main-image');
      if (mainImg && mainImg.src && mainImg.src.trim()) {
        imgEl.src = mainImg.src;
        if (mainImg.alt) imgEl.alt = mainImg.alt;
      } else if (currentMattressProduct) {
        const selectedFoundation = document.querySelector('input[name="foundation"]:checked');
        const foundationOption = selectedFoundation ? selectedFoundation.closest('.foundation-option') : null;
        const foundationImageUrl = foundationOption ? foundationOption.getAttribute('data-variant-image') : null;
        if (foundationImageUrl && foundationImageUrl.trim()) {
          imgEl.src = foundationImageUrl.trim();
        } else if (currentMattressProduct.featured_image && currentMattressProduct.featured_image.src) {
          imgEl.src = currentMattressProduct.featured_image.src;
        } else if (currentMattressProduct.images && currentMattressProduct.images[0] && currentMattressProduct.images[0].src) {
          imgEl.src = currentMattressProduct.images[0].src;
        }
      }
    }
    // Update sticky price: only set sale price; show compare-at only when it is greater than variant price
    const mainPriceEl = document.querySelector('#custom-product-container .price-amount');
    const mainCompareEl = document.querySelector('#custom-product-container .compare-at-price');
    const priceContainer = sticky.querySelector('.sticky-atc-price, .sticky-atc-product-details .price');
    if (priceContainer) {
      const salePriceEl = priceContainer.querySelector('.price-item--sale, .price-item--last');
      const compareWrap = priceContainer.querySelector('.price__sale s.price-item--regular, .price__sale .price-item--regular');
      const saleBadge = priceContainer.querySelector('.price__badge-sale');
      const formattedPrice = (mainPriceEl && mainPriceEl.textContent) ? mainPriceEl.textContent.trim() : (currentSizeVariant ? formatMoney(currentSizeVariant.price) : '');
      if (salePriceEl && formattedPrice) salePriceEl.textContent = formattedPrice;
      var showCompare = false;
      var formattedCompare = '';
      if (currentSizeVariant && currentSizeVariant.compare_at_price && parseInt(currentSizeVariant.compare_at_price, 10) > parseInt(currentSizeVariant.price, 10)) {
        showCompare = true;
        formattedCompare = formatMoney(currentSizeVariant.compare_at_price);
      } else if (mainCompareEl && mainCompareEl.style.display !== 'none' && mainCompareEl.textContent && mainPriceEl && mainPriceEl.textContent) {
        var compareText = mainCompareEl.textContent.trim();
        var priceText = mainPriceEl.textContent.trim();
        if (compareText && compareText !== priceText) {
          showCompare = true;
          formattedCompare = compareText;
        }
      }
      if (compareWrap) {
        if (showCompare && formattedCompare) {
          compareWrap.textContent = formattedCompare;
          if (compareWrap.closest('span')) compareWrap.closest('span').style.display = '';
          priceContainer.classList.add('price--on-sale');
        } else {
          compareWrap.textContent = '';
          if (compareWrap.closest('span')) compareWrap.closest('span').style.display = 'none';
          priceContainer.classList.remove('price--on-sale');
        }
      } else {
        if (showCompare) priceContainer.classList.add('price--on-sale');
        else priceContainer.classList.remove('price--on-sale');
      }
      if (saleBadge) saleBadge.style.display = showCompare ? '' : 'none';
    }

    if (selectionsEl) {
      const variantNameEl = document.getElementById('variant-name-display');
      const foundationNameEl = document.getElementById('foundation-name-display');
      const sizeSelect = document.getElementById('size-select');
      const parts = [];
      if (sizeSelect && sizeSelect.selectedIndex >= 0) {
        const sizeOption = sizeSelect.options[sizeSelect.selectedIndex];
        if (sizeOption && sizeOption.text) parts.push(sizeOption.text.trim());
      }
      if (variantNameEl && variantNameEl.textContent) parts.push(variantNameEl.textContent.trim());
      if (foundationNameEl && foundationNameEl.textContent) {
        const foundationText = foundationNameEl.textContent.trim();
        if (foundationText) parts.push('Foundation: ' + foundationText);
      }
      if (parts.length > 0) {
        selectionsEl.textContent = parts.join(' · ');
        selectionsEl.style.display = '';
      } else {
        selectionsEl.style.display = 'none';
      }
    }
    if (qtyWrap) qtyWrap.style.display = 'none';
  }
  
  // Function to update browser address bar URL
  function updateProductUrlDisplay(productHandle) {
    const baseUrl = window.location.origin;
    const productUrl = `${baseUrl}/products/${productHandle}`;
    
    // Update browser address bar without page reload
    if (window.history && window.history.replaceState) {
      window.history.replaceState({ path: productUrl }, '', productUrl);
    }
  }
  
  // Tab switching for mattress products
  const tabs = document.querySelectorAll("#custom-product-container .tab");
  
  tabs.forEach((tab) => {
    tab.addEventListener("click", async function (e) {
      // Save current scroll position to prevent auto-scroll
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      
      applyMattressTabActiveVisuals(this);
      const tabColor = this.getAttribute('data-tab-color');
      
      const productHandle = this.dataset.tab;
      
      // Update browser address bar URL
      if (productHandle) {
        updateProductUrlDisplay(productHandle);
      }
      
      updateTitleLastWordColor();

      try {
        // Fetch product with metafields
        const response = await fetch(suavePdpProductJsonUrl(productHandle));
        if (response.ok) {
          const productData = await response.json();
          // Fetch variant metafields separately if needed
          if (productData.variants && productData.variants.length > 0) {
            await fetchVariantMetafields(productData);
          }
          await updateMattressProduct(productData, this);
          
          if (document.getElementById('custom-product-container') && document.querySelector('#md-sticky-atc')) {
            updateStickyATC();
            setTimeout(function() {
              updateStickyATC();
            }, 450);
          }
          
          // Restore scroll position after product update to prevent auto-scroll
          window.scrollTo(0, scrollPosition);
          requestAnimationFrame(() => {
            window.scrollTo(0, scrollPosition);
          });
        } else {
          console.error('Failed to fetch product:', response.status);
        }
      } catch (error) {
        console.error('Error loading product data:', error);
      }
    });
  });
  
  // Handle browser back/forward buttons
  window.addEventListener('popstate', function () {
    const matchingTab = findMattressTabForPageProduct();
    if (matchingTab && !matchingTab.classList.contains('active')) {
      activateMattressTabForPageProduct({ skipUrlUpdate: true });
    }
  });
  
  // Size selection handler
  const sizeSelect = document.getElementById("size-select");
  if (sizeSelect) {
    sizeSelect.addEventListener("change", function () {
      updateProductForSelectedVariant();
      updateButtonStates();
    });
  }

  // Function to update variant name display
  function updateVariantNameDisplay() {
    const variantNameDisplay = document.getElementById('variant-name-display');
    const foundationNameDisplay = document.getElementById('foundation-name-display');
    
    if (!variantNameDisplay) return;
    
    // Get current firmness variant name
    if (currentFirmnessVariant) {
      const { firmnessIndex } = detectOptionTypes(currentMattressProduct);
      let firmnessValue = 'Standard';
      
      if (currentFirmnessVariant.options && currentFirmnessVariant.options[firmnessIndex] !== undefined) {
        firmnessValue = currentFirmnessVariant.options[firmnessIndex];
      } else if (currentFirmnessVariant.option1 && firmnessIndex === 0) {
        firmnessValue = currentFirmnessVariant.option1;
      } else if (currentFirmnessVariant.option2 && firmnessIndex === 1) {
        firmnessValue = currentFirmnessVariant.option2;
      } else if (currentFirmnessVariant.option3 && firmnessIndex === 2) {
        firmnessValue = currentFirmnessVariant.option3;
      }
      
      variantNameDisplay.textContent = firmnessValue;
      variantNameDisplay.style.display = 'block';
    } else {
      variantNameDisplay.style.display = 'none';
    }
    
    // Get foundation / base name if selected
    if (foundationNameDisplay) {
      const underbedInput = getSelectedUnderbedInput();
      let foundationTitle = '';
      if (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) {
        foundationTitle = underbedInput.getAttribute('data-foundation-type') || '';
      } else {
        const selectedFoundation = document.querySelector('input[name="foundation"]:checked');
        if (selectedFoundation) {
          foundationTitle = selectedFoundation.getAttribute('data-variant-title') || '';
        }
      }
      if (foundationTitle) {
        foundationNameDisplay.textContent = suaveTWithFoundation(foundationTitle);
        foundationNameDisplay.style.display = 'block';
      } else {
        foundationNameDisplay.style.display = 'none';
      }
    }
  }

  // Function to update variant info (short, long) from variant info metafields
  function updateVariantInfo(variantId) {
    if (!variantId) return;
    const variantIdStr = variantId.toString();
    const variantInfo = variantInfoMetafieldsMap.get(variantIdStr);
    
    // Update firmness card title with variant title
    if (variantInfo && variantInfo.title && variantInfo.title.trim() !== '') {
      const firmnessCardTitle = document.querySelector('.firmness-card.selected .firmness-card-title');
      if (firmnessCardTitle) {
        firmnessCardTitle.textContent = variantInfo.title.trim();
      }
    }
    
    // Keep Shopify product description (locale from Liquid); never overwrite with English .js API text
    restoreLocalizedProductDescription(
      currentActiveTab || document.querySelector('#custom-product-container .tab.active')
    );
    
    // Update meta variant description with long text (preserve spaces and line breaks)
    const metaVariantDescription = document.getElementById('meta-varaint-description');
    if (metaVariantDescription && variantInfo && variantInfo.long && variantInfo.long.trim() !== '') {
      var longText = variantInfo.long.trim();
      if (longText.indexOf('<') === -1 || longText.indexOf('>') === -1) {
        longText = longText.replace(/\r\n/g, '\n').replace(/\n/g, '<br>');
      }
      metaVariantDescription.innerHTML = longText;
    } else if (metaVariantDescription) {
      metaVariantDescription.innerHTML = '';
    }
  }
  
  // Function to update variant image and features section
  async function updateVariantImageAndFeatures(variantId) {
    if (!variantId) return;
    if (!isFoundationSelected) {
      loadVariantImageGallery(variantId);
    }
    
    // Check if section exists on page
    // Try multiple selectors for image element
    let imageElement = document.getElementById('variant-image-data');

    if (!imageElement) {
      imageElement = document.querySelector('[data-attribute="variant-image-data"]');
    }
    if (!imageElement) {
      imageElement = document.querySelector('[id="variant-image-data"]');
    }
    // Also try finding by wrapper class
    if (!imageElement) {
      const wrapper = document.querySelector('.custom-image-feature__image-wrapper');
      if (wrapper) {
        imageElement = wrapper;
      }
    }
    const headingElements = document.querySelectorAll('#variant-data-heading');
    const descriptionElements = document.querySelectorAll('#variant-data-description');
    
    if (!imageElement && headingElements.length === 0 && descriptionElements.length === 0) {
      // Section not present on page, exit
      return;
    }
    
    try {
      // Get variant metafield data from map (loaded from Liquid template)
      const variantIdStr = variantId.toString();
      let variantMetafieldData = variantImageFeaturesMap.get(variantIdStr);
    
      
      // Try alternative variant ID formats
      if (!variantMetafieldData) {
        const variantIdNum = parseInt(variantIdStr);
        if (!isNaN(variantIdNum)) {
          variantMetafieldData = variantImageFeaturesMap.get(variantIdNum.toString()) || 
                                 variantImageFeaturesMap.get(String(variantIdNum));
        }
      }
      
      // If not found in map, try to get from current variant object
      if (!variantMetafieldData && currentMattressProduct && currentMattressProduct.variants) {
        const variant = currentMattressProduct.variants.find(v => 
          v.id.toString() === variantIdStr || 
          v.id === parseInt(variantIdStr) ||
          String(v.id) === variantIdStr
        );
        if (variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.variant_image_and_features) {
          variantMetafieldData = variant.metafields.custom.variant_image_and_features;
          // Handle metaobject - get value if it exists
          if (variantMetafieldData && typeof variantMetafieldData === 'object' && variantMetafieldData.value) {
            variantMetafieldData = variantMetafieldData.value;
          }
        }
      }
      
      // Validate variant data - check if it has actual content
      let hasVariantData = false;
      if (variantMetafieldData) {
        // Check if image exists and is valid - try both "image" and "Image" (case-insensitive)
        const imageField = variantMetafieldData.image || variantMetafieldData.Image;
        const hasImage = imageField && 
                        imageField !== null && 
                        imageField !== 'null' &&
                        imageField !== '';
        
        // Check if heading exists and is valid
        let headingData = variantMetafieldData.heading;
        if (headingData && typeof headingData === 'object' && headingData.value) {
          headingData = headingData.value;
        }
        const hasHeading = headingData && 
                          headingData !== null && 
                          headingData !== 'null' &&
                          (Array.isArray(headingData) ? headingData.length > 0 : String(headingData).trim() !== '');
        
        // Check if description exists and is valid
        let descData = variantMetafieldData.description;
        if (descData && typeof descData === 'object' && descData.value) {
          descData = descData.value;
        }
        const hasDescription = descData && 
                              descData !== null && 
                              descData !== 'null' &&
                              (Array.isArray(descData) ? descData.length > 0 : String(descData).trim() !== '');
        
        hasVariantData = hasImage || hasHeading || hasDescription;
      }
      
      // If no valid variant data, set to null to use customizer data
      if (!hasVariantData) {
        variantMetafieldData = null;
      }
      
      // Update image if variant has image data
      if (imageElement) {
        // Hide all customizer images and placeholder first
        const customizerImages = imageElement.querySelectorAll('img:not([data-variant-image])');
        const placeholder = imageElement.querySelector('.custom-image-feature__image-placeholder');
        
        customizerImages.forEach(img => {
          img.style.cssText = 'display: none !important; visibility: hidden !important;';
        });
        if (placeholder) {
          placeholder.style.cssText = 'display: none !important; visibility: hidden !important;';
        }
        
        // Check if variant has valid image data - try both "image" and "Image" (case-insensitive)
        let imageField = null;
        if (variantMetafieldData) {
          // Try lowercase first, then uppercase
          imageField = variantMetafieldData.image || variantMetafieldData.Image;
          
          // Also check all keys case-insensitively
          if (!imageField) {
            for (const key in variantMetafieldData) {
              if (key.toLowerCase() === 'image') {
                imageField = variantMetafieldData[key];
                break;
              }
            }
          }
        }
        
        if (imageField && 
            imageField !== null && 
            imageField !== 'null' &&
            imageField !== '' &&
            imageField !== undefined) {
          let imgSrc = '';
          
          // Handle different image formats - check all possible structures
          const imageData = imageField;
          
          // First, try direct string
          if (typeof imageData === 'string' && imageData.trim() !== '' && imageData !== 'null' && !imageData.includes('gid://')) {
            imgSrc = imageData.trim();
          }
          // If object, try various properties
          else if (imageData && typeof imageData === 'object' && imageData !== null) {
            // Try direct properties first (src, url)
            if (imageData.src && typeof imageData.src === 'string' && imageData.src.trim() !== '' && !imageData.src.includes('gid://')) {
              imgSrc = imageData.src.trim();
            } else if (imageData.url && typeof imageData.url === 'string' && imageData.url.trim() !== '' && !imageData.url.includes('gid://')) {
              imgSrc = imageData.url.trim();
            } 
            // Try preview property (Shopify media format) - check first as it's common
            else if (imageData.preview) {
              if (imageData.preview.src && typeof imageData.preview.src === 'string' && imageData.preview.src.trim() !== '' && !imageData.preview.src.includes('gid://')) {
                imgSrc = imageData.preview.src.trim();
              } else if (imageData.preview.url && typeof imageData.preview.url === 'string' && imageData.preview.url.trim() !== '' && !imageData.preview.url.includes('gid://')) {
                imgSrc = imageData.preview.url.trim();
              }
            }
            // Try value property (for metaobject references)
            else if (imageData.value) {
              const imgValue = imageData.value;
              if (typeof imgValue === 'string' && imgValue.trim() !== '' && imgValue !== 'null' && !imgValue.includes('gid://')) {
                imgSrc = imgValue.trim();
              } else if (imgValue && typeof imgValue === 'object' && imgValue !== null) {
                // Nested object - try src, url, or preview
                if (imgValue.src && typeof imgValue.src === 'string' && imgValue.src.trim() !== '' && !imgValue.src.includes('gid://')) {
                  imgSrc = imgValue.src.trim();
                } else if (imgValue.url && typeof imgValue.url === 'string' && imgValue.url.trim() !== '' && !imgValue.url.includes('gid://')) {
                  imgSrc = imgValue.url.trim();
                } else if (imgValue.preview && imgValue.preview.src) {
                  // Try preview.src for Shopify media objects
                  imgSrc = imgValue.preview.src;
                }
              }
            }
          }
          
          // Validate image URL - must be valid HTTP/HTTPS URL, not gid://
          // Also check if it's a Shopify CDN URL (cdn.shopify.com)
          const isValidUrl = imgSrc && 
                            imgSrc.trim() !== '' && 
                            !imgSrc.includes('gid://') && 
                            imgSrc !== 'null' && 
                            (imgSrc.startsWith('http') || 
                             imgSrc.startsWith('//') || 
                             imgSrc.startsWith('/') ||
                             imgSrc.includes('cdn.shopify.com'));
          
          if (isValidUrl) {
            // Check if variant image already exists
            let variantImg = imageElement.querySelector('img[data-variant-image]');
            if (variantImg) {
              variantImg.src = imgSrc;
              // Create proper srcset for responsive images
              const baseUrl = imgSrc.split('?')[0]; // Remove query params for srcset
              variantImg.srcset = `${baseUrl}?width=350 350w, ${baseUrl}?width=750 750w, ${baseUrl}?width=1100 1100w, ${imgSrc} ${imgSrc.includes('width=') ? '' : '1100w'}`;
              variantImg.style.cssText = 'display: block !important; visibility: visible !important; width: 100% !important; height: auto !important;';
            } else {
              // Create variant image if doesn't exist
              variantImg = document.createElement('img');
              variantImg.src = imgSrc;
              const baseUrl = imgSrc.split('?')[0];
              variantImg.srcset = `${baseUrl}?width=350 350w, ${baseUrl}?width=750 750w, ${baseUrl}?width=1100 1100w, ${imgSrc} ${imgSrc.includes('width=') ? '' : '1100w'}`;
              variantImg.className = 'custom-image-feature__image';
              variantImg.loading = 'lazy';
              variantImg.setAttribute('data-variant-image', 'true');
              variantImg.alt = 'Variant image';
              variantImg.style.cssText = 'display: block !important; visibility: visible !important; width: 100% !important; height: auto !important;';
              imageElement.appendChild(variantImg);
            }
            // Ensure customizer images and placeholder are hidden
            customizerImages.forEach(img => {
              img.style.cssText = 'display: none !important; visibility: hidden !important;';
            });
            if (placeholder) {
              placeholder.style.cssText = 'display: none !important; visibility: hidden !important;';
            }
          } else {
            // No valid variant image - show customizer images or placeholder
            const variantImg = imageElement.querySelector('img[data-variant-image]');
            if (variantImg) {
              variantImg.style.cssText = 'display: none !important; visibility: hidden !important;';
            }
            // Show customizer image if exists, otherwise show placeholder
            if (customizerImages.length > 0) {
              customizerImages.forEach(img => {
                img.style.cssText = 'display: block !important; visibility: visible !important;';
              });
              if (placeholder) {
                placeholder.style.cssText = 'display: none !important; visibility: hidden !important;';
              }
            } else if (placeholder) {
              placeholder.style.cssText = 'display: block !important; visibility: visible !important;';
            }
          }
        } else {
          // No variant image data - show customizer images or placeholder
          const variantImg = imageElement.querySelector('img[data-variant-image]');
          if (variantImg) {
            variantImg.style.cssText = 'display: none !important; visibility: hidden !important;';
          }
          // Show customizer image if exists, otherwise show placeholder
          if (customizerImages.length > 0) {
            customizerImages.forEach(img => {
              img.style.cssText = 'display: block !important; visibility: visible !important;';
            });
            if (placeholder) {
              placeholder.style.cssText = 'display: none !important; visibility: hidden !important;';
            }
          } else if (placeholder) {
            placeholder.style.cssText = 'display: block !important; visibility: visible !important;';
          }
        }
      }
      
      // Update heading and description if variant has data (handle list format)
      const blocksContainer = document.querySelector('.custom-image-feature__blocks-container');
      if (blocksContainer) {
        if (variantMetafieldData) {
          let headingData = variantMetafieldData.heading;
          let descData = variantMetafieldData.description;
          
          // Handle metaobject values
          if (headingData && typeof headingData === 'object' && headingData.value) {
            headingData = headingData.value;
          }
          if (descData && typeof descData === 'object' && descData.value) {
            descData = descData.value;
          }
          
          // Convert to arrays if needed
          let headingArray = [];
          let descArray = [];
          
          if (Array.isArray(headingData)) {
            headingArray = headingData;
          } else if (headingData && typeof headingData === 'string' && headingData.trim() !== '') {
            headingArray = [headingData.trim()];
          }
          
          if (Array.isArray(descData)) {
            descArray = descData;
          } else if (descData && typeof descData === 'string' && descData.trim() !== '') {
            descArray = [descData.trim()];
          }
          
          // Determine max length - use metafield data length, not customizer blocks
          const maxLength = Math.max(headingArray.length, descArray.length);
          
          // Hide all existing blocks first (but don't remove them yet)
          const existingBlocks = blocksContainer.querySelectorAll('.custom-image-feature__block');
          existingBlocks.forEach(block => {
            block.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important;';
          });
          
          // Create or update blocks for each data pair - ensure loop runs completely
          if (maxLength > 0) {
            for (let i = 0; i < maxLength; i++) {
              const headingText = headingArray[i] ? String(headingArray[i]).trim() : '';
              const descText = descArray[i] ? String(descArray[i]).trim() : '';
              
              // Skip if both heading and description are empty
              if (!headingText && !descText) {
                // Still hide the block if it exists
                if (existingBlocks[i]) {
                  existingBlocks[i].style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important;';
                }
                continue;
              }
              
              // Get or create block element
              let blockElement = existingBlocks[i];
              if (!blockElement) {
                // Create new block if needed
                blockElement = document.createElement('div');
                blockElement.className = 'custom-image-feature__block pdp-border-color';
                blockElement.setAttribute('data-variant-block', 'true');
                const blockInner = document.createElement('div');
                blockInner.className = 'custom-image-feature__block-inner';
                blockElement.appendChild(blockInner);
                blocksContainer.appendChild(blockElement);
              }
              
              // Show block properly - remove all inline styles but keep classes
              blockElement.style.cssText = '';
              blockElement.removeAttribute('style');
              // Ensure classes are present
              if (!blockElement.classList.contains('custom-image-feature__block')) {
                blockElement.classList.add('custom-image-feature__block');
              }
              if (!blockElement.classList.contains('pdp-border-color')) {
                blockElement.classList.add('pdp-border-color');
              }
              
              let blockInner = blockElement.querySelector('.custom-image-feature__block-inner');
              if (!blockInner) {
                blockInner = document.createElement('div');
                blockInner.className = 'custom-image-feature__block-inner';
                blockElement.appendChild(blockInner);
              }
              
              // Update or create heading
              if (headingText) {
                let headingEl = blockInner.querySelector('.custom-image-feature__block-heading');
                if (!headingEl) {
                  headingEl = document.createElement('p');
                  headingEl.className = 'custom-image-feature__block-heading pdp-text-color';
                  blockInner.insertBefore(headingEl, blockInner.firstChild);
                }
                headingEl.textContent = headingText;
                headingEl.setAttribute('data-variant-heading', 'true');
                headingEl.style.cssText = '';
                headingEl.removeAttribute('style');
                // Ensure classes are present
                if (!headingEl.classList.contains('custom-image-feature__block-heading')) {
                  headingEl.classList.add('custom-image-feature__block-heading');
                }
                if (!headingEl.classList.contains('pdp-text-color')) {
                  headingEl.classList.add('pdp-text-color');
                }
                // Re-apply current PDP text color (we cleared style above, so pdp-text-color would show accent otherwise)
                if (headingEl.classList.contains('pdp-text-color')) {
                  const activeTab = document.querySelector('.mattress-type-tabs .tab.active');
                  const tabColor = activeTab && activeTab.getAttribute('data-tab-color');
                  if (tabColor && tabColor.trim() !== '' && tabColor !== 'null') {
                    headingEl.style.color = tabColor.trim();
                    headingEl.style.setProperty('--pdp-text-color', tabColor.trim());
                  }
                }
              } else {
                // Hide heading if empty
                const headingEl = blockInner.querySelector('.custom-image-feature__block-heading');
                if (headingEl) {
                  if (headingEl.hasAttribute('data-variant-heading')) {
                    headingEl.style.cssText = 'display: none !important;';
                  }
                }
              }
              
              // Update or create description
              if (descText) {
                let descEl = blockInner.querySelector('.custom-image-feature__block-content');
                if (!descEl) {
                  descEl = document.createElement('div');
                  descEl.className = 'custom-image-feature__block-content';
                  blockInner.appendChild(descEl);
                }
                descEl.innerHTML = descText;
                descEl.setAttribute('data-variant-content', 'true');
                descEl.style.cssText = '';
                descEl.removeAttribute('style');
              } else {
                // Hide description if empty
                const descEl = blockInner.querySelector('.custom-image-feature__block-content');
                if (descEl) {
                  if (descEl.hasAttribute('data-variant-content')) {
                    descEl.style.cssText = 'display: none !important;';
                  }
                }
              }
            }
          }
        } else {
          // No variant data or invalid data - show customizer blocks
          const existingBlocks = blocksContainer.querySelectorAll('.custom-image-feature__block');
          existingBlocks.forEach(block => {
            block.style.cssText = '';
            block.removeAttribute('style');
          });
          
          // Hide any variant-created blocks
          const variantBlocks = blocksContainer.querySelectorAll('.custom-image-feature__block[data-variant-block]');
          variantBlocks.forEach(block => {
            block.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important;';
          });
        }
      }
      
    } catch (e) {
      // Silent error - fallback to customizer data
    }
  }

  // Function to update variant technical specifications section
  function updateVariantTechnicalSpecs(variantId) {
    if (!variantId) return;
    
    // Check if section exists on page (use class - section has .custom-text-feature__features)
    const featuresContainer = document.querySelector('.custom-text-feature__features');
    if (!featuresContainer) {
      return;
    }
    const titleElements = featuresContainer.querySelectorAll('.custom-text-feature__feature-label');
    const featureElements = featuresContainer.querySelectorAll('.custom-text-feature__feature-value');
    
    if (titleElements.length === 0 && featureElements.length === 0) {
      return;
    }
    
    try {
      // Get variant metafield data from map (loaded from Liquid template)
      const variantIdStr = variantId.toString();
      let variantSpecsData = variantTechnicalSpecsMap.get(variantIdStr);
      
      // Try alternative variant ID formats
      if (!variantSpecsData) {
        const variantIdNum = parseInt(variantIdStr);
        if (!isNaN(variantIdNum)) {
          variantSpecsData = variantTechnicalSpecsMap.get(variantIdNum.toString()) || 
                            variantTechnicalSpecsMap.get(String(variantIdNum));
        }
      }
      
      // If not found in map, try to get from current variant object
      if (!variantSpecsData && currentMattressProduct && currentMattressProduct.variants) {
        const variant = currentMattressProduct.variants.find(v => 
          v.id.toString() === variantIdStr || 
          v.id === parseInt(variantIdStr) ||
          String(v.id) === variantIdStr
        );
        if (variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.technical_specifications_variants) {
          variantSpecsData = variant.metafields.custom.technical_specifications_variants;
          // Handle metaobject - get value if it exists
          if (variantSpecsData && typeof variantSpecsData === 'object' && variantSpecsData.value) {
            variantSpecsData = variantSpecsData.value;
          }
        }
      }
      
      // Validate variant data - check if it has actual content (support titles/headings)
      let hasVariantData = false;
      if (variantSpecsData) {
        let titlesData = variantSpecsData.titles || variantSpecsData.headings;
        if (titlesData && typeof titlesData === 'object' && titlesData.value) {
          titlesData = titlesData.value;
        }
        const hasTitles = titlesData && 
                         titlesData !== null && 
                         titlesData !== 'null' &&
                         (Array.isArray(titlesData) ? titlesData.length > 0 : String(titlesData).trim() !== '');
        
        let featuresData = variantSpecsData.features || variantSpecsData.feature;
        if (featuresData && typeof featuresData === 'object' && featuresData.value) {
          featuresData = featuresData.value;
        }
        const hasFeatures = featuresData && 
                           featuresData !== null && 
                           featuresData !== 'null' &&
                           (Array.isArray(featuresData) ? featuresData.length > 0 : String(featuresData).trim() !== '');
        
        hasVariantData = hasTitles || hasFeatures;
      }
      
      // If no valid variant data, set to null to use customizer data
      if (!hasVariantData) {
        variantSpecsData = null;
      }
      
      // Get all existing feature items (featuresContainer already set above)
      const existingItems = featuresContainer.querySelectorAll('.custom-text-feature__feature-item');
      
      // Store original customizer data if not already stored (store per item)
      existingItems.forEach((item, idx) => {
        const titleEl = item.querySelector('.custom-text-feature__feature-label');
        const featureEl = item.querySelector('.custom-text-feature__feature-value');
        
        if (titleEl && !titleEl.hasAttribute('data-customizer-title') && titleEl.textContent && titleEl.textContent.trim() !== '') {
          titleEl.setAttribute('data-customizer-title', titleEl.textContent);
        }
        if (featureEl && !featureEl.hasAttribute('data-customizer-feature') && featureEl.textContent && featureEl.textContent.trim() !== '') {
          featureEl.setAttribute('data-customizer-feature', featureEl.textContent);
        }
      });
      
      if (variantSpecsData) {
        // Get titles and features arrays (support titles/headings and features/feature)
        let titlesData = variantSpecsData.titles || variantSpecsData.headings;
        let featuresData = variantSpecsData.features || variantSpecsData.feature;
        
        // Handle metaobject values
        if (titlesData && typeof titlesData === 'object' && titlesData.value) {
          titlesData = titlesData.value;
        }
        if (featuresData && typeof featuresData === 'object' && featuresData.value) {
          featuresData = featuresData.value;
        }
        
        // Convert to arrays – one entry per row (title 1, feature 1 | title 2, feature 2 | ...)
        let titlesArray = [];
        let featuresArray = [];
        
        if (Array.isArray(titlesData)) {
          titlesArray = titlesData.map(t => t == null || t === 'null' || t === undefined ? '' : String(t).trim());
        } else if (titlesData && typeof titlesData === 'string' && titlesData !== 'null') {
          titlesArray = [titlesData.trim()];
        }
        
        if (Array.isArray(featuresData)) {
          featuresArray = featuresData.map(f => f == null || f === 'null' || f === undefined ? '' : String(f).trim());
        } else if (featuresData && typeof featuresData === 'string' && featuresData !== 'null') {
          featuresArray = [featuresData.trim()];
        }
        
        // When ALL titles/features came as one comma-separated string, split into one per row
        if (titlesArray.length === 1 && titlesArray[0] && titlesArray[0].indexOf(',') !== -1) {
          titlesArray = titlesArray[0].split(',').map(s => s.trim()).filter(Boolean);
        }
        if (featuresArray.length === 1 && featuresArray[0] && featuresArray[0].indexOf(',') !== -1) {
          featuresArray = featuresArray[0].split(',').map(s => s.trim()).filter(Boolean);
        }
        
        const maxLength = Math.max(titlesArray.length, featuresArray.length);
        while (titlesArray.length < maxLength) titlesArray.push('');
        while (featuresArray.length < maxLength) featuresArray.push('');
        
        // Update or show existing rows; hide only extra rows. Don't hide all first – keeps same design.
        if (maxLength > 0) {
          for (let i = 0; i < maxLength; i++) {
            // Keep comma-separated values as-is (e.g. "Value A, Value B")
            const titleText = titlesArray[i] != null ? String(titlesArray[i]) : '';
            const featureText = featuresArray[i] != null ? String(featuresArray[i]) : '';
            
            // Get or create feature item – same structure as Liquid
            let itemElement = existingItems[i];
            if (!itemElement) {
              itemElement = document.createElement('div');
              itemElement.className = 'custom-text-feature__feature-item' + (i < maxLength - 1 ? ' custom-text-feature__feature-item--with-divider' : '');
              itemElement.setAttribute('data-variant-item', 'true');
              const itemContent = document.createElement('div');
              itemContent.className = 'custom-text-feature__feature-content';
              const labelSpan = document.createElement('span');
              labelSpan.className = 'custom-text-feature__feature-label';
              const valueSpan = document.createElement('span');
              valueSpan.className = 'custom-text-feature__feature-value';
              itemContent.appendChild(labelSpan);
              itemContent.appendChild(valueSpan);
              itemElement.appendChild(itemContent);
              featuresContainer.appendChild(itemElement);
            }
            
            itemElement.removeAttribute('style');
            if (i < maxLength - 1) {
              itemElement.classList.add('custom-text-feature__feature-item--with-divider');
            } else {
              itemElement.classList.remove('custom-text-feature__feature-item--with-divider');
            }
            
            const itemContent = itemElement.querySelector('.custom-text-feature__feature-content');
            const titleEl = itemContent ? itemContent.querySelector('.custom-text-feature__feature-label') : null;
            const featureEl = itemContent ? itemContent.querySelector('.custom-text-feature__feature-value') : null;
            if (titleEl) {
              titleEl.removeAttribute('style');
              titleEl.textContent = titleText;
              titleEl.setAttribute('data-variant-title', 'true');
              titleEl.style.display = titleText ? '' : 'none';
            }
            if (featureEl) {
              featureEl.removeAttribute('style');
              featureEl.textContent = featureText;
              featureEl.setAttribute('data-variant-feature', 'true');
              featureEl.style.display = featureText ? '' : 'none';
            }
          }
          // Hide extra rows (index >= maxLength)
          for (let i = maxLength; i < existingItems.length; i++) {
            existingItems[i].style.display = 'none';
          }
        }
      } else {
        // No variant data or invalid data - show customizer data
        existingItems.forEach((item, idx) => {
          item.removeAttribute('style');
          item.style.display = '';
          const titleEl = item.querySelector('.custom-text-feature__feature-label');
          if (titleEl && titleEl.hasAttribute('data-customizer-title')) {
            titleEl.textContent = titleEl.getAttribute('data-customizer-title');
            titleEl.removeAttribute('data-variant-title');
            titleEl.removeAttribute('style');
            titleEl.style.display = '';
          }
          const featureEl = item.querySelector('.custom-text-feature__feature-value');
          if (featureEl && featureEl.hasAttribute('data-customizer-feature')) {
            featureEl.textContent = featureEl.getAttribute('data-customizer-feature');
            featureEl.removeAttribute('data-variant-feature');
            featureEl.removeAttribute('style');
            featureEl.style.display = '';
          }
        });
        
        // Hide any variant-created items
        const variantItems = featuresContainer.querySelectorAll('.custom-text-feature__feature-item[data-variant-item]');
        variantItems.forEach(item => {
          item.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important;';
        });
      }
      
    } catch (e) {
      // Silent error - fallback to customizer data
      console.error('Error updating variant technical specs:', e);
    }
  }

  // Function to update variant performance blocks section (custom.variant_performance_data)
  function updateVariantPerformanceBlocks(variantId) {
    if (!variantId) return;
    function perfDisplayStr(v) {
      if (v == null || v === undefined) return '';
      if (typeof v === 'object' && v !== null && 'value' in v) return perfDisplayStr(v.value);
      return String(v);
    }
    function perfDisplayNum(v) {
      if (v == null || v === undefined) return 0;
      if (typeof v === 'object' && v !== null) {
        if ('value' in v) return perfDisplayNum(v.value);
        if (Array.isArray(v) && v.length > 0) return perfDisplayNum(v[0]);
      }
      const s = String(v).trim();
      if (s === '') return 0;
      const n = Number(s);
      return isNaN(n) ? 0 : Math.min(100, Math.max(0, n));
    }
    function applyProgressWidth(el, widthVal) {
      if (!el || !widthVal) return;
      el.setAttribute('data-customizer-progress', widthVal);
      el.style.animation = 'none';
      el.style.setProperty('--progress-width', widthVal, 'important');
      el.style.setProperty('width', widthVal, 'important');
    }
    function getProgressFromItem(item) {
      if (!item) return 0;
      var raw = item.performance_progress !== undefined && item.performance_progress !== null ? item.performance_progress : (item.progress !== undefined && item.progress !== null ? item.progress : (item.progress_value !== undefined && item.progress_value !== null ? item.progress_value : item.performance_progress_value));
      return perfDisplayNum(raw);
    }
    const variantIdStr = variantId.toString();
    let variantData = variantPerformanceDataMap.get(variantIdStr);
    if (!variantData) {
      const variantIdNum = parseInt(variantIdStr, 10);
      if (!isNaN(variantIdNum)) {
        variantData = variantPerformanceDataMap.get(variantIdNum.toString()) || variantPerformanceDataMap.get(String(variantIdNum));
      }
    }
    // Fallback: parse from tab that matches CURRENT product (so SlumberCool Max variant data comes from SlumberCool Max tab)
    if (!variantData) {
      let tabToRead = null;
      if (currentMattressProduct && currentMattressProduct.handle) {
        tabToRead = document.querySelector('.mattress-type-tabs .tab[data-product-handle="' + currentMattressProduct.handle + '"]') || document.querySelector('.mattress-type-tabs .tab[data-tab="' + currentMattressProduct.handle + '"]');
      }
      if (!tabToRead) {
        tabToRead = document.querySelector('.mattress-type-tabs .tab.active') || document.querySelector('.mattress-type-tabs .tab');
      }
      if (tabToRead) {
        const attr = tabToRead.getAttribute('data-variant-performance-data');
        if (attr && attr.trim() !== '') {
          const entries = attr.split('||').filter(function(v) { return v && v.trim() !== ''; });
          for (let e = 0; e < entries.length; e++) {
            const parts = entries[e].split(':');
            if (parts.length < 2) continue;
            const vid = parts[0].trim();
            if (vid !== variantIdStr && (isNaN(parseInt(vid, 10)) || parseInt(vid, 10) !== parseInt(variantIdStr, 10))) continue;
            const metafieldJson = parts.slice(1).join(':').trim();
            if (!metafieldJson || metafieldJson === 'null' || metafieldJson === 'undefined' || metafieldJson === '[]') continue;
            try {
              const decodedJson = metafieldJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
              const parsedData = JSON.parse(decodedJson);
              let normalized = [];
              if (Array.isArray(parsedData)) {
                normalized = parsedData.map(function(item) {
                  return {
                    performance_heading: perfDisplayStr(item && item.performance_heading),
                    performance_heading_value: perfDisplayStr(item && item.performance_heading_value),
                    performance_progress: perfDisplayNum(item && item.performance_progress),
                    performance_text: perfDisplayStr(item && item.performance_text)
                  };
                });
              } else if (parsedData && typeof parsedData === 'object') {
                var prog = parsedData.performance_progress !== undefined && parsedData.performance_progress !== null ? parsedData.performance_progress : (parsedData.progress !== undefined && parsedData.progress !== null ? parsedData.progress : parsedData.progress_value);
                normalized = [{
                  performance_heading: perfDisplayStr(parsedData.performance_heading),
                  performance_heading_value: perfDisplayStr(parsedData.performance_heading_value),
                  performance_progress: prog,
                  performance_text: perfDisplayStr(parsedData.performance_text)
                }];
              }
              if (normalized.length > 0) {
                const hasCommaInAny = normalized.some(function(it) {
                  const h = (it.performance_heading || '').toString();
                  const hv = (it.performance_heading_value || '').toString();
                  const t = (it.performance_text || '').toString();
                  const pStr = (it.performance_progress != null ? it.performance_progress : '').toString();
                  return h.indexOf(',') !== -1 || hv.indexOf(',') !== -1 || t.indexOf(',') !== -1 || pStr.indexOf(',') !== -1;
                });
                if (hasCommaInAny) {
                  const expanded = [];
                  for (let i = 0; i < normalized.length; i++) {
                    const item = normalized[i];
                    const h = (item.performance_heading || '').toString();
                    const hv = (item.performance_heading_value || '').toString();
                    const t = (item.performance_text || '').toString();
                    const headings = h.split(',').map(function(s) { return s.trim(); });
                    const values = hv.split(',').map(function(s) { return s.trim(); });
                    const texts = t.split(',').map(function(s) { return s.trim(); });
                    let progressArr = [];
                    const pStr = (item.performance_progress != null ? item.performance_progress : '').toString();
                    if (pStr.indexOf(',') !== -1) {
                      progressArr = pStr.split(',').map(function(s) { return perfDisplayNum(s.trim()); });
                    } else {
                      const singleProgress = perfDisplayNum(item.performance_progress);
                      const n = Math.max(headings.length, values.length, texts.length, 1);
                      progressArr = Array(n).fill(singleProgress);
                    }
                    const n = Math.max(headings.length, values.length, progressArr.length, texts.length, 1);
                    for (let j = 0; j < n; j++) {
                      expanded.push({
                        performance_heading: headings[j] || '',
                        performance_heading_value: values[j] || '',
                        performance_progress: progressArr[j] !== undefined ? progressArr[j] : 0,
                        performance_text: texts[j] || ''
                      });
                    }
                  }
                  normalized = expanded;
                }
              }
              if (normalized.length > 0) {
                variantPerformanceDataMap.set(variantIdStr, normalized);
                const numId = parseInt(variantIdStr, 10);
                if (!isNaN(numId)) {
                  variantPerformanceDataMap.set(numId.toString(), normalized);
                  variantPerformanceDataMap.set(String(numId), normalized);
                }
                variantData = normalized;
                break;
              }
            } catch (err) { /* silent */ }
          }
        }
      }
    }
    const performanceSections = document.querySelectorAll('.performance-blocks');
    if (!performanceSections || performanceSections.length === 0) return;
    performanceSections.forEach((section) => {
      const grid = section.querySelector('.performance-blocks__grid');
      if (!grid) return;
      const blocks = grid.querySelectorAll('.performance-blocks__block');
      const maxBlocks = Math.max(blocks.length, variantData && variantData.length ? variantData.length : 0);
      for (let i = 0; i < maxBlocks; i++) {
        const item = variantData && variantData[i] ? variantData[i] : null;
        let blockEl = blocks[i];
        if (!blockEl && grid) {
          blockEl = document.createElement('div');
          blockEl.className = 'performance-blocks__block';
          blockEl.setAttribute('data-variant-performance-block', 'true');
          const sectionId = section.getAttribute('data-section-id') || section.id || ('sec_' + i);
          const blockId = 'variant_' + sectionId + '_' + i;
          const inner = document.createElement('div');
          inner.className = 'performance-blocks__block-inner';
          const firstBlock = section.querySelector('.performance-blocks__block');
          const firstInner = firstBlock ? firstBlock.querySelector('.performance-blocks__block-inner') : null;
          if (firstInner) {
            inner.setAttribute('style', firstInner.getAttribute('style') || '');
          }
          const content = document.createElement('div');
          content.className = 'performance-blocks__block-content';
          const headingWrapper = document.createElement('div');
          headingWrapper.className = 'performance-blocks__block-heading-wrapper';
          const headingP = document.createElement('p');
          headingP.className = 'performance-blocks__block-heading pdp-text-color';
          headingP.id = 'performance_heading_' + blockId;
          const headingSpan = document.createElement('span');
          headingSpan.className = 'performance-blocks__block-heading-text pdp-text-color';
          headingSpan.id = 'performance_heading_value_' + blockId;
          headingWrapper.appendChild(headingP);
          headingWrapper.appendChild(headingSpan);
          content.appendChild(headingWrapper);
          const progressContainer = document.createElement('div');
          progressContainer.className = 'performance-blocks__progress-container';
          const progressBar = document.createElement('div');
          progressBar.className = 'performance-blocks__progress-bar';
          const progressFill = document.createElement('div');
          progressFill.className = 'performance-blocks__progress-fill pdp-color-enabled';
          progressFill.id = 'performance_progress_' + blockId;
          progressFill.setAttribute('data-section', 'pdp-color-change');
          const firstFill = firstBlock ? firstBlock.querySelector('.performance-blocks__progress-fill') : null;
          if (firstFill && firstFill.style.background) progressFill.style.background = firstFill.style.background;
          var progressPct = getProgressFromItem(item);
          var pctVal = progressPct > 0 ? (progressPct + '%') : (firstFill && firstFill.getAttribute('data-customizer-progress')) ? firstFill.getAttribute('data-customizer-progress') : '0%';
          progressFill.setAttribute('data-customizer-progress', pctVal);
          applyProgressWidth(progressFill, pctVal);
          progressBar.appendChild(progressFill);
          progressContainer.appendChild(progressBar);
          content.appendChild(progressContainer);
          const textDiv = document.createElement('div');
          textDiv.className = 'performance-blocks__block-text';
          textDiv.id = 'performance_text_' + blockId;
          content.appendChild(textDiv);
          inner.appendChild(content);
          blockEl.appendChild(inner);
          grid.appendChild(blockEl);
        }
        if (!blockEl) continue;
        const headingEl = blockEl.querySelector('.performance-blocks__block-heading');
        const headingValueEl = blockEl.querySelector('.performance-blocks__block-heading-text');
        const progressFillEl = blockEl.querySelector('.performance-blocks__progress-fill');
        const progressContainerEl = blockEl.querySelector('.performance-blocks__progress-container');
        const textEl = blockEl.querySelector('.performance-blocks__block-text');
        if (item) {
          if (headingEl) {
            if (!headingEl.hasAttribute('data-customizer-heading') && headingEl.textContent && headingEl.textContent.trim() !== '') {
              headingEl.setAttribute('data-customizer-heading', headingEl.textContent);
            }
            const val = perfDisplayStr(item.performance_heading);
            headingEl.textContent = val;
            headingEl.style.display = val ? '' : 'none';
          }
          if (headingValueEl) {
            if (!headingValueEl.hasAttribute('data-customizer-heading-value') && headingValueEl.textContent && headingValueEl.textContent.trim() !== '') {
              headingValueEl.setAttribute('data-customizer-heading-value', headingValueEl.textContent);
            }
            const val = perfDisplayStr(item.performance_heading_value);
            headingValueEl.textContent = val;
            headingValueEl.style.display = val ? '' : 'none';
          }
          const progressVal = getProgressFromItem(item);
          if (progressFillEl) {
            if (!progressFillEl.hasAttribute('data-customizer-progress')) {
              const w = progressFillEl.style.width || '';
              if (w) progressFillEl.setAttribute('data-customizer-progress', w);
            }
            var widthVal = progressVal > 0 ? (progressVal + '%') : (progressFillEl.getAttribute('data-customizer-progress') || progressFillEl.style.width || '0%');
            applyProgressWidth(progressFillEl, widthVal);
          }
          if (progressContainerEl) {
            progressContainerEl.style.display = '';
          }
          if (textEl) {
            if (!textEl.hasAttribute('data-customizer-text') && textEl.innerHTML && textEl.innerHTML.trim() !== '') {
              textEl.setAttribute('data-customizer-text', textEl.innerHTML);
            }
            const val = perfDisplayStr(item.performance_text);
            textEl.innerHTML = val;
            textEl.style.display = val ? '' : 'none';
          }
          blockEl.removeAttribute('style');
          blockEl.style.display = '';
        } else {
          if (blockEl.hasAttribute('data-variant-performance-block')) {
            blockEl.style.display = 'none';
          } else {
            if (headingEl && !headingEl.hasAttribute('data-customizer-heading') && headingEl.textContent && headingEl.textContent.trim() !== '') {
              headingEl.setAttribute('data-customizer-heading', headingEl.textContent);
            }
            if (headingValueEl && !headingValueEl.hasAttribute('data-customizer-heading-value') && headingValueEl.textContent && headingValueEl.textContent.trim() !== '') {
              headingValueEl.setAttribute('data-customizer-heading-value', headingValueEl.textContent);
            }
            if (progressFillEl && !progressFillEl.hasAttribute('data-customizer-progress') && progressFillEl.style.width) {
              progressFillEl.setAttribute('data-customizer-progress', progressFillEl.style.width);
            }
            if (textEl && !textEl.hasAttribute('data-customizer-text') && textEl.innerHTML && textEl.innerHTML.trim() !== '') {
              textEl.setAttribute('data-customizer-text', textEl.innerHTML);
            }
            if (headingEl && headingEl.hasAttribute('data-customizer-heading')) {
              headingEl.textContent = headingEl.getAttribute('data-customizer-heading');
              headingEl.removeAttribute('style');
            }
            if (headingValueEl && headingValueEl.hasAttribute('data-customizer-heading-value')) {
              headingValueEl.textContent = headingValueEl.getAttribute('data-customizer-heading-value');
              headingValueEl.removeAttribute('style');
            }
            if (progressFillEl && progressFillEl.hasAttribute('data-customizer-progress')) {
              const w = progressFillEl.getAttribute('data-customizer-progress');
              applyProgressWidth(progressFillEl, w);
            }
            if (progressContainerEl) progressContainerEl.style.display = '';
            if (textEl && textEl.hasAttribute('data-customizer-text')) {
              textEl.innerHTML = textEl.getAttribute('data-customizer-text');
              textEl.removeAttribute('style');
            }
            blockEl.removeAttribute('style');
            blockEl.style.display = '';
          }
        }
      }
      for (let i = maxBlocks; i < blocks.length; i++) {
        const blockEl = blocks[i];
        if (blockEl && blockEl.hasAttribute('data-variant-performance-block')) {
          blockEl.style.display = 'none';
        } else {
          const headingEl = blockEl.querySelector('.performance-blocks__block-heading');
          const headingValueEl = blockEl.querySelector('.performance-blocks__block-heading-text');
          const progressFillEl = blockEl.querySelector('.performance-blocks__progress-fill');
          const progressContainerEl = blockEl.querySelector('.performance-blocks__progress-container');
          const textEl = blockEl.querySelector('.performance-blocks__block-text');
          if (headingEl && headingEl.hasAttribute('data-customizer-heading')) {
            headingEl.textContent = headingEl.getAttribute('data-customizer-heading');
            headingEl.removeAttribute('style');
          }
          if (headingValueEl && headingValueEl.hasAttribute('data-customizer-heading-value')) {
            headingValueEl.textContent = headingValueEl.getAttribute('data-customizer-heading-value');
            headingValueEl.removeAttribute('style');
          }
            if (progressFillEl && progressFillEl.hasAttribute('data-customizer-progress')) {
              const w = progressFillEl.getAttribute('data-customizer-progress');
              applyProgressWidth(progressFillEl, w);
            }
            if (progressContainerEl) progressContainerEl.style.display = '';
            if (textEl && textEl.hasAttribute('data-customizer-text')) {
              textEl.innerHTML = textEl.getAttribute('data-customizer-text');
              textEl.removeAttribute('style');
            }
            blockEl.removeAttribute('style');
            blockEl.style.display = '';
        }
      }
      document.querySelectorAll('.performance-blocks__progress-fill[data-customizer-progress]').forEach(function(el) {
        applyProgressWidth(el, el.getAttribute('data-customizer-progress'));
      });
    });
  }

  // First load: show default selected variant's performance blocks (from active tab's first variant)
  setTimeout(function() {
    const activeTab = document.querySelector('.mattress-type-tabs .tab.active') || document.querySelector('.mattress-type-tabs .tab');
    if (!activeTab) return;
    try {
      const variantsStr = activeTab.getAttribute('data-product-variants');
      if (variantsStr) {
        const decoded = variantsStr.replace(/&quot;/g, '"').replace(/&#39;/g, "'");
        const variants = JSON.parse(decoded);
        if (variants && variants.length > 0) {
          updateVariantPerformanceBlocks(variants[0].id);
        }
      }
    } catch (e) {}
  }, 0);

  // Function to update product for selected variant
  function updateProductForSelectedVariant() {
    const sizeSelect = document.getElementById('size-select');
    if (!sizeSelect) return;
    
    const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
    if (!selectedOption) return;
    
    const variantId = selectedOption.value;
    const variantPrice = selectedOption.getAttribute('data-price');
    const variantComparePrice = selectedOption.getAttribute('data-compare-price');
    if (currentMattressProduct && currentMattressProduct.variants) {
      const foundVariant = currentMattressProduct.variants.find(v => v.id.toString() === variantId);
      if (foundVariant) {
        currentSizeVariant = foundVariant;
      }
    }
    
    // Update variant info (short and long text)
    updateVariantInfo(variantId);
    
    // Update variant image and features section
    updateVariantImageAndFeatures(variantId);
    
    // Update variant technical specifications section
    updateVariantTechnicalSpecs(variantId);
    
    // Update variant performance blocks section
    updateVariantPerformanceBlocks(variantId);
    
    // Sync foundation options to current mattress size (foundation size hidden, linked to mattress size)
    syncFoundationOptionsWithMattressSize();

    const underbedInputOnSizeChange = getSelectedUnderbedInput();
    if (underbedInputOnSizeChange && !isUnderbedNoFoundationInput(underbedInputOnSizeChange)) {
      syncCurrentFoundationFromUnderbedInput(underbedInputOnSizeChange);
    }
    
    // Update variant name display
    updateVariantNameDisplay();
    
    // Update total price (includes foundation if selected)
    updateTotalPrice();
    
    const comparePriceElement = document.querySelector('.compare-at-price');
    if (comparePriceElement) {
      if (variantComparePrice && variantComparePrice !== '' && variantComparePrice !== 'null') {
        comparePriceElement.innerHTML = variantComparePrice;
        comparePriceElement.style.display = 'inline';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }
  }

  // Add to Cart functionality
  const addToCartBtn = document.getElementById("add-to-cart");
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", async function () {
      await handleAddToCart(false, false);
    });
  }

  // Buy Now functionality
  const buyNowBtn = document.getElementById("buy-now");
  if (buyNowBtn) {
    buyNowBtn.addEventListener("click", async function () {
      await handleAddToCart(true, false);
    });
  }

  window.stickyATCCustomAddToCart = async function() {
    const stickyBtn = document.querySelector('#md-sticky-atc [name="add"]');
    const stickySpinner = stickyBtn ? stickyBtn.querySelector('.loading__spinner') : null;
    try {
      if (stickyBtn) {
        stickyBtn.disabled = true;
        if (stickySpinner) stickySpinner.classList.remove('hidden');
      }
      await handleAddToCart(false, false);
    } finally {
      if (stickyBtn) {
        stickyBtn.disabled = false;
        if (stickySpinner) stickySpinner.classList.add('hidden');
      }
    }
  };

  // Upsell popups (adjustable + breeze): same confirm/continue behavior, different DOM namespace
  function wireFoundationUpsellPopup(namespace) {
    const overlay = upsellPopupGetEl(namespace, 'overlay');
    const upsellConfirm = upsellPopupGetEl(namespace, 'confirm');
    const upsellContinue = upsellPopupGetEl(namespace, 'continue');
    const upsellClose = upsellPopupGetEl(namespace, 'close');
    if (!overlay) return;
    async function upsellContinueAction() {
      const target = activeUpsellOverlay || overlay;
      const noUpgradeVariantId = target.dataset.noUpgradeVariantId ? target.dataset.noUpgradeVariantId : null;
      const noUpgradeVariantTitle = target.dataset.noUpgradeVariantTitle ? target.dataset.noUpgradeVariantTitle : '';
      target.style.display = 'none';
      target.setAttribute('aria-hidden', 'true');
      activeUpsellOverlay = null;
      await handleAddToCart(pendingUpsellBuyNow, true, null, null, noUpgradeVariantId || null, noUpgradeVariantTitle || '');
    }
    if (upsellConfirm) {
      upsellConfirm.addEventListener('click', async function () {
        const target = activeUpsellOverlay || overlay;
        target.style.display = 'none';
        target.setAttribute('aria-hidden', 'true');
        activeUpsellOverlay = null;
        const buyNow = !!pendingUpsellBuyNow;
        const upgradeVid = target.dataset.upgradeVariantId || null;
        const upgradeTitle = target.dataset.upgradeVariantTitle || '';
        await handleAddToCart(buyNow, true, upgradeVid, upgradeTitle);
      });
    }
    if (upsellContinue) {
      upsellContinue.addEventListener('click', async function () {
        await upsellContinueAction();
      });
    }
    if (upsellClose) {
      upsellClose.addEventListener('click', async function () {
        await upsellContinueAction();
      });
    }
  }
  wireFoundationUpsellPopup('upsell-popup');
  wireFoundationUpsellPopup('breeze-upsell-popup');

  function getAccessoryBundleUpsellConfig() {
    const el = document.getElementById('accessory-bundle-upsell-popup-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function normalizeAccessoryStoragePart(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 96);
  }

  /** Session key so changing mattress / foundation / size / bundle product resets memory. */
  function getAccessoryBundleStorageKey(abCfg) {
    if (typeof sessionStorage === 'undefined') return null;
    if (!abCfg || !abCfg.upgradeProductHandle) return null;
    const ph = currentMattressProduct && currentMattressProduct.handle ? String(currentMattressProduct.handle) : '';
    if (!ph) return null;
    const foundationInput = getFoundationInputForUpsell();
    const ft = (getEffectiveFoundationTypeForUpsell(foundationInput) || selectedFoundationType || '').trim();
    const sz = getCurrentMattressSizeValue().trim();
    const uh = String(abCfg.upgradeProductHandle || '').trim();
    return (
      'scAbb:' +
      normalizeAccessoryStoragePart(ph) +
      ':' +
      normalizeAccessoryStoragePart(ft) +
      ':' +
      normalizeAccessoryStoragePart(sz) +
      ':' +
      normalizeAccessoryStoragePart(uh)
    );
  }

  function readStoredAccessoryBundleChoice(key) {
    if (!key || typeof sessionStorage === 'undefined') return null;
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function writeStoredAccessoryBundleChoice(key, obj) {
    if (!key || typeof sessionStorage === 'undefined') return;
    try {
      sessionStorage.setItem(key, JSON.stringify(obj));
    } catch (e) {}
  }

  /** Forget accessory-bundle popup choices when the cart has no items (new purchase flow). */
  async function clearAccessoryBundleSessionStorageIfCartEmpty() {
    if (typeof sessionStorage === 'undefined') return;
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();
      const count =
        cart && (cart.item_count != null ? Number(cart.item_count) : cart.items && cart.items.length ? cart.items.length : 0);
      if (count > 0) return;
      const keys = [];
      for (let i = 0; i < sessionStorage.length; i++) {
        const k = sessionStorage.key(i);
        if (k && (k.indexOf('scAbb:') === 0 || k.indexOf('scAbbCartDecline:') === 0)) keys.push(k);
      }
      keys.forEach(function (k) {
        try {
          sessionStorage.removeItem(k);
        } catch (e) {}
      });
    } catch (e) {}
  }

  function accessoryBundleFoundationMatches(config, foundationType) {
    if (!config || config.foundationTriggerLines == null) return false;
    const lines = String(config.foundationTriggerLines)
      .split(/\r?\n/)
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
    if (!lines.length) return false;
    const ft = (foundationType || '').toString().trim();
    if (!ft) {
      return lines.some(function (line) {
        return foundationTriggerMatches({ foundationTrigger: line }, 'no foundation');
      });
    }
    return lines.some(function (line) {
      return foundationTriggerMatches({ foundationTrigger: line }, ft);
    });
  }

  function resolveAccessoryVariantIdForItem(accessoryItem) {
    const defaultVariantId = accessoryItem.getAttribute('data-accessory-variant-id');
    const variantsJson = accessoryItem.getAttribute('data-accessory-variants');
    const currentSizeValue = getCurrentMattressSizeValue();
    if (!variantsJson || !currentSizeValue || currentSizeValue === '') {
      return defaultVariantId;
    }
    try {
      const variants = JSON.parse(variantsJson);
      const found = variants.find(function (v) {
        const o1 = (v.o1 || '').toString().trim();
        const o2 = (v.o2 || '').toString().trim();
        const o3 = (v.o3 || '').toString().trim();
        return bedSizeLabelsEqual(o1, currentSizeValue) || bedSizeLabelsEqual(o2, currentSizeValue) || bedSizeLabelsEqual(o3, currentSizeValue);
      });
      return found ? String(found.id) : defaultVariantId;
    } catch (e) {
      return defaultVariantId;
    }
  }

  /**
   * Accessory bundle upgrade popup (after foundation upsell when applicable).
   * @returns {Promise<boolean>}
   */
  async function showAccessoryBundleUpsellPopup() {
    const configEl = document.getElementById('accessory-bundle-upsell-popup-config');
    const overlay = document.getElementById('accessory-bundle-upsell-popup-overlay');
    if (!configEl || !overlay) return false;
    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return false;
    }
    const upgradeHandle = config.upgradeProductHandle;
    if (!upgradeHandle) return false;
    const currentSizeValue = getCurrentMattressSizeValue();
    const accessoryItems = document.querySelectorAll('.accessory-item[data-accessory-product]');
    if (!accessoryItems.length) return false;

    try {
      let includedCents = 0;
      for (let i = 0; i < accessoryItems.length; i++) {
        const item = accessoryItems[i];
        const handle = item.getAttribute('data-accessory-product');
        const vid = resolveAccessoryVariantIdForItem(item);
        if (!handle || !vid) continue;
        try {
          const res = await fetch(suavePdpProductJsonUrl(handle));
          if (!res.ok) continue;
          const prod = await res.json();
          const v = prod.variants && prod.variants.find(function (x) {
            return String(x.id) === String(vid);
          });
          if (v && v.price != null) includedCents += parseInt(v.price, 10) || 0;
        } catch (e) {}
      }

      const upRes = await fetch(suavePdpProductJsonUrl(upgradeHandle));
      if (!upRes.ok) return false;
      const upgradeProduct = await upRes.json();
      const upgradeVariant = getVariantBySize(upgradeProduct, currentSizeValue) || (upgradeProduct.variants && upgradeProduct.variants[0]);
      if (!upgradeVariant) return false;
      const upgradeCents = parseInt(upgradeVariant.price, 10) || 0;
      const diffCents = Math.max(0, upgradeCents - includedCents);
      const priceFormatted = formatMoneyFromCents(diffCents);

      const curLabEl = document.getElementById('abb-pro-current-label');
      if (curLabEl && config.comparisonCurrentLabel) curLabEl.textContent = config.comparisonCurrentLabel;
      const upLabEl = document.getElementById('abb-pro-upgrade-label');
      if (upLabEl && config.comparisonUpgradeLabel) upLabEl.textContent = config.comparisonUpgradeLabel;
      const curTagEl = document.getElementById('abb-pro-current-tagline');
      if (curTagEl) {
        if (config.currentCardTagline && String(config.currentCardTagline).trim() !== '') {
          curTagEl.textContent = String(config.currentCardTagline).trim();
        } else {
          curTagEl.textContent = '';
        }
      }
      const upTagEl = document.getElementById('abb-pro-upgrade-tagline');
      if (upTagEl) {
        if (config.upgradeCardTagline && String(config.upgradeCardTagline).trim() !== '') {
          upTagEl.textContent = String(config.upgradeCardTagline).trim();
        } else {
          upTagEl.textContent = '';
        }
      }

      const diffMainEl = document.getElementById('accessory-bundle-upsell-popup-diff');
      if (diffMainEl && config.subheadTemplate) {
        diffMainEl.textContent = String(config.subheadTemplate).replace(/\{\{price\}\}|\$X/g, priceFormatted);
      }
      const compareAtRaw = config.compareAtDifference ? String(config.compareAtDifference).trim() : '';
      const compareTopEl = document.getElementById('accessory-bundle-upsell-popup-compare-at');
      if (compareTopEl) {
        compareTopEl.textContent = compareAtRaw ? compareAtRaw : '';
      }

      const subheadEl = upsellPopupGetEl('accessory-bundle-upsell-popup', 'subhead');
      const priceEl = upsellPopupGetEl('accessory-bundle-upsell-popup', 'price');
      if (priceEl) priceEl.textContent = priceFormatted;
      if (subheadEl && config.subheadTemplate) {
        subheadEl.textContent = String(config.subheadTemplate).replace(/\{\{price\}\}|\$X/g, priceFormatted);
      }
      let includedBundleAlt = 'Included accessories';
      if (config.currentCardTitle && String(config.currentCardTitle).trim() !== '') {
        includedBundleAlt = String(config.currentCardTitle).trim();
      } else {
        const titles = [];
        accessoryItems.forEach(function (node) {
          const dt = node.getAttribute('data-accessory-display-title') || '';
          const vt = node.getAttribute('data-accessory-variant-title') || '';
          const t = (dt && dt.trim()) ? dt.trim() : vt;
          if (t) titles.push(t);
        });
        if (titles.length) includedBundleAlt = titles.join(', ');
      }

      const upgradeBundleAlt =
        config.upgradeCardTitle && String(config.upgradeCardTitle).trim() !== ''
          ? String(config.upgradeCardTitle).trim()
          : upgradeVariant.title || upgradeProduct.title || 'Upgrade bundle';

      const currentImgEl = upsellPopupGetEl('accessory-bundle-upsell-popup', 'current-image');
      if (currentImgEl) {
        const customSrc = config.currentImageUrl || null;
        if (customSrc) {
          currentImgEl.src = customSrc;
          currentImgEl.alt = includedBundleAlt;
          currentImgEl.style.display = '';
        } else {
          const firstImg = accessoryItems[0] && accessoryItems[0].querySelector('.accessory-product-image');
          if (firstImg && firstImg.src) {
            currentImgEl.src = firstImg.src;
            currentImgEl.alt = includedBundleAlt;
            currentImgEl.style.display = '';
          } else {
            currentImgEl.style.display = 'none';
          }
        }
      }

      const upgradeImgEl = upsellPopupGetEl('accessory-bundle-upsell-popup', 'upgrade-image');
      if (upgradeImgEl && config.showUpgradeImage !== false) {
        let imgSrc = config.upgradeImageUrl || null;
        if (!imgSrc && upgradeVariant.featured_image) {
          imgSrc = upgradeVariant.featured_image.src || (typeof upgradeVariant.featured_image === 'string' ? upgradeVariant.featured_image : null);
        }
        if (!imgSrc && upgradeProduct.featured_image) {
          imgSrc = upgradeProduct.featured_image.src || upgradeProduct.featured_image;
        }
        if (imgSrc) {
          upgradeImgEl.src = imgSrc;
          upgradeImgEl.alt = upgradeBundleAlt;
          upgradeImgEl.style.display = '';
        } else {
          upgradeImgEl.style.display = 'none';
        }
      }

      overlay.dataset.upgradeBundleVariantId = String(upgradeVariant.id);
      overlay.style.display = 'flex';
      overlay.setAttribute('aria-hidden', 'false');
      return true;
    } catch (e) {
      console.error('Accessory bundle upsell popup error:', e);
      return false;
    }
  }

  function wireAccessoryBundleUpsellPopup() {
    const overlay = document.getElementById('accessory-bundle-upsell-popup-overlay');
    const confirmBtn = document.getElementById('accessory-bundle-upsell-popup-confirm');
    const continueBtn = document.getElementById('accessory-bundle-upsell-popup-continue');
    const closeBtn = document.getElementById('accessory-bundle-upsell-popup-close');
    if (!overlay) return;

    async function closeAndContinue() {
      overlay.style.display = 'none';
      overlay.setAttribute('aria-hidden', 'true');
      const abCfg = getAccessoryBundleUpsellConfig();
      if (abCfg && abCfg.rememberChoice !== false) {
        const sk = getAccessoryBundleStorageKey(abCfg);
        if (sk) writeStoredAccessoryBundleChoice(sk, { mode: 'decline' });
      }
      const chain = pendingAccessoryChain;
      pendingAccessoryChain = null;
      if (!chain) return;
      await handleAddToCart(
        chain.buyNow,
        true,
        chain.upgradeVariantId || null,
        chain.upgradeVariantTitle || '',
        chain.noUpgradeVariantId || null,
        chain.noUpgradeVariantTitle || '',
        true,
        false,
        null
      );
    }

    async function closeAndUpgrade() {
      const bundleVid = overlay.dataset.upgradeBundleVariantId || null;
      overlay.style.display = 'none';
      overlay.setAttribute('aria-hidden', 'true');
      const abCfg = getAccessoryBundleUpsellConfig();
      if (abCfg && abCfg.rememberChoice !== false) {
        const sk = getAccessoryBundleStorageKey(abCfg);
        if (sk) writeStoredAccessoryBundleChoice(sk, { mode: 'upgrade', variantId: bundleVid ? String(bundleVid) : undefined });
      }
      const chain = pendingAccessoryChain;
      pendingAccessoryChain = null;
      if (!chain) return;
      await handleAddToCart(
        chain.buyNow,
        true,
        chain.upgradeVariantId || null,
        chain.upgradeVariantTitle || '',
        chain.noUpgradeVariantId || null,
        chain.noUpgradeVariantTitle || '',
        true,
        true,
        bundleVid
      );
    }

    if (confirmBtn) confirmBtn.addEventListener('click', closeAndUpgrade);
    if (continueBtn) continueBtn.addEventListener('click', closeAndContinue);
    if (closeBtn) closeBtn.addEventListener('click', closeAndContinue);
  }
  wireAccessoryBundleUpsellPopup();
  void clearAccessoryBundleSessionStorageIfCartEmpty();

  function normalizeBedSizeLabel(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/[-–—]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compactBedSizeKey(value) {
    return normalizeBedSizeLabel(value).replace(/\s+/g, '');
  }

  function bedSizeLabelsEqual(a, b) {
    const na = normalizeBedSizeLabel(a);
    const nb = normalizeBedSizeLabel(b);
    if (!na || !nb) return false;
    if (na === nb) return true;
    return compactBedSizeKey(a) === compactBedSizeKey(b);
  }

  function getSizeLikeOptionIndexes(product) {
    const indexes = [];
    if (product && product.options && product.options.length) {
      product.options.forEach(function (name, idx) {
        const n = String(name || '').toLowerCase();
        if (n.includes('size') || n.includes('dimension') || n.includes('width') || n.includes('mattress')) {
          indexes.push(idx);
        }
      });
    }
    return indexes;
  }

  function variantOptionValuesAll(variant) {
    const out = [];
    if (variant && variant.options && Array.isArray(variant.options)) {
      variant.options.forEach(function (o) {
        if (o != null && String(o).trim() !== '') out.push(String(o).trim());
      });
    }
    if (out.length) return out;
    if (variant.option1) out.push(String(variant.option1).trim());
    if (variant.option2) out.push(String(variant.option2).trim());
    if (variant.option3) out.push(String(variant.option3).trim());
    return out;
  }

  function isVariantSellableForUpsell(v) {
    if (!v) return false;
    if (v.available === true) return true;
    if (v.inventory_policy === 'continue') return true;
    if (v.inventory_management == null && v.available !== false) return true;
    const qty = v.inventory_quantity;
    if (qty != null && parseInt(qty, 10) > 0) return true;
    return false;
  }

  function firstSellableOrFirstVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    const avail = product.variants.find(isVariantSellableForUpsell);
    return avail || product.variants[0];
  }

  /**
   * Match upgrade / no-upgrade product variant to mattress size.
   * Checks every variant option (not only option1), prefers option names containing "Size",
   * case/whitespace tolerant. If matched variant is unavailable, returns product.variants[0].
   * If no match, returns first sellable variant or first variant.
   */
  function getVariantBySize(product, sizeValue) {
    if (!product || !product.variants || !product.variants.length) return null;
    const wantRaw = (sizeValue || '').toString().trim();
    if (!wantRaw) return firstSellableOrFirstVariant(product);

    const preferredIdxs = getSizeLikeOptionIndexes(product);
    const optLen = (product.options && product.options.length) || 0;
    const tryIndexes = preferredIdxs.length
      ? preferredIdxs
      : [0, 1, 2].filter(function (i) { return i < optLen; });

    function valueAtVariantIndex(variant, ix) {
      if (variant.options && variant.options[ix] != null) return String(variant.options[ix]).trim();
      if (ix === 0) return variant.option1 ? String(variant.option1).trim() : '';
      if (ix === 1) return variant.option2 ? String(variant.option2).trim() : '';
      if (ix === 2) return variant.option3 ? String(variant.option3).trim() : '';
      return '';
    }

    function variantMatchesSize(variant) {
      if (tryIndexes.length) {
        for (let ti = 0; ti < tryIndexes.length; ti++) {
          const val = valueAtVariantIndex(variant, tryIndexes[ti]);
          if (val && bedSizeLabelsEqual(val, wantRaw)) return true;
        }
      }
      const allVals = variantOptionValuesAll(variant);
      for (let ai = 0; ai < allVals.length; ai++) {
        if (bedSizeLabelsEqual(allVals[ai], wantRaw)) return true;
      }
      return false;
    }

    const matches = product.variants.filter(variantMatchesSize);
    if (!matches.length) return firstSellableOrFirstVariant(product);

    const sellableMatch = matches.find(isVariantSellableForUpsell);
    if (sellableMatch) return sellableMatch;
    return product.variants[0] || matches[0];
  }

  /**
   * Show foundation upsell popup (adjustable or breeze namespace).
   * @param {boolean} buyNow
   * @param {string} namespace - "upsell-popup" | "breeze-upsell-popup"
   * @returns {Promise<boolean>} true if overlay was shown
   */
  async function showFoundationUpsellPopup(buyNow, namespace) {
    const configEl = upsellPopupGetEl(namespace, 'config');
    const overlay = upsellPopupGetEl(namespace, 'overlay');
    if (!configEl || !overlay) {
      suavePdpUpsellDbg('showFoundationUpsellPopup: missing config or overlay', { namespace: namespace });
      return false;
    }
    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      suavePdpUpsellDbg('showFoundationUpsellPopup: config JSON parse failed', { namespace: namespace, err: e });
      return false;
    }
    const upgradeHandle = config.upgradeProductHandle;
    if (!upgradeHandle) {
      suavePdpUpsellDbg('showFoundationUpsellPopup: no upgradeProductHandle in config', { namespace: namespace });
      return false;
    }
    const currentSizeValue = getCurrentMattressSizeValue();
    suavePdpUpsellDbg('showFoundationUpsellPopup: size + upgrade', {
      namespace: namespace,
      currentSizeValue: currentSizeValue,
      upgradeHandle: upgradeHandle
    });
    const foundationInput = getFoundationInputForUpsell();
    const currentFoundationType =
      getEffectiveFoundationTypeForUpsell(foundationInput) ||
      (selectedFoundationType ? String(selectedFoundationType).trim() : '');
    const foundationOptionEl = foundationInput ? (foundationInput.closest && foundationInput.closest('.foundation-option')) : null;
    const foundationHandle = foundationInput ? (foundationInput.getAttribute('data-product-handle') || (foundationOptionEl && foundationOptionEl.getAttribute('data-product-handle'))) : null;
    const foundationVariantId = foundationInput ? (foundationInput.value || foundationInput.getAttribute('data-variant-id')) : null;

    try {
      var includedPriceCents = 0;
      if (foundationHandle && foundationVariantId) {
        try {
          const foundationRes = await fetch(suavePdpProductJsonUrl(foundationHandle));
          if (foundationRes.ok) {
            const foundationProduct = await foundationRes.json();
            const foundVariant = foundationProduct.variants && foundationProduct.variants.find(function (v) { return String(v.id) === String(foundationVariantId); });
            if (foundVariant && foundVariant.price != null) includedPriceCents = parseInt(foundVariant.price, 10) || 0;
          }
        } catch (e) {}
      }
      if (includedPriceCents === 0 && foundationInput) {
        var attrPrice = parseFloat(String(foundationInput.getAttribute('data-variant-price') || '0').replace(/[^0-9.]/g, '')) || 0;
        if (attrPrice > 0 && attrPrice < 100000) includedPriceCents = Math.round(attrPrice * 100);
        else includedPriceCents = Math.round(attrPrice);
      }

      const res = await fetch('/products/' + encodeURIComponent(upgradeHandle) + '.js');
      if (!res.ok) {
        suavePdpUpsellDbg('showFoundationUpsellPopup: upgrade product fetch failed', {
          status: res.status,
          upgradeHandle: upgradeHandle
        });
        return false;
      }
      const upgradeProduct = await res.json();
      const upgradeVariant = getVariantBySize(upgradeProduct, currentSizeValue) || upgradeProduct.variants[0];
      if (!upgradeVariant) {
        suavePdpUpsellDbg('showFoundationUpsellPopup: no variant for size', {
          currentSizeValue: currentSizeValue,
          variantCount: upgradeProduct.variants && upgradeProduct.variants.length
        });
        return false;
      }

      var upgradePriceCents = parseInt(upgradeVariant.price, 10) || 0;

      var differenceCents = Math.max(0, upgradePriceCents - includedPriceCents);

      const priceFormatted = formatMoneyFromCents(differenceCents);
      const priceWithPlus = '+' + priceFormatted;

      const subheadEl = upsellPopupGetEl(namespace, 'subhead');
      const priceEl = upsellPopupGetEl(namespace, 'price');
      if (priceEl) priceEl.textContent = priceFormatted;
      if (subheadEl && config.subheadTemplate) {
        subheadEl.textContent = config.subheadTemplate.replace(/\{\{price\}\}|\$X/g, priceFormatted);
      }

      var priceCardEl = upsellPopupGetEl(namespace, 'price-card');
      if (priceCardEl) priceCardEl.textContent = priceWithPlus;

      var compareAtRaw = (config && config.compareAtDifference) ? String(config.compareAtDifference).trim() : '';
      var compareAtEl = upsellPopupGetEl(namespace, 'compare-at');
      if (compareAtEl) {
        compareAtEl.textContent = compareAtRaw ? compareAtRaw + ' ' : '';
        compareAtEl.style.display = compareAtRaw ? '' : 'none';
      }

      var currentNameEl = upsellPopupGetEl(namespace, 'current-name');
      if (currentNameEl) {
        if (config.currentCardTitle && String(config.currentCardTitle).trim() !== '') {
          currentNameEl.textContent = String(config.currentCardTitle).trim();
        } else if (foundationInput) {
          var currentLabel =
            getEffectiveFoundationTypeForUpsell(foundationInput) ||
            (currentFoundationVariant && currentFoundationVariant.title) ||
            '';
          currentNameEl.textContent = currentLabel || '—';
        }
      }
      var upgradeNameEl = upsellPopupGetEl(namespace, 'upgrade-name');
      if (upgradeNameEl) {
        if (config.upgradeCardTitle && String(config.upgradeCardTitle).trim() !== '') {
          upgradeNameEl.textContent = String(config.upgradeCardTitle).trim();
        } else {
          upgradeNameEl.textContent = upgradeVariant.title || upgradeProduct.title || '—';
        }
      }

      var currentImgEl = upsellPopupGetEl(namespace, 'current-image');
      if (currentImgEl) {
        var currentImgSrc = (config && config.currentImageUrl) ? config.currentImageUrl : null;
        if (currentImgSrc) {
          currentImgEl.src = currentImgSrc;
          currentImgEl.alt = (currentNameEl && currentNameEl.textContent) ? currentNameEl.textContent : 'Current';
          currentImgEl.style.display = '';
        } else {
          currentImgEl.style.display = 'none';
        }
      }

      var upgradeImgEl = upsellPopupGetEl(namespace, 'upgrade-image');
      if (upgradeImgEl && config.showUpgradeImage !== false) {
        var imgSrc = (config && config.upgradeImageUrl) ? config.upgradeImageUrl : (upgradeVariant.featured_image && (upgradeVariant.featured_image.src || (typeof upgradeVariant.featured_image === 'string' ? upgradeVariant.featured_image : null))) || (upgradeProduct.featured_image && (upgradeProduct.featured_image.src || (typeof upgradeProduct.featured_image === 'string' ? upgradeProduct.featured_image : null))) || (upgradeProduct.images && upgradeProduct.images[0] && (upgradeProduct.images[0].src || (typeof upgradeProduct.images[0] === 'string' ? upgradeProduct.images[0] : null)));
        if (imgSrc) {
          upgradeImgEl.src = imgSrc;
          upgradeImgEl.alt = upgradeProduct.title || '';
          upgradeImgEl.style.display = '';
        } else {
          upgradeImgEl.style.display = 'none';
        }
      }

      var sizeForCart = currentSizeValue || (upgradeVariant.options && upgradeVariant.options[0]) || upgradeVariant.title || '';
      var fullUpgradeTitleForCart = currentFoundationType ? (currentFoundationType + (sizeForCart ? ' / ' + sizeForCart : '')) : (upgradeVariant.options && upgradeVariant.options.length ? upgradeVariant.options.join(' / ') : (upgradeVariant.title || upgradeProduct.title || ''));

      overlay.dataset.upgradeVariantId = String(upgradeVariant.id);
      overlay.dataset.upgradeVariantTitle = fullUpgradeTitleForCart;
      overlay.dataset.noUpgradeVariantId = '';
      overlay.dataset.noUpgradeVariantTitle = '';
      var noUpgradeHandle = (config && config.noUpgradeProductHandle) ? String(config.noUpgradeProductHandle).trim() : '';
      if (noUpgradeHandle && noUpgradeHandle !== '' && noUpgradeHandle !== 'null') {
        try {
          const noUpgradeRes = await fetch(suavePdpProductJsonUrl(noUpgradeHandle));
          if (noUpgradeRes.ok) {
            const noUpgradeProduct = await noUpgradeRes.json();
            const noUpgradeVariant = getVariantBySize(noUpgradeProduct, currentSizeValue) || (noUpgradeProduct.variants && noUpgradeProduct.variants[0]) || null;
            if (noUpgradeVariant) {
              overlay.dataset.noUpgradeVariantId = String(noUpgradeVariant.id);
              overlay.dataset.noUpgradeVariantTitle = noUpgradeVariant.title || (noUpgradeVariant.options && noUpgradeVariant.options.join(' / ')) || noUpgradeProduct.title || '';
              if (currentNameEl) {
                currentNameEl.textContent = noUpgradeProduct.title + (noUpgradeVariant.title && noUpgradeVariant.title !== 'Default Title' ? ' - ' + noUpgradeVariant.title : '');
              }
            }
          }
        } catch (e) {}
      }
      if (!overlay.dataset.noUpgradeVariantId && currentNameEl && (!config.currentCardTitle || String(config.currentCardTitle).trim() === '') && foundationInput) {
        var currentLabel2 =
          getEffectiveFoundationTypeForUpsell(foundationInput) ||
          (currentFoundationVariant && currentFoundationVariant.title) ||
          '';
        currentNameEl.textContent = currentLabel2 || '—';
      }

      activeUpsellOverlay = overlay;
      overlay.style.display = 'flex';
      overlay.setAttribute('aria-hidden', 'false');
      return true;
    } catch (e) {
      console.error('Upsell popup error:', e);
      return false;
    }
  }

  async function handleAddToCart(
    buyNow = false,
    skipUpsellPopup = false,
    upgradeVariantId = null,
    upgradeVariantTitle = '',
    noUpgradeVariantId = null,
    noUpgradeVariantTitle = '',
    skipAccessoryBundlePopup = false,
    accessoryBundleUseUpgrade = false,
    accessoryBundleUpgradeVariantId = null
  ) {
    try {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = suavePdpT('adding', 'Adding...');

      if (!skipUpsellPopup) {
        suavePdpUpsellDbg('handleAddToCart: upsell branch entered', { skipUpsellPopup: false });
        const foundationInput = getFoundationInputForUpsell();
        const foundationType =
          getEffectiveFoundationTypeForUpsell(foundationInput) || selectedFoundationType || '';
        const foundationTypeTrim = String(foundationType || '').trim();
        if (!foundationInput) {
          suavePdpUpsellDbg('upsell skipped: no foundation input (no :checked / .selected / container)', {
            hasContainer: !!document.getElementById('foundation-options-container')
          });
        } else if (!foundationTypeTrim) {
          suavePdpUpsellDbg('upsell skipped: foundation input has no data-foundation-type', {
            value: foundationInput.value,
            outerHTML: foundationInput.outerHTML && foundationInput.outerHTML.slice(0, 200)
          });
        } else {
          const adjustableConfigEl = upsellPopupGetEl('upsell-popup', 'config');
          const adjustableOverlay = upsellPopupGetEl('upsell-popup', 'overlay');
          suavePdpUpsellDbg('DOM: adjustable upsell', {
            hasConfigScript: !!adjustableConfigEl,
            hasOverlay: !!adjustableOverlay
          });
          if (!adjustableConfigEl || !adjustableOverlay) {
            suavePdpUpsellDbg('Adjustable upsell block not in DOM (no upsell_popup block or upgrade_product empty in theme)');
          }
          if (adjustableConfigEl && adjustableOverlay) {
            let adjConfig;
            try {
              adjConfig = JSON.parse(adjustableConfigEl.textContent);
            } catch (e) {
              suavePdpUpsellDbg('adjustable config JSON parse error', e);
            }
            suavePdpUpsellDbg('adjustable config', {
              upgradeHandle: adjConfig && adjConfig.upgradeProductHandle,
              foundationTrigger: adjConfig && adjConfig.foundationTrigger
            });
            if (adjConfig && adjConfig.upgradeProductHandle) {
              if (foundationTriggerMatches(adjConfig, foundationTypeTrim)) {
                pendingUpsellBuyNow = buyNow;
                suavePdpUpsellDbg('showing adjustable upsell popup');
                const shown = await showFoundationUpsellPopup(buyNow, 'upsell-popup');
                suavePdpUpsellDbg('adjustable showFoundationUpsellPopup returned', { shown: shown });
                if (!shown) {
                  suavePdpUpsellDbgAlert('Adjustable trigger matched but popup did not show (fetch error or no variant?). Check console.');
                }
                if (shown) return;
              } else {
                suavePdpUpsellDbg('adjustable trigger did not match', {
                  selectedType: foundationTypeTrim,
                  configTrigger: adjConfig.foundationTrigger
                });
              }
            }
          }
          const breezeConfigEl = upsellPopupGetEl('breeze-upsell-popup', 'config');
          const breezeOverlay = upsellPopupGetEl('breeze-upsell-popup', 'overlay');
          suavePdpUpsellDbg('DOM: breeze/Base upsell', {
            hasConfigScript: !!breezeConfigEl,
            hasOverlay: !!breezeOverlay
          });
          if (!breezeConfigEl || !breezeOverlay) {
            suavePdpUpsellDbg('Breeze upsell block not in DOM (no breeze_upsell_popup block or upgrade_product empty)');
          }
          if (breezeConfigEl && breezeOverlay) {
            let breezeConfig;
            try {
              breezeConfig = JSON.parse(breezeConfigEl.textContent);
            } catch (e) {
              suavePdpUpsellDbg('breeze config JSON parse error', e);
            }
            suavePdpUpsellDbg('breeze config', {
              upgradeHandle: breezeConfig && breezeConfig.upgradeProductHandle,
              foundationTrigger: breezeConfig && breezeConfig.foundationTrigger
            });
            if (breezeConfig && breezeConfig.upgradeProductHandle && foundationTriggerMatches(breezeConfig, foundationTypeTrim)) {
              pendingUpsellBuyNow = buyNow;
              suavePdpUpsellDbg('showing breeze/Base upsell popup');
              const shown = await showFoundationUpsellPopup(buyNow, 'breeze-upsell-popup');
              suavePdpUpsellDbg('breeze showFoundationUpsellPopup returned', { shown: shown });
              if (!shown) {
                suavePdpUpsellDbgAlert('Base/Breeze trigger matched but popup did not show. Check console for fetch/variant errors.');
              }
              if (shown) return;
            } else if (breezeConfig && breezeConfig.upgradeProductHandle) {
              suavePdpUpsellDbg('breeze trigger did not match selected foundation type', {
                selectedType: foundationTypeTrim,
                configTrigger: breezeConfig.foundationTrigger
              });
              suavePdpUpsellDbgAlert(
                'Trigger match fail: selected type "' + foundationTypeTrim + '" vs theme trigger "' + (breezeConfig.foundationTrigger || '') + '"'
              );
            }
          }
        }
      } else {
        suavePdpUpsellDbg('handleAddToCart: skipUpsellPopup true (after upsell confirm/continue chain)');
      }

      /* Accessory bundle popup runs only after adjustable + breeze (Base) upsell checks above (when not skipUpsellPopup). */
      if (!skipAccessoryBundlePopup) {
        await clearAccessoryBundleSessionStorageIfCartEmpty();
        const abConfigEl = document.getElementById('accessory-bundle-upsell-popup-config');
        const abOverlay = document.getElementById('accessory-bundle-upsell-popup-overlay');
        const foundationInputAb = getFoundationInputForUpsell();
        const foundationTypeAb =
          getEffectiveFoundationTypeForUpsell(foundationInputAb) || selectedFoundationType || '';
        const hasAccessoryRows = document.querySelectorAll('.accessory-item[data-accessory-product]').length > 0;
        if (abConfigEl && abOverlay && hasAccessoryRows) {
          let abCfg;
          try {
            abCfg = JSON.parse(abConfigEl.textContent);
          } catch (e) {}
          if (abCfg && abCfg.upgradeProductHandle && accessoryBundleFoundationMatches(abCfg, foundationTypeAb)) {
            const rememberAb = abCfg.rememberChoice !== false;
            const storageKeyAb = rememberAb ? getAccessoryBundleStorageKey(abCfg) : null;
            const storedAb = readStoredAccessoryBundleChoice(storageKeyAb);
            if (storedAb && storedAb.mode === 'upgrade') {
              const rememberedBundleVid =
                storedAb.variantId != null && String(storedAb.variantId).trim() !== ''
                  ? String(storedAb.variantId).trim()
                  : null;
              await handleAddToCart(
                buyNow,
                true,
                upgradeVariantId || null,
                upgradeVariantTitle || '',
                noUpgradeVariantId || null,
                noUpgradeVariantTitle || '',
                true,
                true,
                rememberedBundleVid
              );
              return;
            }
            if (storedAb && storedAb.mode === 'decline') {
              /* fall through — add default accessories, no popup */
            } else {
              pendingAccessoryChain = {
                buyNow: buyNow,
                upgradeVariantId: upgradeVariantId || null,
                upgradeVariantTitle: upgradeVariantTitle || '',
                noUpgradeVariantId: noUpgradeVariantId || null,
                noUpgradeVariantTitle: noUpgradeVariantTitle || ''
              };
              pendingUpsellBuyNow = buyNow;
              const shownAb = await showAccessoryBundleUpsellPopup();
              if (shownAb) return;
            }
          }
        }
      }

      const mattressSizeForCart =
        getCurrentMattressSizeValueFromUI() || getCurrentMattressSizeValue();

      syncMattressModelFromUnderbedSelection();

      if (currentMattressProduct && currentMattressProduct.handle) {
        try {
          const mattressRes = await fetch(suavePdpProductJsonUrl(currentMattressProduct.handle));
          if (mattressRes.ok) {
            currentMattressProduct = await mattressRes.json();
          }
        } catch (e) {}
      }

      const items = [];
      const bundleGroupId = 'scbg-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
      const mattressVariantForCart = findMattressVariantForAddToCart(mattressSizeForCart);
      const resolvedModelLabel = getMattressModelLabelForCart();
      const mattressVariantIdForCart = mattressVariantForCart && mattressVariantForCart.id
        ? parseInt(mattressVariantForCart.id, 10)
        : null;

      if (mattressVariantForCart) {
        if (!isMattressVariantSellable(mattressVariantForCart)) {
          throw new Error('Selected mattress variant is out of stock');
        }

        const { firmnessIndex, sizeIndex } = detectOptionTypes(currentMattressProduct);
        let sizeValue = 'Standard';
        let firmnessValue = 'Standard';

        if (mattressVariantForCart.options) {
          if (mattressVariantForCart.options[sizeIndex] !== undefined) {
            sizeValue = mattressVariantForCart.options[sizeIndex];
          }
          if (mattressVariantForCart.options[firmnessIndex] !== undefined) {
            firmnessValue = mattressVariantForCart.options[firmnessIndex];
          }
        }
        
        // Add properties to cart for detailed display
        const properties = {};
        
        // Add Foundation Type if foundation is selected - show in main product details (or upgrade title when confirming upsell)
        if (upgradeVariantId && upgradeVariantTitle) {
          properties['Foundation Type'] = upgradeVariantTitle;
        } else if (currentFoundationVariant && currentFoundationVariant.title) {
          properties['Foundation Type'] = currentFoundationVariant.title;
        } else {
          const underbedInputProp = getSelectedUnderbedInput();
          if (underbedInputProp && !isUnderbedNoFoundationInput(underbedInputProp)) {
            const underbedTitle = underbedInputProp.getAttribute('data-foundation-type') || '';
            if (underbedTitle) properties['Foundation Type'] = underbedTitle;
          } else {
            const foundationInputProp = document.querySelector('input[name="foundation"]:checked');
            if (foundationInputProp) {
              const foundationVariantTitle = foundationInputProp.getAttribute('data-variant-title') || '';
              if (foundationVariantTitle) {
                properties['Foundation Type'] = foundationVariantTitle;
              }
            } else if (selectedModelValue) {
              properties['Foundation Type'] = selectedModelValue;
            }
          }
        }

        const foundationInputForCart = getFoundationInputForUpsell();
        const foundationTypeForCart = getEffectiveFoundationTypeForUpsell(foundationInputForCart);
        if (foundationTypeForCart) {
          properties['_foundation_type'] = foundationTypeForCart;
        }

        let willIncludeAccessoryBundle = false;
        if (!accessoryBundleUseUpgrade) {
          const accItemsCheck = document.querySelectorAll('.accessory-item[data-accessory-product]');
          for (let abi = 0; abi < accItemsCheck.length; abi++) {
            const accItem = accItemsCheck[abi];
            const ph = accItem.getAttribute('data-accessory-product');
            const vid = resolveAccessoryVariantIdForItem(accItem);
            if (ph && ph !== '' && ph !== 'null' && vid) {
              willIncludeAccessoryBundle = true;
              break;
            }
          }
        }
        if (willIncludeAccessoryBundle) {
          properties['_accessory_bundle_included'] = '1';
        }

        properties['_bundle_group_id'] = bundleGroupId;
        properties['_bundle_role'] = 'parent';
        if (resolvedModelLabel && resolvedModelLabel !== suavePdpNoFoundationLabel() && resolvedModelLabel !== 'No Foundation') {
          properties['_model_label'] = resolvedModelLabel;
        }
        properties['_mattress_size'] = sizeValue;
        if (accessoryBundleUseUpgrade) {
          properties['_accessory_upgraded'] = '1';
        }
        
        items.push({
          id: mattressVariantIdForCart,
          quantity: 1,
          properties: properties
        });
      } else {
        throw new Error('No size selected');
      }

      // Add foundation to cart if selected (even if price is $0) — skip when adding upgrade variant instead
      let foundationInput = document.querySelector('input[name="foundation"]:checked');
      // Fallback: on first load user may add to cart before changing anything; ensure we use foundation from container
      if (!foundationInput) {
        const foundationContainer = document.getElementById('foundation-options-container');
        if (foundationContainer) {
          foundationInput = foundationContainer.querySelector('input[name="foundation"]:checked') ||
            foundationContainer.querySelector('.foundation-option.selected input[name="foundation"]') ||
            foundationContainer.querySelector('.foundation-option:not(.out-of-stock) input[name="foundation"]:not([disabled])') ||
            foundationContainer.querySelector('input[name="foundation"]');
          // Sync UI so visible selection matches what we add to cart
          if (foundationInput) {
            foundationInput.checked = true;
            const optionEl = foundationInput.closest('.foundation-option');
            if (optionEl) {
              foundationContainer.querySelectorAll('.foundation-option').forEach(function (o) {
                o.classList.remove('selected');
                const t = o.querySelector('.foundation-title');
                const p = o.querySelector('.foundation-price');
                if (t) t.classList.remove('pdp-text-color');
                if (p) p.classList.remove('pdp-text-color');
              });
              optionEl.classList.add('selected');
              const st = optionEl.querySelector('.foundation-title');
              const sp = optionEl.querySelector('.foundation-price');
              if (st) st.classList.add('pdp-text-color');
              if (sp) sp.classList.add('pdp-text-color');
              var activeTabForCartFoundation = document.querySelector('#custom-product-container .tab.active');
              applyFoundationOptionTabColor(
                activeTabForCartFoundation ? activeTabForCartFoundation.getAttribute('data-tab-color') : ''
              );
            }
          }
        }
      }
      if (upgradeVariantId) {
        const upgradeFoundationProperties = { _bundle_group_id: bundleGroupId };
        const upgradeLine = {
          id: parseInt(upgradeVariantId, 10),
          quantity: 1,
          properties: upgradeFoundationProperties
        };
        if (mattressVariantIdForCart) upgradeLine.parent_id = mattressVariantIdForCart;
        items.push(upgradeLine);
      } else if (noUpgradeVariantId) {
        const noUpgradeProperties = { _bundle_group_id: bundleGroupId };
        if (noUpgradeVariantTitle) noUpgradeProperties['Variant'] = noUpgradeVariantTitle;
        const noUpgradeLine = {
          id: parseInt(noUpgradeVariantId, 10),
          quantity: 1,
          properties: noUpgradeProperties
        };
        if (mattressVariantIdForCart) noUpgradeLine.parent_id = mattressVariantIdForCart;
        items.push(noUpgradeLine);
      } else {
        const underbedInputForCart = getSelectedUnderbedInput();
        if (underbedInputForCart && !isUnderbedNoFoundationInput(underbedInputForCart)) {
          const underbedVariantId = underbedInputForCart.getAttribute('data-underbed-variant-id');
          if (!underbedVariantId) {
            throw new Error('Selected base is not available for this size');
          }
          const underbedProperties = { _bundle_group_id: bundleGroupId, _bundle_role: 'child' };
          const underbedLine = {
            id: parseInt(underbedVariantId, 10),
            quantity: 1,
            properties: underbedProperties
          };
          if (mattressVariantIdForCart) underbedLine.parent_id = mattressVariantIdForCart;
          items.push(underbedLine);
        } else if (foundationInput && foundationInput.name === 'foundation' && foundationInput.value) {
          // data-variant-price may be formatted (e.g. "$79.00") so strip non-numeric chars first.
          const foundationPriceAttr = foundationInput.getAttribute('data-variant-price');
          let foundationPrice = parseFloat(String(foundationPriceAttr || '0').replace(/[^0-9.]/g, '')) || 0;
          if ((!foundationPriceAttr || String(foundationPriceAttr).trim() === '') && foundationInput.closest) {
            const optionEl = foundationInput.closest('.foundation-option') || foundationInput.closest('[class*="foundation-option"]');
            const priceEl = optionEl ? optionEl.querySelector('.foundation-price') : null;
            if (priceEl) {
              const priceText = (priceEl.textContent || '').trim();
              foundationPrice = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
            }
          }
          if (foundationPrice > 0) {
            const isAvailable = foundationInput.getAttribute('data-variant-available') === 'true';
            const inventoryPolicy = foundationInput.getAttribute('data-variant-inventory-policy');
            const inventoryQuantity = foundationInput.getAttribute('data-variant-inventory');
            const inventoryManagement = foundationInput.getAttribute('data-variant-inventory-management');

            let isFoundationAvailable = false;
            if (isAvailable === true) {
              isFoundationAvailable = true;
            } else if (inventoryPolicy === 'continue') {
              isFoundationAvailable = true;
            } else if (inventoryQuantity && parseInt(inventoryQuantity, 10) > 0) {
              isFoundationAvailable = true;
            } else if (inventoryManagement === 'null' || inventoryManagement === null) {
              isFoundationAvailable = true;
            }

            if (!isFoundationAvailable) {
              throw new Error('Selected foundation variant is out of stock');
            }

            const foundationProperties = { _bundle_group_id: bundleGroupId };
            const foundationLine = {
              id: parseInt(foundationInput.value, 10),
              quantity: 1,
              properties: foundationProperties
            };
            if (mattressVariantIdForCart) foundationLine.parent_id = mattressVariantIdForCart;
            items.push(foundationLine);
          }
        }
      }
      // Add accessories to cart; resolve variant by main size dropdown (hidden – no separate size selector)
      const accessoryItems = document.querySelectorAll('.accessory-item[data-accessory-product]');
      const accessoryProductsMap = new Map();
      const mainProductName = currentMattressProduct ? currentMattressProduct.title : 'Main Product';
      const currentSizeValue = getCurrentMattressSizeValue();

      let resolvedBundleUpgradeVariantId = accessoryBundleUpgradeVariantId;
      if (accessoryBundleUseUpgrade && !resolvedBundleUpgradeVariantId) {
        const abCfgResolve = getAccessoryBundleUpsellConfig();
        const uh = abCfgResolve && abCfgResolve.upgradeProductHandle;
        if (uh) {
          try {
            const r = await fetch(suavePdpProductJsonUrl(String(uh)));
            if (r.ok) {
              const p = await r.json();
              const vv = getVariantBySize(p, getCurrentMattressSizeValue());
              if (vv && vv.id != null) resolvedBundleUpgradeVariantId = String(vv.id);
            }
          } catch (e) {}
        }
      }

      if (accessoryBundleUseUpgrade && resolvedBundleUpgradeVariantId) {
        const bundleProps = {
          'Linked to': mainProductName,
          _bundle_group_id: bundleGroupId,
          Bundle: 'Upgraded accessory bundle'
        };
        items.push({
          id: parseInt(resolvedBundleUpgradeVariantId, 10),
          quantity: 1,
          properties: bundleProps
        });
      } else if (accessoryBundleUseUpgrade) {
        throw new Error(
          'Could not match the upgraded accessory bundle to your mattress size. Try another size or refresh the page.'
        );
      } else {

      accessoryItems.forEach(accessoryItem => {
        const productHandle = accessoryItem.getAttribute('data-accessory-product');
        const productId = accessoryItem.getAttribute('data-accessory-product-id');
        const variantId = resolveAccessoryVariantIdForItem(accessoryItem);
        const variantTitle = accessoryItem.getAttribute('data-accessory-variant-title') || '';
        const variantOptions = accessoryItem.getAttribute('data-accessory-variant-options') || '';
        
        if (productHandle && productHandle !== '' && productHandle !== 'null' && variantId) {
          if (!accessoryProductsMap.has(productHandle)) {
            accessoryProductsMap.set(productHandle, {
              productId: productId,
              productHandle: productHandle,
              firstVariantId: variantId,
              variantDetails: []
            });
          }
          
          const productData = accessoryProductsMap.get(productHandle);
          productData.firstVariantId = variantId;
          let variantInfo = variantTitle;
          if (variantOptions && variantOptions !== '') {
            variantInfo += ` (${variantOptions})`;
          }
          productData.variantDetails.push(variantInfo);
        }
      });
      
      // Add each accessory product once with variant names only
      accessoryProductsMap.forEach((productData, productHandle) => {
        const accessoryProperties = {};
        
        // Collect variant names: use customizer display title if set, else variant title
        const variantNames = [];
        accessoryItems.forEach(accessoryItem => {
          const itemProductHandle = accessoryItem.getAttribute('data-accessory-product');
          if (itemProductHandle === productHandle) {
            const displayTitle = accessoryItem.getAttribute('data-accessory-display-title') || '';
            const variantTitle = accessoryItem.getAttribute('data-accessory-variant-title') || '';
            const title = (displayTitle && displayTitle.trim()) ? displayTitle.trim() : variantTitle;
            if (title) {
              variantNames.push(title);
            }
          }
        });
        
        // Add variant names as single property
        if (variantNames.length > 0) {
          accessoryProperties['Included Items'] = variantNames.join(', ');
        }
        
        // Add link to main product (like foundation)
        accessoryProperties['Linked to'] = mainProductName;
        accessoryProperties['_bundle_group_id'] = bundleGroupId;
        
        items.push({
          id: parseInt(productData.firstVariantId),
          quantity: 1,
          properties: accessoryProperties
        });
      });

      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add items to cart');
      }

      if (buyNow) {
        window.location.href = '/checkout';
      } else {
        window.location.href = '/cart';
      }

    } catch (err) {
      console.error('Cart add error:', err);
      alert('Error adding item to cart: ' + err.message);
    } finally {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = suavePdpT('addToCart', 'Add to Cart');
    }
  }

  // Helper functions
  function stripHtml(html) {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  function truncateWords(text, wordCount) {
    const words = text.trim().split(/\s+/);
    if (words.length <= wordCount) return text;
    return words.slice(0, wordCount).join(' ') + '...';
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = parseFloat(cents.replace(/[^0-9.]/g, ''));
    }
    
    let amount = cents;
    if (amount > 1000 && amount % 100 === 0) {
      amount = amount / 100;
    }
    
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  /** Format a value that is always in cents (e.g. price difference) as currency. */
  function formatMoneyFromCents(cents) {
    if (cents == null || isNaN(cents)) return '$0';
    const num = typeof cents === 'string' ? parseFloat(cents.replace(/[^0-9.-]/g, '')) : Number(cents);
    const dollars = Math.round(num) / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Math.max(0, dollars));
  }

  // Initialize custom dropdown
  function initCustomDropdown() {
    const nativeSelect = document.getElementById('size-select');
    const customDropdown = document.querySelector('#custom-product-container .custom-dropdown');
    const customSelected = document.querySelector('#custom-product-container .custom-dropdown-selected');
    const customOptions = document.querySelector('#custom-product-container .custom-dropdown-options');
    
    if (!nativeSelect || !customDropdown || !customSelected || !customOptions) {
      console.error('Custom dropdown elements not found');
      return;
    }
    
    const selectedSize = customSelected.querySelector('.selected-size');
    const selectedPrice = customSelected.querySelector('.selected-price');

    function buildCustomOptions() {
      customOptions.innerHTML = '';
      
      if (nativeSelect.options.length === 0) {
        if (selectedSize) selectedSize.textContent = suavePdpT('selectSize', 'Select Size');
        if (selectedPrice) selectedPrice.textContent = '';
        return;
      }
      
      Array.from(nativeSelect.options).forEach((option, index) => {
        const optionDiv = document.createElement('div');
        optionDiv.className = 'custom-dropdown-option';
        optionDiv.dataset.value = option.value;
        optionDiv.dataset.index = index;
        
        const isAvailable = option.dataset.available === 'true';
        const size = option.dataset.size || option.text.split(' - ')[0].trim();
        const price = option.dataset.price || '';
        const availabilityText = option.dataset.availabilityText || '';
        const mapsToFoundation = foundationProductHasMattressSizeForDropdown(currentFoundationProduct, size);
        const effectiveAvailable = isAvailable && mapsToFoundation;

        if (isAvailable) {
          option.disabled = !mapsToFoundation;
        }

        let displaySize = size;
        let displayPrice = price;
        
        if (!isAvailable) {
          optionDiv.classList.add('disabled', 'out-of-stock');
          displayPrice = suavePdpT('outOfStock', 'Out of Stock');
        } else if (!mapsToFoundation) {
          optionDiv.classList.add('disabled', 'out-of-stock');
          displayPrice = '';
        } else if (availabilityText && availabilityText !== suavePdpT('inStock', 'In Stock')) {
          displayPrice = availabilityText;
        }

        const sizeSpan = document.createElement('span');
        sizeSpan.className = 'option-size';
        // Add pipe separator between size and price
        if (effectiveAvailable && displayPrice && displayPrice !== suavePdpT('outOfStock', 'Out of Stock') && displayPrice !== availabilityText) {
          sizeSpan.textContent = `${displaySize} | ${displayPrice}`;
        } else {
          sizeSpan.textContent = displaySize;
        }
        
        const priceSpan = document.createElement('span');
        priceSpan.className = `option-price ${!effectiveAvailable ? 'out-of-stock' : ''}`;
        // Price is now in sizeSpan, so hide priceSpan or show empty
        if (!isAvailable || (availabilityText && availabilityText !== suavePdpT('inStock', 'In Stock'))) {
          priceSpan.textContent = displayPrice;
        } else if (!mapsToFoundation && isAvailable) {
          priceSpan.textContent = '';
        } else {
          priceSpan.textContent = '';
        }

        const rowMain = document.createElement('div');
        rowMain.className = 'custom-dropdown-option-main';
        rowMain.appendChild(sizeSpan);
        if (isAvailable && !mapsToFoundation) {
          const naSpan = document.createElement('span');
          naSpan.className = 'custom-dropdown-na-label';
          naSpan.textContent = suavePdpT('notAvailable', 'Not Available');
          rowMain.appendChild(naSpan);
        }
        optionDiv.appendChild(rowMain);
        optionDiv.appendChild(priceSpan);

        if (effectiveAvailable) {
          optionDiv.addEventListener('click', () => {
            selectOption(index);
          });
        } else {
          optionDiv.style.opacity = '0.5';
          optionDiv.style.cursor = 'not-allowed';
        }

        customOptions.appendChild(optionDiv);
      });

      const selIdx = nativeSelect.selectedIndex;
      const selOpt = nativeSelect.options[selIdx];
      if (selOpt && selOpt.disabled) {
        for (let i = 0; i < nativeSelect.options.length; i++) {
          const o = nativeSelect.options[i];
          if (o.value && !o.disabled) {
            nativeSelect.selectedIndex = i;
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }

      updateSelected();
    }

    function updateSelected() {
      const selectedOption = nativeSelect.options[nativeSelect.selectedIndex];
      if (selectedOption && selectedOption.value) {
        const isAvailable = selectedOption.dataset.available === 'true';
        const size = selectedOption.dataset.size || selectedOption.text.split(' - ')[0].trim();
        const price = selectedOption.dataset.price || '';
        const availabilityText = selectedOption.dataset.availabilityText || '';
        
        // Get variant name from current firmness variant
        let variantName = '';
        if (currentFirmnessVariant && currentMattressProduct) {
          const { firmnessIndex } = detectOptionTypes(currentMattressProduct);
          if (currentFirmnessVariant.options && currentFirmnessVariant.options[firmnessIndex] !== undefined) {
            variantName = currentFirmnessVariant.options[firmnessIndex];
          } else if (currentFirmnessVariant.option1 && firmnessIndex === 0) {
            variantName = currentFirmnessVariant.option1;
          } else if (currentFirmnessVariant.option2 && firmnessIndex === 1) {
            variantName = currentFirmnessVariant.option2;
          } else if (currentFirmnessVariant.option3 && firmnessIndex === 2) {
            variantName = currentFirmnessVariant.option3;
          }
        }
        
        if (selectedSize) {
          // Show size variant name with pipe separator and price
          if (isAvailable && price) {
            selectedSize.textContent = `${size} | ${price}`;
          } else {
            selectedSize.textContent = size;
          }
          selectedSize.classList.toggle('out-of-stock', !isAvailable);
        }
        
        if (selectedPrice) {
          if (!isAvailable) {
            selectedPrice.textContent = suavePdpT('outOfStock', 'Out of Stock');
            selectedPrice.classList.add('out-of-stock');
          } else if (availabilityText && availabilityText !== suavePdpT('inStock', 'In Stock')) {
            selectedPrice.textContent = availabilityText;
            selectedPrice.classList.remove('out-of-stock');
          } else {
            // Price is now shown in selectedSize with pipe, so hide selectedPrice or show empty
            selectedPrice.textContent = '';
            selectedPrice.classList.remove('out-of-stock');
          }
        }
      } else {
        if (selectedSize) {
          selectedSize.textContent = suavePdpT('selectSize', 'Select Size');
          selectedSize.classList.remove('out-of-stock');
        }
        if (selectedPrice) {
          selectedPrice.textContent = '';
          selectedPrice.classList.remove('out-of-stock');
        }
      }
    }

    function closeDropdown() {
      customDropdown.classList.remove('open');
      customOptions.style.position = '';
      customOptions.style.top = '';
      customOptions.style.left = '';
      customOptions.style.right = '';
      customOptions.style.width = '';
      customOptions.style.zIndex = '';
    }

    function selectOption(index) {
      const option = nativeSelect.options[index];
      if (!option || option.disabled) return;
      
      nativeSelect.selectedIndex = index;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      
      updateSelected();
      closeDropdown();
    }

    customSelected.addEventListener('click', (e) => {
      e.stopPropagation();
      customDropdown.classList.toggle('open');
      if (customDropdown.classList.contains('open') && window.matchMedia('(max-width: 768px)').matches) {
        var rect = customSelected.getBoundingClientRect();
        customOptions.style.position = 'fixed';
        customOptions.style.top = rect.bottom + 'px';
        customOptions.style.left = rect.left + 'px';
        customOptions.style.right = 'auto';
        customOptions.style.width = rect.width + 'px';
        customOptions.style.zIndex = '9999';
      } else {
        customOptions.style.position = '';
        customOptions.style.top = '';
        customOptions.style.left = '';
        customOptions.style.right = '';
        customOptions.style.width = '';
        customOptions.style.zIndex = '';
      }
    });

    document.addEventListener('click', (e) => {
      if (!customDropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    nativeSelect.addEventListener('change', updateSelected);

    buildCustomOptions();
    window.rebuildCustomDropdown = buildCustomOptions;
  }

  function normalizePdpCollectionHandle(raw) {
    if (!raw || typeof raw !== 'string') return '';
    const h = raw.trim().toLowerCase();
    const aliases = {
      classico: 'tango',
      moderno: 'flamenco',
      modreno: 'flamenco',
      flamenco: 'flamenco',
      tango: 'tango',
    };
    return aliases[h] || h;
  }

  function getPageProductContext() {
    const root = document.getElementById('custom-product-container');
    const pathHandle = window.location.pathname.replace(/^\/products\//, '').replace(/\/$/, '');
    const handle =
      (root && root.getAttribute('data-page-product-handle')) || pathHandle || '';
    const title = (root && root.getAttribute('data-page-product-title')) || '';
    let collections = [];
    const rawCollections =
      root && root.getAttribute('data-page-product-collections');
    if (rawCollections) {
      collections = rawCollections
        .split(',')
        .map(function (s) {
          return s.trim().toLowerCase();
        })
        .filter(Boolean);
    }
    return { handle: handle.trim(), title: title.trim(), collections: collections };
  }

  function inferMattressLineFromProduct(handle, title) {
    const blob = ((handle || '') + ' ' + (title || '')).toLowerCase();
    if (
      /\b(flamenco|moderno|modreno)\b/.test(blob) ||
      /(^|[-_])(flamenco|moderno|modreno)([-_]|$)/.test(handle.toLowerCase())
    ) {
      return 'flamenco';
    }
    if (
      /\b(tango|classico)\b/.test(blob) ||
      /(^|[-_])(tango|classico)([-_]|$)/.test(handle.toLowerCase())
    ) {
      return 'tango';
    }
    return '';
  }

  function getPdpCollectionHintFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      const keys = ['collection', 'collection_handle', 'line', 'tab'];
      for (let i = 0; i < keys.length; i++) {
        const v = params.get(keys[i]);
        if (v) return normalizePdpCollectionHandle(v);
      }
    } catch (e) {
      /* ignore */
    }
    return '';
  }

  function findMattressTabForProductHandle(handle) {
    if (!handle) return null;
    const allTabs = document.querySelectorAll('#custom-product-container .tab');
    for (let tab of allTabs) {
      const tabHandle = tab.getAttribute('data-tab') || tab.getAttribute('data-product-handle');
      if (tabHandle === handle) return tab;
    }
    for (let tab of allTabs) {
      const products = parseCollectionProductsFromTab(tab);
      if (products.some(function (item) { return item && item.handle === handle; })) {
        return tab;
      }
    }
    return null;
  }

  function findMattressTabForProductCollections(collectionHandles) {
    if (!collectionHandles || !collectionHandles.length) return null;
    const normalized = collectionHandles.map(normalizePdpCollectionHandle);
    const allTabs = document.querySelectorAll('#custom-product-container .tab');
    for (let tab of allTabs) {
      const tabCollection = normalizePdpCollectionHandle(
        tab.getAttribute('data-collection-handle') || ''
      );
      if (tabCollection && normalized.indexOf(tabCollection) !== -1) {
        return tab;
      }
    }
    return null;
  }

  function findMattressTabForPageProduct() {
    const ctx = getPageProductContext();
    let tab = findMattressTabForProductHandle(ctx.handle);
    if (tab) return tab;
    tab = findMattressTabForProductCollections(ctx.collections);
    if (tab) return tab;
    const line = inferMattressLineFromProduct(ctx.handle, ctx.title);
    if (line) {
      tab = findMattressTabForCollectionHandle(line);
      if (tab) return tab;
    }
    const hint = getPdpCollectionHintFromUrl();
    if (hint) return findMattressTabForCollectionHandle(hint);
    return null;
  }

  function activateMattressTabForPageProduct(options) {
    const opts = options || {};
    const ctx = getPageProductContext();
    let activeTab = findMattressTabForPageProduct();
    if (!activeTab) {
      activeTab = document.querySelector('#custom-product-container .tab.active');
      if (!activeTab) {
        activeTab = document.querySelector('#custom-product-container .tab');
      }
    }
    if (!activeTab) return null;

    const productHandleToLoad =
      ctx.handle ||
      activeTab.getAttribute('data-tab') ||
      activeTab.getAttribute('data-product-handle') ||
      '';

    applyMattressTabActiveVisuals(activeTab);
    syncPdpLayersCollectionCopy(activeTab);

    const tabDefaultHandle =
      activeTab.getAttribute('data-tab') || activeTab.getAttribute('data-product-handle');
    if (
      !opts.skipUrlUpdate &&
      tabDefaultHandle &&
      (!ctx.handle || ctx.handle === tabDefaultHandle)
    ) {
      updateProductUrlDisplay(tabDefaultHandle);
    }

    if (opts.loadProduct !== false && productHandleToLoad) {
      loadMattressProductForTab(activeTab, productHandleToLoad).then(function () {
        if (opts.onLoaded) opts.onLoaded();
      });
    }

    return activeTab;
  }

  function findMattressTabForCollectionHandle(collectionHandle) {
    const normalized = normalizePdpCollectionHandle(collectionHandle);
    if (!normalized) return null;
    const allTabs = document.querySelectorAll('#custom-product-container .tab');
    for (let tab of allTabs) {
      const tabCollection = (tab.getAttribute('data-collection-handle') || '').trim().toLowerCase();
      if (tabCollection && normalizePdpCollectionHandle(tabCollection) === normalized) {
        return tab;
      }
      const label = (tab.textContent || '').trim().toLowerCase();
      if (normalized === 'tango' && (label.indexOf('classico') !== -1 || label.indexOf('tango') !== -1)) {
        return tab;
      }
      if (normalized === 'flamenco' && (label.indexOf('moderno') !== -1 || label.indexOf('modreno') !== -1 || label.indexOf('flamenco') !== -1)) {
        return tab;
      }
    }
    return null;
  }

  async function loadMattressProductForTab(activeTab, productHandle) {
    const handle = productHandle || activeTab.getAttribute('data-tab') || activeTab.getAttribute('data-product-handle');
    if (!handle) return;
    try {
      const response = await fetch(suavePdpProductJsonUrl(handle));
      if (!response.ok) {
        console.error('Failed to fetch product:', response.status);
        return;
      }
      const productData = await response.json();
      if (productData.variants && productData.variants.length > 0) {
        await fetchVariantMetafields(productData);
      }
      await updateMattressProduct(productData, activeTab);
      if (document.getElementById('custom-product-container') && document.querySelector('#md-sticky-atc')) {
        updateStickyATC();
        setTimeout(updateStickyATC, 450);
      }
    } catch (error) {
      console.error('Error loading product data:', error);
    }
  }

  const initialMattressTab = findMattressTabForPageProduct();
  if (initialMattressTab) {
    applyMattressTabActiveVisuals(initialMattressTab);
    syncPdpLayersCollectionCopy(initialMattressTab);
    setTimeout(function () {
      activateMattressTabForPageProduct({
        onLoaded: function () {
          setTimeout(function () {
            initCustomDropdown();
            updateTitleLastWordColor();
            updateButtonStates();
            syncPdpLayersCollectionCopy(
              document.querySelector('#custom-product-container .tab.active')
            );
          }, 800);
        },
      });
    }, 100);
  } else {
    if (originalProduct && originalProduct.id) {
      updateMattressProduct(originalProduct);
      setTimeout(() => {
        initCustomDropdown();
        updateTitleLastWordColor();
        updateButtonStates();
      }, 500);
    }
  }

  if (document.querySelector('#md-sticky-atc')) {
    initMobileStickyATC();
    setTimeout(updateStickyATC, 1200);
  }



function initPDPColorHandler() {
  // Find all elements that should change colors
  const bgElements = document.querySelectorAll('.pdp-bg-color, [data-section="pdp-color-change"], .pdp-color-enabled');
  const textElements = document.querySelectorAll('.pdp-text-color, [data-pdp-color="text"]');
  const borderElements = document.querySelectorAll('.pdp-border-color, [data-pdp-color="border"]');
  const mattressTabs = document.querySelectorAll('.mattress-type-tabs .tab');
  
  // If no tabs found, exit
  if (mattressTabs.length === 0) {
    return;
  }
  
  // Function to calculate luminance and determine if color is dark
  function isColorDark(color) {
    // Convert color to RGB
    let r, g, b;
    
    // Handle hex colors
    if (color.startsWith('#')) {
      const hex = color.replace('#', '');
      if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
      } else {
        r = parseInt(hex.substr(0, 2), 16);
        g = parseInt(hex.substr(2, 2), 16);
        b = parseInt(hex.substr(4, 2), 16);
      }
    }
    // Handle rgb/rgba colors
    else if (color.startsWith('rgb')) {
      const matches = color.match(/\d+/g);
      if (matches && matches.length >= 3) {
        r = parseInt(matches[0]);
        g = parseInt(matches[1]);
        b = parseInt(matches[2]);
      }
    }
    // If we couldn't parse, default to light (black text)
    else {
      return false;
    }
    
    // Calculate relative luminance using WCAG formula
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // If luminance is less than 0.5, it's a dark color
    return luminance < 0.5;
  }
  
  // Function to update colors
  function updatePDPColor(tabElement) {
    applyMattressTabActiveVisuals(tabElement);

    // Get the color from the clicked tab
    let color = tabElement.getAttribute('data-tab-color');
    
    // Clean and validate color
    if (color) {
      color = color.trim();
      const isValidColor = color && color !== '' && color !== 'null' && color !== '#';
      
      if (isValidColor) {
        // Determine if the background is dark
        const isDark = isColorDark(color);
        const textColor = isDark ? '#ffffff' : '#000000';
        
        // Apply background color AND auto text color to pdp-color-enabled elements
        document.querySelectorAll('.pdp-bg-color, [data-section="pdp-color-change"], .pdp-color-enabled').forEach(element => {
          // Check if element has a gradient background
          const currentBg = window.getComputedStyle(element).backgroundImage;
          
          if (currentBg && currentBg !== 'none' && currentBg.includes('gradient')) {
            // Element has a gradient, preserve it but change the base color
            if (!element.dataset.originalGradient) {
              element.dataset.originalGradient = currentBg;
            }
            element.style.background = `linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), ${color}`;
          } else {
            // No gradient, just apply solid color
            element.style.backgroundColor = color;
          }
          
          element.style.setProperty('--pdp-bg-color', color);
          
          // AUTO-APPLY TEXT COLOR to all text within pdp-color-enabled elements
          element.style.color = textColor;
          element.style.setProperty('--pdp-text-color', textColor);
          
          // Also apply to all child text elements
          const allTextElements = element.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, a, li, td, th, div');
          allTextElements.forEach(textEl => {
            // Only apply if the element doesn't have an explicit color override
            const computedColor = window.getComputedStyle(textEl).color;
            const hasInlineColor = textEl.style.color && textEl.style.color !== '';
            
            if (!hasInlineColor) {
              textEl.style.color = textColor;
            }
          });
          
          // Apply to SVG elements (fill and stroke)
          const allSvgElements = element.querySelectorAll('svg, svg path, svg circle, svg rect, svg polygon, svg line, svg polyline, svg ellipse');
          allSvgElements.forEach(svgEl => {
            // Only apply if the element doesn't have an explicit fill/stroke override
            const hasInlineFill = svgEl.style.fill && svgEl.style.fill !== '' && svgEl.style.fill !== 'none';
            const hasInlineStroke = svgEl.style.stroke && svgEl.style.stroke !== '' && svgEl.style.stroke !== 'none';
            const currentFill = svgEl.getAttribute('fill');
            const currentStroke = svgEl.getAttribute('stroke');
            
            // Apply fill color if element has fill (not 'none')
            if (!hasInlineFill && currentFill !== 'none') {
              svgEl.style.fill = textColor;
            }
            
            // Apply stroke color if element has stroke (not 'none')
            if (!hasInlineStroke && currentStroke && currentStroke !== 'none') {
              svgEl.style.stroke = textColor;
            }
          });
        });
        
        // Apply text color to explicit text color elements (.pdp-text-color)
        let pdpTextColor = color; // Tab color for title etc.
        const tabIndex = Array.from(document.querySelectorAll('.mattress-type-tabs .tab')).indexOf(tabElement);
        
        document.querySelectorAll('.pdp-text-color, [data-pdp-color="text"]').forEach(element => {
          if (element.closest('.foundation-option')) return;
          // Check if this is the last word of the title
          if (element.classList.contains('title-last-word')) {
            // Apply the determined text color directly to the last word
            element.style.color = pdpTextColor;
            element.style.setProperty('--pdp-text-color', pdpTextColor);
          } else {
            // For other text color elements, apply the determined color
            element.style.color = pdpTextColor;
            element.style.setProperty('--pdp-text-color', pdpTextColor);
          }
        });
        
        // Apply border color
        document.querySelectorAll('.pdp-border-color, [data-pdp-color="border"]').forEach(element => {
          element.style.borderColor = color;
          element.style.setProperty('--pdp-border-color', color);
        });

        applyPdpSelectionTabColors(color);

        // Preserve progress bar width from metafield (data-customizer-progress) after color apply
        document.querySelectorAll('.performance-blocks__progress-fill[data-customizer-progress]').forEach(function(el) {
          const w = el.getAttribute('data-customizer-progress');
          if (w) {
            el.style.animation = 'none';
            el.style.setProperty('--progress-width', w, 'important');
            el.style.setProperty('width', w, 'important');
          }
        });

      } else {
        clearAllColors();
      }
    } else {
      clearAllColors();
    }
  }
  
  // Function to clear all applied colors
  function clearAllColors() {
    document.querySelectorAll('.pdp-bg-color, [data-section="pdp-color-change"], .pdp-color-enabled').forEach(element => {
      element.style.backgroundColor = '';
      element.style.background = '';
      element.style.color = '';
      element.style.removeProperty('--pdp-bg-color');
      element.style.removeProperty('--pdp-text-color');
      
      // Clear child text elements
      const allTextElements = element.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, a, li, td, th, div');
      allTextElements.forEach(textEl => {
        textEl.style.color = '';
      });
      
      // Clear SVG elements
      const allSvgElements = element.querySelectorAll('svg, svg path, svg circle, svg rect, svg polygon, svg line, svg polyline, svg ellipse');
      allSvgElements.forEach(svgEl => {
        svgEl.style.fill = '';
        svgEl.style.stroke = '';
      });
    });
    
    document.querySelectorAll('.pdp-text-color, [data-pdp-color="text"]').forEach(element => {
      element.style.color = '';
      element.style.removeProperty('--pdp-text-color');
    });
    
    document.querySelectorAll('.pdp-border-color, [data-pdp-color="border"]').forEach(element => {
      element.style.borderColor = '';
      element.style.removeProperty('--pdp-border-color');
    });
  }
  
  // Add click events to tabs
  mattressTabs.forEach(tab => {
    // Remove existing listeners to avoid duplicates
    tab.removeEventListener('click', tab.clickHandler);
    
    // Create new handler
    tab.clickHandler = function(e) {
      e.preventDefault();
      updatePDPColor(this);
    };
    
    tab.addEventListener('click', tab.clickHandler);
  });
  
  // Set initial color
  const activeTab = document.querySelector('.mattress-type-tabs .tab.active');
  if (activeTab) {
    updatePDPColor(activeTab);
  } else if (mattressTabs.length > 0) {
    const fallbackTab = findMattressTabForPageProduct() || mattressTabs[0];
    updatePDPColor(fallbackTab);
  }
  
  mattressTabs.forEach((tab, index) => {
    const color = tab.getAttribute('data-tab-color');
    const hasColor = color && color.trim() && color.trim() !== 'null';
  });
}

// Initialize - with multiple attempts for dynamic content
function initializeWithRetry() {
  initPDPColorHandler();
  
  // If no tabs found, try again (for dynamically loaded content)
  const mattressTabs = document.querySelectorAll('.mattress-type-tabs .tab');
  if (mattressTabs.length === 0) {
    setTimeout(initPDPColorHandler, 500);
    setTimeout(initPDPColorHandler, 1000);
  }
}

// Start when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWithRetry);
} else {
  initializeWithRetry();
}

// Re-initialize for dynamic content
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', initializeWithRetry);
  document.addEventListener('shopify:section:unload', initializeWithRetry);
}

// Handle variant changes
document.addEventListener('variant:change', function() {
  setTimeout(initPDPColorHandler, 100);
})
});